/* eslint-disable */
var curdomain = location.hostname;

// var livedomain = [ 'trueyou.workdoneby.us', 'qa.trueyou.global', 'trueyou.global' ];
// var livedomain = [ 'trueyou.workdoneby.us', 'qa.trueyoudna.com', 'trueyou.global' ];
var livedomain = [ 'trueyou.workdoneby.us', 'qa.trueyoudna.com', 'trueyou.global', 'trueyoudna.com' ];
if (livedomain.indexOf(curdomain) == 0) {	// staging
	var apipath 	= 'https://trueyou-admin.workdoneby.us/api/1.0/';
	var reportpath 	= 'https://trueyou-admin.workdoneby.us/assets/reports_json/';
	var pdfpath 	= 'https://trueyou-report.workdoneby.us/';
	var baseUrl 	= 'https://trueyou.workdoneby.us/';
	var fbID 		= '458776044818034';
	var googleID 	= '141460734830-20q964j49ihor6jrkmbg42712o34ft5v.apps.googleusercontent.com';
} else if (livedomain.indexOf(curdomain) == 1) {	// qa
	var apipath 	= 'https://app-qa.trueyoudna.com/api/1.0/';
	var reportpath 	= 'https://app-qa.trueyoudna.com/assets/reports_json/';
	var pdfpath 	= 'https://qa-report.trueyoudna.com/';
	var baseUrl 	= 'https://qa.trueyoudna.com/';
	var fbID 		= '472255350347841';
	var googleID 	= '228626608403-bpinevgpqidku3gi1pjnp52hdge33nek.apps.googleusercontent.com';
	window.console.log = function () {}; 
} else if (livedomain.indexOf(curdomain) == 2) {	//live
	var apipath 	= 'https://app.trueyou.global/api/1.0/';
	var reportpath 	= 'https://app.trueyou.global/assets/reports_json/';
	var pdfpath 	= 'https://report.trueyou.global/';
	var baseUrl 	= 'https://trueyou.global/';
	var fbID 		= '458776044818034';
	var googleID 	= '687225442291-8mgon9jdi1fqkg89jgs8g6a3tf2d9kie.apps.googleusercontent.com';
	window.console.log = function () {}; 
} else if (livedomain.indexOf(curdomain) == 3) {	//new live
	var apipath 	= 'https://app.trueyoudna.com/api/1.0/';
	var reportpath 	= 'https://app.trueyoudna.com/assets/reports_json/';
	var pdfpath 	= 'https://report.trueyoudna.com/';
	var baseUrl 	= 'https://trueyoudna.com/';
	var fbID 		= '458776044818034';
	var googleID 	= '687225442291-8mgon9jdi1fqkg89jgs8g6a3tf2d9kie.apps.googleusercontent.com';
	window.console.log = function () {}; 
} else {	// localhost
	var apipath 	= 'https://trueyou-admin.workdoneby.us/api/1.0/';
	var reportpath 	= 'https://trueyou-admin.workdoneby.us/assets/reports_json/';
	var pdfpath 	= 'https://trueyou-report.workdoneby.us/';
	var baseUrl 	= 'http://localhost:3000';
	var fbID 		= '458776044818034';
	var googleID 	= '141460734830-20q964j49ihor6jrkmbg42712o34ft5v.apps.googleusercontent.com';
}

var localeObject = {
	en: {
		Malaysian: "Malaysian",
		Male: "Male",
		Female: "Female",
		"Non-Malaysian": "Non-Malaysian",
		Malay: "Malay",
		Chinese: "Chinese",
		Indian: "Indian",
		Bajau: "Bajau",
		Kadazan: "Kadazan",
		Murut: "Murut",
		Melanau: "Melanau",
		"Other Sabah Bumiputeras": "Other Sabah Bumiputeras",
		"Other Sarawak Bumiputeras": "Other Sarawak Bumiputeras",
		Iban: "Iban",
		Bidayuh: "Bidayuh",
		Dusun: "Dusun",
		Kedayan: "Kedayan",
		"Aborigines (Peninsular)": "Aborigines (Peninsular)",
		Bangladeshi: "Bangladeshi",
		Pakistani: "Pakistani",
		"Sri Lankan": "Sri Lankan",
		Indonesian: "Indonesian",
		European: "European",
		Others: "Others",

		//Status tracker
		st_registered_succesfully: "Registered <br> successfully​",
		st_received_lab: "Received <br> by laboratory​",
		st_analysis_in_progress: "Analysis <br> in progress​",
		st_completed: "Completed​",
		st_name: "Name",
		st_pacakge: "Package",
		st_barcode: "Barcode",
		st_activation_code: "Activation Code",
		st_language: "Language",
		st_weight: "Weight (kg)",
		st_height: "Height (cm)",
		st_alcohol_intake: "Alcohol intake",
		st_avg_sleep: "Average sleep (hrs/day)​",
		st_exercise: "Exercise​",
		st_none: "None",
		st_method: "Method​",
		st_address: "Address",
		st_date: "Date",
		st_timeslot: "Timeslot",
		st_dropoff: "Drop off​",
		st_skinproblem: "Skin Problem",
		st_skintype: "Skin Type",
		st_next: "Next",
		st_back: "Back",
		st_dropoff_event: "Drop off",
		st_pickup: "Pick Up",

		//Purchase History
		ph_order: "Order",
		ph_date: "Date",
		ph_quantity: "Quantity",
		ph_delivery_addr: "Delivery Address",
		ph_items: "Items",
		ph_subtotal: "Subtotal",
		ph_shipping: "Shipping",
		ph_promocode: "Promo Code",
		ph_total: "Total",
		ph_price_per_unit: "Price per unit",
		ph_free: "FREE",
		ph_subscription_plan: "Subscription Plan",
		ph_subscription_plan_text1: "24 months",
		ph_subscription_plan_text2: "Please note that your 24-months meal subscription plan will only start on the day you receive your report.",

		//submit testkit
		submit_dropOffEvent: "Drop off",
		submit_info: "Info",
		submit_info_text: "Only available on event location",

		//Register Kit Icon
		registerKit_info: "First time user?",
		registerKit_text: "Please Sign Up or Login with a TrueYou account to continue with your TrueYou DNA kit registration.",

        register_addon: "Register Add On",
        newkit_addon: "Register Your<br>Add On Module",
		submitkit_addon: "Register Your<br>Add On Module",

		submitkit_tq_addon : 'Thank You For Your Add On Module Registration',
		submitkit_tq_type_addon : "You have successfully registered your genetic test kit. Click the 'Home' button below to return to the homepage.",
		submitkit_tq_consultant : 'Thank You For Your Consultation Module Registration',
		submitkit_tq_type_consultant : "You have successfully registered your consultation with us. You may proceed to schedule a session with our consultants below.",

		newsletter_info: "Thank you!",
        newsletter_text: "Thank you for signing up! You will hear from us soon.",

        entity_elkenGlobal: "Elken Global",
        entity_elken: "Elken",
        errorText: "Error"
	},
	ms: {
		Malaysian: "Warganegara",
		"Non-Malaysian": "Bukan Warganegara",
		Male: "Lelaki",
		Female: "Wanita",
		Malay: "Melayu",
		Chinese: "Cina",
		Indian: "India",
		Bajau: "Bajau",
		Kadazan: "Kadazan",
		Murut: "Murut",
		Melanau: "Melanau",
		"Other Sabah Bumiputeras": "Lain-lain Bumiputera Sabah",
		"Other Sarawak Bumiputeras": "Lain-lain Bumiputera Sarawak",
		Iban: "Iban",
		Bidayuh: "Bidayuh",
		Dusun: "Dusun",
		Kedayan: "Kedayan",
		"Aborigines (Peninsular)": "Orang Asli (Semenanjung)",
		Bangladeshi: "Bangladesh",
		Pakistani: "Pakistan",
		"Sri Lankan": "Sri Lanka",
		Indonesian: "Indonesia",
		European: "Eropah",
		others: "Lain-lain",

		//Status tracker
		st_registered_succesfully: "Pendaftaran <br> berjaya",
		st_received_lab: "Diterima <br> oleh makmal",
		st_analysis_in_progress: "Analisis <br> sedang dijalankan",
		st_completed: "Selesai​",
		st_name: "Nama",
		st_pacakge: "Pakej",
		st_barcode: "Kod Bar​",
		st_activation_code: "Kod pengaktifan",
		st_language: "Bahasa",
		st_weight: "Berat (kg)",
		st_height: "Tinggi (cm)",
		st_alcohol_intake: "Pengambilan alkohol​",
		st_avg_sleep: "Purata tidur (jam/hari)​",
		st_exercise: "Senaman​",
		st_none: "Tiada",
		st_method: "Kaedah",
		st_dropoff: "Penghantaran",
		st_address: "Alamat",
		st_date: "Tarikh",
		st_timeslot: "Slot masa",
		st_skinproblem: "Masalah Kulit",
		st_skintype: "Jenis Kulit",
		st_next: "Seterusnya​",
		st_back: "Kembali",
		st_dropoff_event: "Penghantaran",
		st_pickup: "Pungutan",

		//Purchase History
		ph_order: "Pesanan",
		ph_date: "Tarikh",
		ph_quantity: "Kuantiti",
		ph_delivery_addr: "Alamat Penghantaran",
		ph_items: "Item",
		ph_subtotal: "Jumlah",
		ph_shipping: "Bayaran Penghantaran / Kos Kiriman",
		ph_promocode: "Kod Promo",
		ph_total: "Jumlah Keseluruhan",
		ph_price_per_unit: "Harga seunit",
		ph_free: "PERCUMA",
		ph_subscription_plan: "Subscription Plan",
		ph_subscription_plan_text1: "24 months",
		ph_subscription_plan_text2: "Please note that your 24-months meal subscription plan will only start on the day you receive your report.",

		//submit testkit
		submit_dropOffEvent: "Penghantaran",
		submit_info: "Maklumat",
		submit_info_text: "Hanya sedia di lokasi acara",

		//Register Kit Icon
		registerKit_info: "Pengguna kali pertama?",
		registerKit_text: "Sila Daftar atau Log masuk dengan akaun TrueYou untuk meneruskan pendaftaran kit ujian DNA TrueYou anda.",

        register_addon: "Pendaftaran Tambahan",
        newkit_addon: "Daftar Modul Tambahan Anda",
		submitkit_addon: "Daftar Modul Tambahan Anda",

		submitkit_tq_addon : 'Terima Kasih Atas Pendaftaran Modul Tambahan Anda',
		submitkit_tq_type_addon : "Anda telah berjaya mendaftarkan Pakej Tambahan anda. Klik butang 'Laman Utama' di bawah untuk kembali ke laman utama.",
		submitkit_tq_consultant : 'Terima Kasih Atas Pendaftaran Modul Perundingan Anda',
		submitkit_tq_type_consultant : "Anda telah berjaya mendaftarkan perundingan anda dengan kami. Klik butang 'Laman Utama' di bawah untuk kembali ke laman utama.",

		newsletter_info: "Terima kasih!",
        newsletter_text: "Terima kasih atas pendaftaran anda!",

        entity_elkenGlobal: "Elken Global",
        entity_elken: "Elken",
        errorText: "Ralat"
	},
	zh: {
		Malaysian: "马来西亚人​",
		"Non-Malaysian": "非马来西亚人",
		Male: "男",
		Female: "女",
		Malay: "马来人",
		Chinese: "华人",
		Indian: "印度人",
		Bajau: "巴瑶人",
		Kadazan: "卡达山人",
		Murut: "姆鲁人",
		Melanau: "马兰诺人",
		"Other Sabah Bumiputeras": "其他沙巴原住民",
		"Other Sarawak Bumiputeras": "其他砂拉越原住民",
		Iban: "伊班人",
		Bidayuh: "比达友人",
		Dusun: "杜顺人",
		Kedayan: "克达岩人",
		"Aborigines (Peninsular)": "西马原住民",
		Bangladeshi: "孟加拉人",
		Pakistani: "巴基斯坦人",
		"Sri Lankan": "斯里兰卡人",
		Indonesian: "印尼人",
		European: "欧洲人",
		others: "其他",

		//Status tracker
		st_registered_succesfully: "成功注册",
		st_received_lab: "实验室成功接收​",
		st_analysis_in_progress: "分析进行中​",
		st_completed: "完成​",
		st_name: "姓名​",
		st_pacakge: "配套​",
		st_barcode: "条形码​",
		st_activation_code: "激活码",
		st_language: "语言​",
		st_weight: "体重（公斤）​",
		st_height: "身高（公分）",
		st_alcohol_intake: "酒精摄取量​l",
		st_avg_sleep: "平均睡眠（小时/日）​​",
		st_exercise: "运动​",
		st_none: "没有",
		st_method: "方式​",
		st_dropoff: "寄件",
		st_date: "地址",
		st_address: "日期",
		st_timeslot: "时段",
		st_skinproblem: "皮肤问题",
		st_skintype: "皮肤类型",
		st_next: "下一页​",
		st_back: "回到前一页​",
		st_dropoff_event: "寄件",
		st_pickup: "取件",

		//Purchase History
		ph_order: "订购",
		ph_date: "日期",
		ph_quantity: "数量",
		ph_delivery_addr: "送货地址",
		ph_items: "物品",
		ph_subtotal: "小计",
		ph_shipping: "运费",
		ph_promocode: "优惠码",
		ph_total: "总计",
		ph_price_per_unit: "每单位价格",
		ph_free: "免费",
		ph_subscription_plan: "Subscription Plan",
		ph_subscription_plan_text1: "24 months",
		ph_subscription_plan_text2: "Please note that your 24-months meal subscription plan will only start on the day you receive your report.",

		//submit testkit
		submit_dropOffEvent: "寄件",
		submit_info: "信息",
		submit_info_text: "仅在活动地点可用",

		//Register Kit Icon
		registerKit_info: "首次使用？",
		registerKit_text: "请注册或登录TrueYou帐户以继续注册您的TrueYou DNA唾液采集套件。",

        register_addon: "注册附加产品",
        newkit_addon: "注册额外配套",
		submitkit_addon: "注册您的唾液采集套件​",

		submitkit_tq_addon : '谢谢您注册额外配套',
		submitkit_tq_type_addon : "您已成功注册额外配套。欲返回主页，请点击下方的 '首页'。",
		submitkit_tq_consultant : '谢谢您注册咨询配套',
		submitkit_tq_type_consultant : "您已成功注册咨询配套。欲与我们的专家进行预约请点选下方。",

		newsletter_info: "谢谢！",
        newsletter_text: "谢谢注册！您将很快收到我们的回复。",

        entity_elkenGlobal: "爱康环球",
        entity_elken: "爱康",
        errorText: "错误"
	},
};

var iti;

var log_debug = true;

var localization = "en";

var secret = "Bt5mxoILK1";

var validator, validate;
var mobileValidate = false;

var notificationPage = 1;

var originalMobile = "";
var originalEmail = "";

var country = "MY";

var smallLetterCountry = "my";

var redirectPath = "";
var organization_id = 1;

// var sortable;

function loading () {
	$("body").prepend('<div class="loading"><i class="fas fa-spinner"></i></div>');
	$(".loading").css("display", "flex");
}

function removeLoading () {
	$(".loading").css("display", "none");
	$("body .loading").remove();
}

var URLSearchParams = function (param) {
	(this.url = param),
		(this.set = function (param) {
			this.url = param;
		}),
		(this.has = function (name) {
			var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
				window.location.href
			);
			if (results == null) {
				return null;
			} else {
				return decodeURI(results[1]) || 0;
			}
		}),
		(this.get = function (name) {
			var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
				window.location.href
			);
			if (results == null) {
				return null;
			} else {
				return decodeURI(results[1]) || 0;
			}
		});
};

$(document).ready(function () {
	var prevScrollpos = window.pageYOffset;
	window.onscroll = function () {
		var navBarHeight = document.getElementById("nav-bar").offsetHeight;
		var currentScrollPos = window.pageYOffset;
		if (prevScrollpos > currentScrollPos || currentScrollPos < navBarHeight) {
			document.getElementById("nav-bar").style.top = "0";
		} else {
			document.getElementById("nav-bar").style.top = "-80px";
		}
		// Target IE
		setTimeout(function () {
			prevScrollpos = currentScrollPos;
		}, 100);
	};

	//Contact Us form//
	$("select[name=subject]").on("change", function () {
		$(this).css("color", "#0a0a0a");
	});

	$("textarea[name=enquiry]").on("change", function () {
		$(this).css("color", "#0a0a0a");
	});
	//Contact Us form end//

	$(document).foundation();

	var currentUrl = window.location.pathname;
	var url = window.location.href;
	url = url.split("/");

	if (currentUrl != "/shopping-load") {
		smallLetterCountry = url[3];
		country = url[3].toUpperCase();
		localization = url[4];
	} else {
		url = document.referrer;
		url = url.split("/");

		smallLetterCountry = url[3];
		country = url[3].toUpperCase();
		localization = url[4];
	}
	redirectPath = "https://" + url[2] + "/" + smallLetterCountry + "/" + localization;

	// Live Chat Init (exclude Print PDF)
	if ($("main").hasClass("print")) {
	} else {
		function initFreshChat () {
			window.fcWidget.init({
				token: "69fe8091-50d3-49ed-b8e4-947865e9a981",
				host: "https://wchat.freshchat.com",
			});
		}
		(function (d, id) {
			var fcJS;
			if (d.getElementById(id)) {
				initFreshChat();
				return;
			}
			fcJS = d.createElement("script");
			fcJS.id = id;
			fcJS.async = true;
			fcJS.src = "https://wchat.freshchat.com/js/widget.js";
			fcJS.onload = initFreshChat;
			d.head.appendChild(fcJS);
		})(document, "freshchat-js-sdk");
	}

	$(window).scroll(function () {
		var footerHeight = $("footer").innerHeight();
		var scrollPosition = $(window).scrollTop();
		var screenHeight = $(window).height();
		var footerPosition = $(document).height() - screenHeight - footerHeight;

		if ($(window).width() < 767) {
			if (scrollPosition > footerPosition) {
				// $('#fc_frame').css('bottom', footerHeight + 10 + 'px');
				$("#fc_frame").css({
					bottom: footerHeight + 10 + "px",
					position: "absolute",
				});
			} else {
				// $('#fc_frame').css('bottom', '15px');
				$("#fc_frame").css({
					bottom: "15px",
					position: "fixed",
				});
			}
		} else {
			if (scrollPosition > footerPosition) {
				// $('#fc_frame').css('bottom', footerHeight + 10 + 'px');
				$("#fc_frame").css({
					bottom: footerHeight + 10 + "px",
					position: "absolute",
				});
			} else {
				// $('#fc_frame').css('bottom', '15px');
				$("#fc_frame").css({
					bottom: "15px",
					position: "fixed",
				});
			}
		}
	});

	//navigation//
	// desktop
	var url = window.location.href;
	var activePage = url;
	$(".mainNav li a").each(function () {
		var linkPage = this.href;

		if (activePage == linkPage) {
			$(this).closest("li").addClass("active");

			// If nested, apply to all multi level parent
			var linkNestCount = $(this).parents("[role=menuitem]");
			console.log(linkNestCount);
			if (linkNestCount.length > 0) {
				for (var i = 0; i < linkNestCount.length; i++) {
					$(linkNestCount[i]).addClass("active");
				}
			}
		}
	});

	// mobile
	$(".menu-icon").click(function () {
		if ($(".top-bar").css("display") == "none") {
			$(".menu-icon").addClass("changed fas fa-times");
		} else {
			$(".menu-icon").removeClass("changed fas fa-times");
		}
	});
	//navigation end//

	// Landing Page Slider
	$(".homeSlides").slick({
		dots: true,
		arrows: false,
		lazyLoad: "ondemand",
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 2000,
	});

	$("[data-slick]").each(function (index) {
		var slickOption = $(this).attr("data-slick");
		$(this).slick(JSON.parse(slickOption));
	});

	/* $(".addons-slides-package").slick({
		dots: true,
		arrows: true,
		lazyLoad: "ondemand",
		slidesToShow: 3,
		slidesToScroll: 3,
		responsive: [
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	}); */


	$('.product-tabs-tabs').on('change.zf.tabs', function(e) {
		var target = $(e.target).find('.is-active a').attr('href');
		var mh = $(target).find('[data-mh]');
		$(mh).matchHeight();
		var initiated_slick = $(target).find('.addons-slides-package');
		$(initiated_slick).slick('reinit');

	})

	$(".slides-product-parameters").slick({
		dots: true,
		arrows: true,
		lazyLoad: "ondemand",
		slidesToShow: 3,
		slidesToScroll: 3,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});

	// $(".categories-container").on("touchstart", function(e){
	// 	$(this).toggleClass("hover");
	// });

	$(".yes-btn").click(function () {
		var currentIndex = $(".confirm-delete").data("index");
		$(".confirm-delete").fadeOut();
		$("div.sub-profiles").eq(currentIndex).remove();
		reCalculate();
	});

	$(".no-btn").click(function () {
		$(".confirm-delete").fadeOut();
	});

	checkLoginNav();

	$("#sign-out-btn").click(function () {
        deleteCookie("ty_access_token");
        deleteCookie("ty_addon");
        // window.location.href = redirectPath + "/";
        window.location.href = redirectPath;
	});

	// About Page Slider
	$(".aboutSlides").slick({
		dots: true,
		arrows: false,
		lazyLoad: "ondemand",
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 2000,
	});

	// Youtube Load After Thumbnail Clicked
	var youtube = document.querySelectorAll(".youtube-container");

	if (youtube.length) {
		for (var i = 0; i < youtube.length; i++) {
			var thumbnail = new Image();
			thumbnail.id = "youtubeThumbNail_" + i;
			thumbnail.classList.add("lazyload");
			youtube[i].appendChild(thumbnail);

			setTimeout(function () {
				if (thumbnail.classList.contains("lazyloaded")) {
					var idArray = thumbnail.id.split("_");
					var source =
						"https://img.youtube.com/vi/" +
						youtube[idArray[1]].dataset.embed +
						"/sddefault.jpg";
					thumbnail.src = source;
				}
			}, 3000);

			youtube[i].addEventListener("click", function () {
				var iframe = document.createElement("iframe");

				iframe.setAttribute("frameborder", "0");
				iframe.setAttribute("allowfullscreen", "");
				iframe.setAttribute(
					"src",
					"https://www.youtube.com/embed/" +
					this.dataset.embed +
					"?rel=0&showinfo=0&autoplay=1"
				);

				this.innerHTML = "";
				this.appendChild(iframe);
			});
		}

		var youtubeCheked = false;

		$(window).scroll(function (event) {
			if (!youtubeCheked) {
				if (
					thumbnail.classList.contains("lazyloaded") &&
					!thumbnail.hasAttribute("src")
				) {
					var idArray = thumbnail.id.split("_");
					var source =
						"https://img.youtube.com/vi/" +
						youtube[idArray[1]].dataset.embed +
						"/sddefault.jpg";
					thumbnail.src = source;

					youtubeCheked = true;
				} else if (
					thumbnail.hasAttribute("src") &&
					!thumbnail.getAttribute("src") == ""
				) {
					youtubeCheked = true;
				}
			}
		});
	}

	// Sample Report Slider
	$(".sampleReportSlides").slick({
		arrows: true,
		lazyLoad: "ondemand",
		slidesToShow: 3,
		slidesToScroll: 3,
		infinite: false,
		responsive: [
			{
				breakpoint: 1025,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});

	// Newsletter section
	newsletterValidate();
	$("#newsletter-btn").on("click", function () {
		newsletterValidate();
	});
});
// console.log('test-1');
// Accordion Scroll to Title on Expand
/* $(window).on("down.zf.accordion", function (e) {
	console.log(e)
	var containerPos = $(".accordion-item.is-active").offset().top - 50;
	$("html, body").animate({ scrollTop: containerPos }, 300, "easeOutExpo");
}); */
$('.accordion-title').on('click', function(event) {
	$('html,body').animate({scrollTop: $(event.target).offset().top - 50 }, 300, 'easeOutExpo');
});

$(".productBtn").click(function () {
	$(".productBtn").removeClass("active");
	$(".product .product-container").removeClass("show");
	var curEl = $(this);
	curEl.addClass("active");
	$(".product .product-container." + curEl.attr("data-target")).addClass("show");
	$(window).resize();
});

// Product Reveal
$(".product-reveal.revealer[data-orientation!='vertical']").twentytwenty({
	default_offset_pct: 0.5,
});
$(".product-reveal.revealer[data-orientation='vertical']").twentytwenty({
	default_offset_pct: 0.5,
	orientation: "vertical",
});

setTimeout(function () {
	$(window).resize();
}, 1000);

$(".mainNav li, .notification, .profile").click("click", function () {
	$(".off-canvas").foundation("close");

	setTimeout(function () {
		if ($("#profile").hasClass("is-open")) {
			$(".profile").addClass("profile-active");
		}

		if ($("#notification").hasClass("is-open")) {
			$(".notification").addClass("notification-active");
		}
	}, 50);
});

$(".off-canvas").on({
	"closed.zf.offcanvas": function () {
		$(".profile").removeClass("profile-active");
		$(".notification").removeClass("notification-active");
	},
});

// Newsletter
function newsletterValidate () {
	$.validator.addMethod(
		"validemail",
		function (value, element) {
			// allow any non-whitespace characters as the host part
			return (
				this.optional(element) ||
				/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
					value
				)
			);
		},
		"Please enter a valid email."
	);

	$("#newsletterForm").validate({
		debug: true,
		focusInvalid: true,
		rules: {
			newsletter_email: {
				required: true,
				email: true,
				validemail: true,
			},
		},
		errorPlacement: function (error, element) {
			if (element.attr("name") == "newsletter_email") {
				error.insertAfter("#emailNewsletter");
			}
		},
		invalidHandler: function (e, validator) { },
		submitHandler: function (form) {
			loading();

			var url = apipath + "user/newsletter";
			var newsletter_email = $("#newsletter_email").val();
			var data = { newsletter_email: newsletter_email, country: country };

			$.ajax({
				url: url,
				type: "POST",
				headers: { "X-localization": localization },
				data: JSON.stringify(data),
				contentType: "application/json", // tell jQuery not to set contentType
				success: function (data) {
					removeLoading();

					$("#newsletterForm")[0].reset();
					Swal.fire({
						type: "success",
						title: localeObject[localization]["newsletter_info"],
						text: localeObject[localization]["newsletter_text"],
						animation: false,
						customClass: {
							popup: "animated fadeIn",
						},
					}).then(function () {
						// do nothing
					});
				},
				error: function (data) {
					var response = JSON.parse(data.responseText);
					removeLoading();

					Swal.fire({
						type: "error",
						title: localeObject[localization]["errorText"],
						text: response.message,
						animation: false,
						customClass: {
							popup: "animated fadeIn",
						},
					});
				},
				complete: function (data) {
					// console.log(data);
				},
			});
		},
	});

	if (localization == "en") {
		jQuery.extend(jQuery.validator.messages, {
			required: "This field is required.",
			remote: "Please fix this field.",
			email: "Please enter a valid email address.",
			validemail: jQuery.validator.format(
				"Please enter a valid email address."
			),
			url: "Please enter a valid URL.",
			date: "Please enter a valid date.",
			dateISO: "Please enter a valid date (ISO).",
			number: "Please enter a valid number.",
			digits: "Please enter only digits.",
			creditcard: "Please enter a valid credit card number.",
			equalTo: "Please enter the same value again.",
			validpassword: jQuery.validator.format(
				"Please enter at least 8 characters which consists of lowercase letters, uppercase letters and numerals."
			),
			accept: "Please enter a value with a valid extension.",
			maxlength: jQuery.validator.format(
				"Please enter no more than {0} characters."
			),
			minlength: jQuery.validator.format(
				"Please enter at least {0} characters."
			),
			rangelength: jQuery.validator.format(
				"Please enter a value between {0} and {1} characters long."
			),
			range: jQuery.validator.format(
				"Please enter a value between {0} and {1}."
			),
			max: jQuery.validator.format(
				"Please enter a value less than or equal to {0}."
			),
			min: jQuery.validator.format(
				"Please enter a value greater than or equal to {0}."
			),
			CheckDOB: "Please enter valid date format.",
			checkDeliveryDateWeekend: "Please select weekdays only.",
			checkDeliveryDate: "Please select 1 day after today.",
		});
	} else if (localization == "ms") {
		jQuery.extend(jQuery.validator.messages, {
			required: "Ruangan ini wajib diisi.",
			remote: "Sila betulkan ruangan ini.",
			email: "Sila masukkan alamat e-mel yang sah.",
			validemail: jQuery.validator.format(
				"Sila masukkan alamat e-mel yang sah."
			),
			url: "Sila masukkan URL yang sah.",
			date: "Sila masukkan tarikh yang sah.",
			dateISO: "Sila masukkan tarikh yang sah (ISO).",
			number: "Sila masukkan nombor yang sah.",
			digits: "Sila masukkan nombor sahaja.",
			creditcard: "SIla masukkan nombor kad kredit yang sah.",
			equalTo: "Sila masukkan nilai yang sama sekali lagi.",
			validpassword: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya 8 aksara yang terdiri daripada huruf kecil, huruf besar dan angka."
			),
			accept: "Sila masukkan nilai dengan sambungan sah.",
			maxlength: jQuery.validator.format(
				"Sila masukkan tidak melebihi {0} aksara."
			),
			minlength: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya {0} aksara."
			),
			rangelength: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara panjang."
			),
			range: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara."
			),
			max: jQuery.validator.format(
				"Sila masukkan nilai sekurang-kurangnya atau sama dengan {0}."
			),
			min: jQuery.validator.format(
				"Sila masukkan nilai melebihi atau sama dengan {0}."
			),
			CheckDOB: "Sila masukkan format tarikh yang sah.",
			checkDeliveryDateWeekend: "Sila pilih hari bekerja sahaja.",
			checkDeliveryDate: "Sila pilih tarikh selepas hari ini.",
		});
	} else if (localization == "zh") {
		jQuery.extend(jQuery.validator.messages, {
			required: "此为必填项.",
			remote: "请更正此项目.",
			email: "请输入有效的电邮地址.",
			validemail: jQuery.validator.format("请输入有效的电邮地址."),
			url: "请输入有效的网址.",
			date: "请输入有效的日期.",
			dateISO: "请输入有效的日期(ISO).",
			number: "请输入有效的数字.",
			digits: "请只输入号码.",
			creditcard: "请输入有效的信用卡号码.",
			equalTo: "请再次输入一样的字符串.",
			validpassword: jQuery.validator.format(
				"请输入至少8个字符，包括小写字母，大写字母和数字."
			),
			accept: "请输入拥有有效后缀名的字符串.",
			maxlength: jQuery.validator.format("请输入不多于 {0}个的字母."),
			minlength: jQuery.validator.format("请输入至少 {0}个的字数."),
			rangelength: jQuery.validator.format(
				"请输入一个长度介于 {0} 和 {1} 之间的字符串."
			),
			range: jQuery.validator.format("请输入一个介于 {0} 和 {1} 之间的字符串."),
			max: jQuery.validator.format("请输入一个 长度最少是 {0} 的字符串."),
			min: jQuery.validator.format("请输入一个最小为{0} 的字符串."),
			CheckDOB: "请输入有效的日期格式。",
			checkDeliveryDateWeekend: "请仅选择工作日。",
			checkDeliveryDate: "请选择今天之后的日期",
		});
	}
}

//Sign Up
function signUpValidate () {
	$.validator.addMethod(
		"validemail",
		function (value, element) {
			// allow any non-whitespace characters as the host part
			return (
				this.optional(element) ||
				/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
					value
				)
			);
		},
		"Please enter a valid email."
    );

    $.validator.addMethod(
        "mobileformat",
        function (value, element) {
			if(country == 'MY') {
				if( value.length >= 5 && value.length <= 20 && Object.keys(iti.getSelectedCountryData()).length != 0 ) {
					return true;
				} else {
					log('invalid format');
					return false;
				}
			} else {
				if (value.substring(0, 2) == '60') {    // MY
				    log('MY number');
				    return true;
				}else if (value.substring(0, 2) == '65') {  // SG
				    log('SG number');
				    return true;
				}else if (value.substring(0, 3) == '673') {   // BN
				    log('BN number');
				    return true;
				}else{
				    log('wrong number, no prefix');
				    return false;
				}
			}
        },
        "Please enter a valid mobile with country code."
    );

	$.validator.addMethod(
		"validpassword",
		function (value, element) {
			// allow any non-whitespace characters as the host part
			return (
				this.optional(element) ||
				/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(value)
			);
		},
		"Please enter at least 8 characters which consists of lowercase letters, uppercase letters and numerals"
	);

	$.validator.addMethod(
		"CheckDOB",
		function (value, element) {
			// checking whether the date entered is in correct format
			var isValid = value.match(/^\d\d\d\d?\/\d\d?\/\d\d$/);
			if (isValid) {
				var minDate = Date.parse("1919/01/01");
				var today = new Date();
				// today.setFullYear( today.getFullYear() - 18 );
				today.setDate(today.getDate() - 1);
				var DOB = new Date(value);
				if (DOB >= today || DOB <= minDate) {
					isValid = false;
				}
				return isValid;
			}
		},
		"Please enter valid date format."
	);

	$.validator.addMethod(
		"checkSubDOB",
		function (value, element) {
			// checking whether the date entered is in correct format
			var isValid = value.match(/^\d\d\d\d?\/\d\d?\/\d\d$/);
			if (isValid) {
				var minDate = new Date();
				minDate.setFullYear(minDate.getFullYear() - 18);
				var maxDate = new Date();
				var DOB = new Date(value);
				if (DOB < minDate || DOB > maxDate) {
					isValid = false;
				}

				return isValid;
			}
		},
		"Please enter valid date format."
	);

	var rules = new Object();

	rules["name"] = { required: true };
	rules["email"] = { required: true, email: true, validemail: true };
    // rules["mobile"] = { required: true, minlength: 10, maxlength: 11 };
	rules["mobile"] = {
		required: true,
		mobileformat: true,
	};
	if(country != 'MY') {
		rules["mobile"]['minlength'] = function (el) {
			    if ( $("#mobile").val().substring(0, 2) == '60' ) {
			        return 11;
			    }else if ( $("#mobile").val().substring(0, 2) == '65' ) {
			        return 10;
			    }else if ( $("#mobile").val().substring(0, 3) == '673' ) {
			        return 10;
			    }else{
			        return 11;
			    }
		};
		rules["mobile"]['maxlength'] = function (el) {
			    if ( $("#mobile").val().substring(0, 2) == '60' ) {
			        return 12;
			    }else if ( $("#mobile").val().substring(0, 2) == '65' ) {
			        return 10;
			    }else if ( $("#mobile").val().substring(0, 3) == '673' ) {
			        return 10;
			    }else{
			        return 12;
			    }
			};
	}
	rules["OTP"] = { required: true, minlength: 6, maxlength: 6 };
	// rules["race"] = { required: true };
	// rules["other_races"] = {
	// 	required: function (el) {
	// 		if ($("#race-list").val() == "others") return true;
	// 		else return false;
	// 	},
	// };
	rules["gender"] = { required: true };
	rules["password"] = { required: true, validpassword: true };
	rules["confirmPassword"] = {
		required: true,
		validpassword: true,
		equalTo: "#password",
	};
	rules["nationality"] = { required: true };
	rules["passport"] = {
		required: true,
		minlength: function (el) {
			if ($("#Malaysian").is(":checked"))
                if (country == "MY")
                    return 12;
                else
                    return 5;
            else
                return 5;
		},
		maxlength: function (el) {
			if ($("#Malaysian").is(":checked"))
                if (country == "MY")
                    return 12;
                else
                    return 30;
            else
                return 30;
		},
	};
    rules["dob"] = {
        required: true,
        CheckDOB: true,
    };
	rules["agreement"] = { required: true };

	// Guardian Section
	rules["guardian_name"] = { required: true };
	rules["guardian_nric"] = { required: true, minlength: 5, maxlength: 20 };
	rules["guardian_relationship"] = { required: true };
	rules["guardian_agreement"] = { required: true };

	// Children Section
	$("input[name^=subName]").each(function () {
		rules[this.name] = { required: true };
	});

	$("input[name^=subNationality]").each(function () {
		rules[this.name] = { required: true };
	});

	$("input[name^=addGender]").each(function () {
		rules[this.name] = { required: true };
	});

	$("input[name^=subRace]").each(function () {
		rules[this.name] = { required: true };
	});

	$("input[name^=subOtherRaces]").each(function () {
		var id = this.name.replace("subOtherRaces", "");
		if ($("#additional-race-list" + id).val() == "others") {
			rules[this.name] = { required: true };
		} else {
			rules[this.name] = { required: false };
		}
	});

	$("input[name^=subDob]").each(function () {
		rules[this.name] = {
			required: true,
			checkSubDOB: true,
		};
	});

	validate = $("#signUpForm").validate();

	if (typeof validate != "undefined") {
		validate.destroy();
	}

	validator = $("#signUpForm").validate({
		debug: true,
		focusInvalid: true,
		rules: rules,
		errorPlacement: function (error, element) {
			if (element.attr("name") == "agreement") {
				error.insertAfter("#agreement-wrap");
			} else if (element.attr("name") == "guardian_agreement") {
				error.insertAfter("#guardian-wrap");
			} else if (element.attr("name") == "gender") {
				error.insertAfter("#gender-wrap");
			} else if (element.attr("name") == "nationality") {
				error.insertAfter("#nationality-wrap");
			} else if (element.attr("name") == "mobile") {
				error.insertAfter(".mobile-container");
			} else if (element.attr("name") == "OTP") {
				error.insertAfter(".otp-container");
			} else if (element.attr("name").indexOf("addGender") != -1) {
				var id = element.attr("name").replace("addGender", "");
				error.insertAfter("#add-gender-wrap" + id);
			} else if (element.attr("name").indexOf("subNationality") != -1) {
				var id = element.attr("name").replace("subNationality", "");
				error.insertAfter("#additional-nationality-wrap" + id);
			} else {
				error.insertAfter(element);
			}
		},
		invalidHandler: function (e, validator) {
			// for (var i in validator.errorMap) {
			//     console.log(i, ":", validator.errorMap[i]);
			// }
		},
		submitHandler: function (form) {
			loading();

			if (mobileValidate) {
				var full_name = $("#name").val();
				var email = $("#email").val();
				if (country == 'MY') {
					var mobile = iti.getSelectedCountryData().dialCode + $("#mobile").val();
				} else {
					var mobile = $("#mobile").val();
				}
				var password = $("#password").val();
				var confirmPassword = $("#confirmPassword").val();
				var gender = $("#Male").is(":checked") ? 1 : 2;
				var nationality = $("#Malaysian").is(":checked") ? 1 : 0;
				var dob = $(".dob").val();

				// if ($("#race-list").val() == "others")
				// 	var race = $("#other-races").val();
				// else var race = $("#race-list").val();
                var race = '';

				var authorise = $("#subscribe2").is(":checked") ? 1 : 0;
				var newsletter = $("#subscribe3").is(":checked") ? 1 : 0;

				if (nationality == 1) {
					var NRIC = $("#passport").val();

					var data = {
						full_name: full_name,
						password: password,
						confirmation_password: confirmPassword,
						email: email,
						mobile_no: mobile,
						nationality: nationality,
						gender: gender,
						DOB: dob,
						NRIC: NRIC,
						authorise_upline: authorise,
						newsletter_email: newsletter,
						race: race,
					};
				} else {
					var passport = $("#passport").val();

					var data = {
						full_name: full_name,
						password: password,
						confirmation_password: confirmPassword,
						email: email,
						mobile_no: mobile,
						nationality: nationality,
						gender: gender,
						DOB: dob,
						passport_no: passport,
						authorise_upline: authorise,
						newsletter_email: newsletter,
						race: race,
					};
				}

				var guardian_flag = $("#guardian_flag").is(":checked") ? 1 : 0;
				// if (guardian_flag == 1) {
				data.guardian_flag = guardian_flag;
				data.guardian_name = $("#guardian_name").val() === "" ? "" : $("#guardian_name").val();
				data.guardian_nric = $("#guardian_nric").val() === "" ? "" : $("#guardian_nric").val();
				data.guardian_relationship = $("#guardian_relationship").val() === "" ? "" : $("#guardian_relationship").val();
				// }

				data.country = country;
				data.organization_id = organization_id;

				var childrenArray = [];
				for (var i = 0; i < $(".sub-profiles").length; i++) {
					var profileNumber = i + 1;

					var full_name = $("#sub-profile-name" + profileNumber).val();
					var id = $("#sub-profile-bkID" + profileNumber).val();
					var dob = $("#sub-dob" + profileNumber).val();
					var gender = $("#addMale" + profileNumber).is(":checked") ? 1 : 2;
					var nationality = $("#addMalaysian" + profileNumber).is(":checked") ? 1 : 0;

					if (id == "new") {
						var race = $("#additional-race-list" + profileNumber).val();

						if (race == "others") {
							race = $("#additional-other-races" + profileNumber).val();
						}
					} else {
						var race = $("#additional-race-list" + profileNumber).val();
					}

					var childrenAttr = {
						full_name: full_name,
						id: id,
						DOB: dob,
						gender: gender,
						race: race,
						nationality: nationality,
					};

					childrenArray.push(childrenAttr);
				}
				data.children = childrenArray;
				log(data);

				var url = apipath + "user/registration";

				$.ajax({
					url: url,
					type: "POST",
					headers: { "X-localization": localization },
					data: JSON.stringify(data),
					contentType: "application/json", // tell jQuery not to set contentType
					success: function (data) {
						deleteCookie("user_fb_token");
						deleteCookie("user_google_token");
						deleteCookie("user_ielken_cookie");
						deleteCookie("user_classic_cookie");
						deleteCookie("user_email");
						deleteCookie("user_password");

						removeLoading();

						window.location.href = redirectPath + "/sign-up-verification";
					},
					error: function (data) {
						var response = JSON.parse(data.responseText);

						removeLoading();

						if (response.message == "token_expired") {
							promptTokenExpired();
							$(".navLoader").css("display", "none");
						} else {
							Swal.fire({
								type: "error",
								title: localeObject[localization]["errorText"],
								text: response.message,
								animation: false,
								customClass: {
									popup: "animated fadeIn",
								},
							});
						}
						// window.location.href = redirectPath + '/login';
					},
					complete: function (data) {
						// console.log(data);
					},
				});
			} else {
				removeLoading();

				var errorMsg = "";

                if (localization == "en")
                    errorMsg = "Mobile no. not verified";
				else if (localization == "ms")
					errorMsg = "No. telefon belum disahkan";
                else if (localization == "zh")
                    errorMsg = "手机号码没有经过验证";

				Swal.fire({
					type: "error",
					title: localeObject[localization]["errorText"],
					text: errorMsg,
					animation: false,
					customClass: {
						popup: "animated fadeIn",
					},
				});
			}
		},
	});

	if (localization == "en") {
		jQuery.extend(jQuery.validator.messages, {
			required: "This field is required.",
			remote: "Please fix this field.",
			email: "Please enter a valid email address.",
			validemail: jQuery.validator.format(
				"Please enter a valid email address."
			),
			url: "Please enter a valid URL.",
			date: "Please enter a valid date.",
			dateISO: "Please enter a valid date (ISO).",
			number: "Please enter a valid number.",
			digits: "Please enter only digits.",
			creditcard: "Please enter a valid credit card number.",
			equalTo: "Please enter the same value again.",
			validpassword: jQuery.validator.format(
				"Please enter at least 8 characters which consists of lowercase letters, uppercase letters and numerals."
			),
            accept: "Please enter a value with a valid extension.",
            mobileformat: jQuery.validator.format("Please enter a valid mobile."),
			maxlength: jQuery.validator.format(
				"Please enter no more than {0} characters."
			),
			minlength: jQuery.validator.format(
				"Please enter at least {0} characters."
			),
			rangelength: jQuery.validator.format(
				"Please enter a value between {0} and {1} characters long."
			),
			range: jQuery.validator.format(
				"Please enter a value between {0} and {1}."
			),
			max: jQuery.validator.format(
				"Please enter a value less than or equal to {0}."
			),
			min: jQuery.validator.format(
				"Please enter a value greater than or equal to {0}."
			),
			CheckDOB: "Please enter valid date format.",
			checkDeliveryDateWeekend: "Please select weekdays only.",
			checkDeliveryDate: "Please select 1 day after today.",
		});
	} else if (localization == "ms") {
		jQuery.extend(jQuery.validator.messages, {
			required: "Ruangan ini wajib diisi.",
			remote: "Sila betulkan ruangan ini.",
			email: "Sila masukkan alamat e-mel yang sah.",
			validemail: jQuery.validator.format(
				"Sila masukkan alamat e-mel yang sah."
			),
			url: "Sila masukkan URL yang sah.",
			date: "Sila masukkan tarikh yang sah.",
			dateISO: "Sila masukkan tarikh yang sah (ISO).",
			number: "Sila masukkan nombor yang sah.",
			digits: "Sila masukkan nombor sahaja.",
			creditcard: "SIla masukkan nombor kad kredit yang sah.",
			equalTo: "Sila masukkan nilai yang sama sekali lagi.",
			validpassword: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya 8 aksara yang terdiri daripada huruf kecil, huruf besar dan angka."
			),
            accept: "Sila masukkan nilai dengan sambungan sah.",
            mobileformat: jQuery.validator.format("Sila masukkan Telefon bimbit yang sah."),
			maxlength: jQuery.validator.format(
				"Sila masukkan tidak melebihi {0} aksara."
			),
			minlength: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya {0} aksara."
			),
			rangelength: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara panjang."
			),
			range: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara."
			),
			max: jQuery.validator.format(
				"Sila masukkan nilai sekurang-kurangnya atau sama dengan {0}."
			),
			min: jQuery.validator.format(
				"Sila masukkan nilai melebihi atau sama dengan {0}."
			),
			CheckDOB: "Sila masukkan format tarikh yang sah.",
			checkDeliveryDateWeekend: "Sila pilih hari bekerja sahaja.",
			checkDeliveryDate: "Sila pilih tarikh selepas hari ini.",
		});
	} else if (localization == "zh") {
		jQuery.extend(jQuery.validator.messages, {
			required: "此为必填项.",
			remote: "请更正此项目.",
			email: "请输入有效的电邮地址.",
			validemail: jQuery.validator.format("请输入有效的电邮地址."),
			url: "请输入有效的网址.",
			date: "请输入有效的日期.",
			dateISO: "请输入有效的日期(ISO).",
			number: "请输入有效的数字.",
			digits: "请只输入号码.",
			creditcard: "请输入有效的信用卡号码.",
			equalTo: "请再次输入一样的字符串.",
			validpassword: jQuery.validator.format(
				"请输入至少8个字符，包括小写字母，大写字母和数字."
			),
            accept: "请输入拥有有效后缀名的字符串.",
            mobileformat: jQuery.validator.format("请输入有效的手机号码."),
			maxlength: jQuery.validator.format("请输入不多于 {0}个的字母."),
			minlength: jQuery.validator.format("请输入至少 {0}个的字数."),
			rangelength: jQuery.validator.format(
				"请输入一个长度介于 {0} 和 {1} 之间的字符串."
			),
			range: jQuery.validator.format("请输入一个介于 {0} 和 {1} 之间的字符串."),
			max: jQuery.validator.format("请输入一个 长度最少是 {0} 的字符串."),
			min: jQuery.validator.format("请输入一个最小为{0} 的字符串."),
			CheckDOB: "请输入有效的日期格式。",
			checkDeliveryDateWeekend: "请仅选择工作日。",
			checkDeliveryDate: "请选择今天之后的日期",
		});
	}
}

$("#mobile").bind("change", function () {
	if (originalMobile != $("#mobile").val()) {
		$(".verifyMobile").css("display", "block");
	} else {
		$(".verifyMobile, .otp-message, .mobile-otp, .otp-container, .otp-failed").css("display", "none");
	}
});

// MOBILE INTERNATIONAL TEL INPUT
$(document).ready(function () {
	if(country == 'MY') {
		var mobileInput = document.querySelector("#mobile");
		iti = intlTelInput(mobileInput, {
			// initialCountry : 'auto',
			initialCountry : 'my',
			preferredCountries: ['sg', 'my', 'bn', 'kh', 'hk', 'id', 'tw', 'th', 'ph', 'vn'],
			separateDialCode: true,
			// geoIpLookup: function(success, failure) {
			// 	$.get("https://ipinfo.io", function() {}, "jsonp").always(function(resp) {
			// 		var countryCode = (resp && resp.country) ? resp.country : "us";
			// 		success(countryCode);
			// 		iti.setCountry(countryCode);
			// 	});
			// },
		});
		mobileInput.addEventListener("countrychange", function() {
			$(mobileInput).val('');
		});
	} else {
		$("#mobile").on("keyup", function() {
			var value = $(this).val();
			$(this).val($(this).data("initial") + value.substring(1));
		});
	}
});

//MOBILE VERIFY
var otpDisable = 300; // 180; // 3minutes
var otpDisableTemp = otpDisable;
var otpCounter = document.getElementById("otp-counter");
var optTimerId;

function otpCountdown () {
	console.log(otpDisable);
	if (otpDisable < 0) {
		clearTimeout(optTimerId);
		//enable re-send OTP//
		$(".verifyMobile").css({
			"background-color": "#53d54b",
			cursor: "pointer",
		});
		$(".verifyMobile").bind("click", assignEventToVerifyMobile);
		$(".otp-message").css("display", "none");
		// otpCounter.innerHTML = '180';
		otpCounter.innerHTML = otpDisable;
	} else {
		otpCounter.innerHTML = otpDisable;
		otpDisable--;
	}
}

function assignEventToVerifyMobile () {
	if (validator.element("#mobile")) {
		otpDisable = otpDisableTemp;
		$(".verifyMobile").unbind("click", assignEventToVerifyMobile);
		$(".verifyMobile").css({
			"background-color": "#e6e6e6",
			cursor: "no-drop",
		});
		$(".otp-message").css("display", "block");
		$(".mobile-otp, .otp-container").css("display", "flex");
		optTimerId = setInterval(otpCountdown, 1000);

		var url = apipath + "send-otp";

		if(country == 'MY') {
			var data = { mobile_no: iti.getSelectedCountryData().dialCode + $("#mobile").val() };
		} else {
			var data = { mobile_no: $("#mobile").val() };
		}

		$.ajax({
			url: url,
			type: "POST",
			data: JSON.stringify(data),
			contentType: "application/json", // tell jQuery not to set contentType
			success: function (data) {
				log(data);
			},
			error: function (data) {
				log(data);
			},
			complete: function (data) {
				// console.log(data);
			},
		});
	}
}

//click OTP show verify column ends//
function verifyOTP () {
	if (validator.element("#OTP")) {
		var url = apipath + "verify-otp";

		if(country == 'MY') {
			var data = { mobile_no: iti.getSelectedCountryData().dialCode + $("#mobile").val(), mobile_otp: $("#OTP").val() };
		} else {
			var data = { mobile_no: $("#mobile").val(), mobile_otp: $("#OTP").val() };
		}

		$.ajax({
			url: url,
			type: "POST",
			data: JSON.stringify(data),
			contentType: "application/json", // tell jQuery not to set contentType
			success: function (data) {
				$(".verifyMobile").html("");
				$(".verifyMobile").addClass("fas fa-check");
				$(".verifyMobile").css({
					"pointer-events": "none",
					"background-color": "#53d54b",
				});
				$(".mobile-otp, .otp-container, .otp-message").css("display", "none");
				$("#mobile").attr("readOnly", "true");
				clearInterval(optTimerId);
				$(".otp-failed").css("display", "none");

				mobileValidate = true;
			},
			error: function (data) {
				$(".otp-failed").css("display", "block");
			},
			complete: function (data) {
				// console.log(data);
			},
		});
	}
}

function checkNumeric(o){
    o.value=o.value.replace(/([^0-9])/g,"");
}

//COMPLETE PROFILE SIGN UP VIA SOCIAL MEDIA
function completeProfileValidate () {
	$.validator.addMethod(
		"validemail",
		function (value, element) {
			// allow any non-whitespace characters as the host part
			return (
				this.optional(element) ||
				/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
					value
				)
			);
		},
		"Please enter a valid email."
	);

    $.validator.addMethod(
		"mobileformat",
		function (value, element) {
			if(country == 'MY') {
				if( value.length >= 5 && value.length <= 20 && Object.keys(iti.getSelectedCountryData()).length != 0 ) {
					return true;
				} else {
					log('invalid format');
					return false;
				}
			} else {
				if (value.substring(0, 2) == '60') {    // MY
				    log('MY number');
				    return true;
				}else if (value.substring(0, 2) == '65') {  // SG
				    log('SG number');
				    return true;
				}else if (value.substring(0, 3) == '673') {   // BN
				    log('BN number');
				    return true;
				}else{
				    log('wrong number, no prefix');
				    return false;
				}
			}
		},
		"Please enter a valid mobile"
    );

	$.validator.addMethod(
		"CheckDOB",
		function (value, element) {
			// checking whether the date entered is in correct format
			var isValid = value.match(/^\d\d\d\d?\/\d\d?\/\d\d$/);
			if (isValid) {
				var minDate = Date.parse("1919/01/01");
				var today = new Date();
				// today.setFullYear( today.getFullYear() - 18 );
				today.setDate(today.getDate() - 1);
				var DOB = new Date(value);
				if (DOB >= today || DOB <= minDate) {
					isValid = false;
				}
				return isValid;
			}
		},
		"Please enter valid date format."
	);

	$.validator.addMethod(
		"checkSubDOB",
		function (value, element) {
			// checking whether the date entered is in correct format
			var isValid = value.match(/^\d\d\d\d?\/\d\d?\/\d\d$/);
			if (isValid) {
				var minDate = new Date();
				minDate.setFullYear(minDate.getFullYear() - 18);
				var maxDate = new Date();
				var DOB = new Date(value);
				if (DOB < minDate || DOB > maxDate) {
					isValid = false;
				}

				return isValid;
			}
		},
		"Please enter valid date format."
	);

	var rules = new Object();

	rules["name"] = { required: true };
	rules["email"] = { required: true, email: true, validemail: true };
    // rules["mobile"] = { required: true, minlength: 10, maxlength: 11 };
    rules["mobile"] = {
        required: true,
        mobileformat: true,
    };
	if(country != 'MY') {
		rules["mobile"]['minlength'] = function (el) {
			    if ( $("#mobile").val().substring(0, 2) == '60' ) {
			        return 11;
			    }else if ( $("#mobile").val().substring(0, 2) == '65' ) {
			        return 10;
			    }else if ( $("#mobile").val().substring(0, 3) == '673' ) {
			        return 10;
			    }else{
			        return 11;
			    }
		};
		rules["mobile"]['maxlength'] = function (el) {
			    if ( $("#mobile").val().substring(0, 2) == '60' ) {
			        return 12;
			    }else if ( $("#mobile").val().substring(0, 2) == '65' ) {
			        return 10;
			    }else if ( $("#mobile").val().substring(0, 3) == '673' ) {
			        return 10;
			    }else{
			        return 12;
			    }
			};
	}
	rules["OTP"] = { required: true, minlength: 6, maxlength: 6 };
	// rules["race"] = { required: true };
	// rules["other_races"] = {
	// 	required: function (el) {
	// 		if ($("#race-list").val() == "others") return true;
	// 		else return false;
	// 	},
	// };
	rules["gender"] = { required: true };
	rules["nationality"] = { required: true };
	rules["passport"] = {
		required: true,
		minlength: function (el) {
			if ($("#Malaysian").is(":checked"))
                if (country == "MY")
                    return 12;
                else
                    return 5;
            else
                return 5;
		},
		maxlength: function (el) {
			if ($("#Malaysian").is(":checked"))
                if (country == "MY")
                    return 12;
                else
                    return 30;
            else
                return 30;
		},
	};
    rules["dob"] = {
        required: true,
        CheckDOB: true,
    };
	rules["agreement"] = { required: true };

	// Guardian Section
	rules["guardian_name"] = { required: true };
	rules["guardian_nric"] = { required: true, minlength: 5, maxlength: 20 };
	rules["guardian_relationship"] = { required: true };
	rules["guardian_agreement"] = { required: true };

	// Children Section
	$("input[name^=subName]").each(function () {
		rules[this.name] = { required: true };
	});

	$("input[name^=subNationality]").each(function () {
		rules[this.name] = { required: true };
	});

	$("input[name^=addGender]").each(function () {
		rules[this.name] = { required: true };
	});

	$("input[name^=subRace]").each(function () {
		rules[this.name] = { required: true };
	});

	$("input[name^=subOtherRaces]").each(function () {
		var id = this.name.replace("subOtherRaces", "");
		if ($("#additional-race-list" + id).val() == "others") {
			rules[this.name] = { required: true };
		} else {
			rules[this.name] = { required: false };
		}
	});

	$("input[name^=subDob]").each(function () {
		rules[this.name] = {
			required: true,
			checkSubDOB: true,
		};
	});

	validate = $("#signUpForm").validate();

	if (typeof validate != "undefined") {
		validate.destroy();
	}

	validator = $("#signUpForm").validate({
		debug: true,
		focusInvalid: true,
		rules: rules,
		errorPlacement: function (error, element) {
			if (element.attr("name") == "agreement") {
				error.insertAfter("#agreement-wrap");
			} else if (element.attr("name") == "guardian_agreement") {
				error.insertAfter("#guardian-wrap");
			} else if (element.attr("name") == "gender") {
				error.insertAfter("#gender-wrap");
			} else if (element.attr("name") == "nationality") {
				error.insertAfter("#nationality-wrap");
			} else if (element.attr("name") == "mobile") {
				error.insertAfter(".mobile-container");
			} else if (element.attr("name") == "OTP") {
				error.insertAfter(".otp-container");
			} else if (element.attr("name").indexOf("addGender") != -1) {
				var id = element.attr("name").replace("addGender", "");
				error.insertAfter("#add-gender-wrap" + id);
			} else if (element.attr("name").indexOf("subNationality") != -1) {
				var id = element.attr("name").replace("subNationality", "");
				error.insertAfter("#additional-nationality-wrap" + id);
			} else {
				error.insertAfter(element);
			}
		},
		invalidHandler: function (e, validator) {
			// for (var i in validator.errorMap) {
			//     console.log(i, ":", validator.errorMap[i]);
			// }
		},
		submitHandler: function (form) {
			loading();

			if (mobileValidate) {
				var full_name = $("#name").val();
				var email = $("#email").val();

				if(country == 'MY') {
					var mobile = iti.getSelectedCountryData().dialCode + $("#mobile").val();
				} else {
					var mobile = $("#mobile").val();
				}

				// if ($("#race-list").val() == "others")
				// 	var race = $("#other-races").val();
				// else var race = $("#race-list").val();
                var race = '';

				var gender = $("#Male").is(":checked") ? 1 : 2;
				var nationality = $("#Malaysian").is(":checked") ? 1 : 0;
				var dob = $(".dob").val();
				var authorise = $("#subscribe2").is(":checked") ? 1 : 0;
				var newsletter = $("#subscribe3").is(":checked") ? 1 : 0;

				if (nationality == 1) {
					var NRIC = $("#passport").val();

					var data = {
						full_name: full_name,
						email: email,
						mobile_no: mobile,
						nationality: nationality,
						gender: gender,
						DOB: dob,
						NRIC: NRIC,
						authorise_upline: authorise,
						newsletter_email: newsletter,
						race: race,
					};
				} else {
					var passport = $("#passport").val();

					var data = {
						full_name: full_name,
						email: email,
						mobile_no: mobile,
						nationality: nationality,
						gender: gender,
						DOB: dob,
						passport_no: passport,
						authorise_upline: authorise,
						newsletter_email: newsletter,
						race: race,
					};
				}

				var guardian_flag = $("#guardian_flag").is(":checked") ? 1 : 0;
				// if (guardian_flag == 1) {
				data.guardian_flag = guardian_flag;
				data.guardian_name = $("#guardian_name").val() === "" ? "" : $("#guardian_name").val();
				data.guardian_nric = $("#guardian_nric").val() === "" ? "" : $("#guardian_nric").val();
				data.guardian_relationship = $("#guardian_relationship").val() === "" ? "" : $("#guardian_relationship").val();
				// }

				if (getCookie("user_fb_token")) {
					var url = apipath + "facebook/registration";

					data.access_token = getCookie("user_fb_token");
				} else if (getCookie("user_google_token")) {
					var url = apipath + "google/registration";

					data.access_token = getCookie("user_google_token");
				} else if (getCookie("user_ielken_token")) {
					var url = apipath + "old-elken/registration";

					data.member_id = getCookie("user_member_id");
					data.password = getCookie("user_password");
				} else if (getCookie("user_classic_token")) {
					var url = apipath + "classic-elken/registration";

					data.member_id = getCookie("user_member_id");
					data.password = getCookie("user_password");
				}

				data.country = country;
				data.organization_id = organization_id;

				var childrenArray = [];
				for (var i = 0; i < $(".sub-profiles").length; i++) {
					var profileNumber = i + 1;

					var full_name = $("#sub-profile-name" + profileNumber).val();
					var id = $("#sub-profile-bkID" + profileNumber).val();
					var dob = $("#sub-dob" + profileNumber).val();
					var gender = $("#addMale" + profileNumber).is(":checked") ? 1 : 2;
					var nationality = $("#addMalaysian" + profileNumber).is(":checked") ? 1 : 0;

					if (id == "new") {
						var race = $("#additional-race-list" + profileNumber).val();

						if (race == "others") {
							race = $("#additional-other-races" + profileNumber).val();
						}
					} else {
						var race = $("#additional-race-list" + profileNumber).val();
					}

					var childrenAttr = {
						full_name: full_name,
						id: id,
						DOB: dob,
						gender: gender,
						race: race,
						nationality: nationality,
					};

					childrenArray.push(childrenAttr);
				}
				data.children = childrenArray;

				$.ajax({
					url: url,
					type: "POST",
					headers: { "X-localization": localization },
					data: JSON.stringify(data),
					contentType: "application/json", // tell jQuery not to set contentType
					success: function (data) {
						deleteCookie("user_fb_token");
						deleteCookie("user_google_token");
						deleteCookie("user_ielken_cookie");
						deleteCookie("user_classic_cookie");
						deleteCookie("user_member_id");
						deleteCookie("user_password");

						removeLoading();

						window.location.href = redirectPath + "/sign-up-verification";
					},
					error: function (data) {
						log(data);
						var response = JSON.parse(data.responseText);

						removeLoading();

						Swal.fire({
							type: "error",
							title: localeObject[localization]["errorText"],
							text: response.message,
							animation: false,
							customClass: {
								popup: "animated fadeIn",
							},
						});
						// window.location.href = redirectPath + '/login';
					},
					complete: function (data) {
						// console.log(data);
					},
				});
			} else {
				removeLoading();

				var errorMsg = "";

                if (localization == "en")
                    errorMsg = "Mobile no. not verified";
				else if (localization == "ms")
					errorMsg = "No. telefon belum disahkan";
                else if (localization == "zh")
                    errorMsg = "手机号码没有经过验证";

				Swal.fire({
					type: "error",
					title: localeObject[localization]["errorText"],
					text: errorMsg,
					animation: false,
					customClass: {
						popup: "animated fadeIn",
					},
				});
			}
		},
	});

	if (localization == "en") {
		jQuery.extend(jQuery.validator.messages, {
			required: "This field is required.",
			remote: "Please fix this field.",
			email: "Please enter a valid email address.",
			validemail: jQuery.validator.format(
				"Please enter a valid email address."
			),
			url: "Please enter a valid URL.",
			date: "Please enter a valid date.",
			dateISO: "Please enter a valid date (ISO).",
			number: "Please enter a valid number.",
			digits: "Please enter only digits.",
			creditcard: "Please enter a valid credit card number.",
			equalTo: "Please enter the same value again.",
			validpassword: jQuery.validator.format(
				"Please enter at least 8 characters which consists of lowercase letters, uppercase letters and numerals."
			),
            accept: "Please enter a value with a valid extension.",
            mobileformat: jQuery.validator.format(
				"Please enter a valid mobile."
			),
			maxlength: jQuery.validator.format(
				"Please enter no more than {0} characters."
			),
			minlength: jQuery.validator.format(
				"Please enter at least {0} characters."
			),
			rangelength: jQuery.validator.format(
				"Please enter a value between {0} and {1} characters long."
			),
			range: jQuery.validator.format(
				"Please enter a value between {0} and {1}."
			),
			max: jQuery.validator.format(
				"Please enter a value less than or equal to {0}."
			),
			min: jQuery.validator.format(
				"Please enter a value greater than or equal to {0}."
			),
			CheckDOB: "Please enter valid date format.",
			checkDeliveryDateWeekend: "Please select weekdays only.",
			checkDeliveryDate: "Please select 1 day after today.",
		});
	} else if (localization == "ms") {
		jQuery.extend(jQuery.validator.messages, {
			required: "Ruangan ini wajib diisi.",
			remote: "Sila betulkan ruangan ini.",
			email: "Sila masukkan alamat e-mel yang sah.",
			validemail: jQuery.validator.format(
				"Sila masukkan alamat e-mel yang sah."
			),
			url: "Sila masukkan URL yang sah.",
			date: "Sila masukkan tarikh yang sah.",
			dateISO: "Sila masukkan tarikh yang sah (ISO).",
			number: "Sila masukkan nombor yang sah.",
			digits: "Sila masukkan nombor sahaja.",
			creditcard: "SIla masukkan nombor kad kredit yang sah.",
			equalTo: "Sila masukkan nilai yang sama sekali lagi.",
			validpassword: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya 8 aksara yang terdiri daripada huruf kecil, huruf besar dan angka."
			),
            accept: "Sila masukkan nilai dengan sambungan sah.",
            mobileformat: jQuery.validator.format(
				"Sila masukkan Telefon bimbit yang sah."
			),
			maxlength: jQuery.validator.format(
				"Sila masukkan tidak melebihi {0} aksara."
			),
			minlength: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya {0} aksara."
			),
			rangelength: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara panjang."
			),
			range: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara."
			),
			max: jQuery.validator.format(
				"Sila masukkan nilai sekurang-kurangnya atau sama dengan {0}."
			),
			min: jQuery.validator.format(
				"Sila masukkan nilai melebihi atau sama dengan {0}."
			),
			CheckDOB: "Sila masukkan format tarikh yang sah.",
			checkDeliveryDateWeekend: "Sila pilih hari bekerja sahaja.",
			checkDeliveryDate: "Sila pilih tarikh selepas hari ini.",
		});
	} else if (localization == "zh") {
		jQuery.extend(jQuery.validator.messages, {
			required: "此为必填项.",
			remote: "请更正此项目.",
			email: "请输入有效的电邮地址.",
			validemail: jQuery.validator.format("请输入有效的电邮地址."),
			url: "请输入有效的网址.",
			date: "请输入有效的日期.",
			dateISO: "请输入有效的日期(ISO).",
			number: "请输入有效的数字.",
			digits: "请只输入号码.",
			creditcard: "请输入有效的信用卡号码.",
			equalTo: "请再次输入一样的字符串.",
			validpassword: jQuery.validator.format(
				"请输入至少8个字符，包括小写字母，大写字母和数字."
			),
            accept: "请输入拥有有效后缀名的字符串.",
            mobileformat: jQuery.validator.format("请输入有效的手机号码."),
			maxlength: jQuery.validator.format("请输入不多于 {0}个的字母."),
			minlength: jQuery.validator.format("请输入至少 {0}个的字数."),
			rangelength: jQuery.validator.format(
				"请输入一个长度介于 {0} 和 {1} 之间的字符串."
			),
			range: jQuery.validator.format("请输入一个介于 {0} 和 {1} 之间的字符串."),
			max: jQuery.validator.format("请输入一个 长度最少是 {0} 的字符串."),
			min: jQuery.validator.format("请输入一个最小为{0} 的字符串."),
			CheckDOB: "请输入有效的日期格式。",
			checkDeliveryDateWeekend: "请仅选择工作日。",
			checkDeliveryDate: "请选择今天之后的日期",
		});
	}
}

//CHECK TOKEN FOR SOCIAL MEDIA
function signUpCookieCheck () {
	$("#upline-wrap").hide();

	if ( getCookie("user_fb_token").length != 0 || getCookie("user_google_token").length != 0 || getCookie("user_ielken_token").length != 0 || getCookie("user_classic_token").length != 0 ) {
		$("#email").val(getCookie("user_email"));

		if ( getCookie("user_ielken_token").length != 0 || getCookie("user_classic_token").length != 0 ) {
			loading();
			$("#upline-wrap").show();

			if (getCookie("user_classic_token") == "Classic") {
				log("pull classic details");
				var url = apipath + "classic-elken/detail";
			} else {
				log("pull ielken details");
				var url = apipath + "old-elken/detail";
			}

			var data;
			data = {
				member_id: getCookie("user_member_id"),
				password: getCookie("user_password"),
			};
			data.country = country;
			data.organization_id = organization_id;

			$.ajax({
				url: url,
				type: "POST",
				headers: { "X-localization": localization },
				data: JSON.stringify(data),
				contentType: "application/json", // tell jQuery not to set contentType
				success: function (data) {
					log(data);

					$("#name").val(data.name);
					$("#email").val(data.email);
					$("#mobile").val(data.mobile);

					if (data.gender == "Male") {
						$("#Male").prop("checked", true);
					} else if (data.gender == "Female") {
						$("#Female").prop("checked", true);
					}

					if (data.nationality == 1) {
						$("#Malaysian").prop("checked", true);
					} else if (data.nationality == 0) {
						$("#Non-Malaysian").prop("checked", true);
					}
					$("#passport").val(data.passport);

					var dob = data.dob;
					$("#dob").val(dob);
					if (dob) guardianDiv(dob);

					removeLoading();
				},
				error: function (data) {
					var response = JSON.parse(data.responseText);
					removeLoading();

					Swal.fire({
						type: "error",
						title: localeObject[localization]["errorText"],
						text: response.message,
						animation: false,
						customClass: {
							popup: "animated fadeIn",
						},
					});
				},
				complete: function (data) {
					// console.log(data);
				},
			});
		}
	} else {
		window.location.href = redirectPath + "/login";
	}
}

//EMAIL VERIFY
function verifyEmail () {
	var urlParams = new URLSearchParams(window.location.search);

	var url = apipath + "user/verify";
	var data = { token: urlParams.get("token") };

	$.ajax({
		url: url,
		type: "POST",
		headers: { "X-localization": localization },
		data: JSON.stringify(data),
		contentType: "application/json", // tell jQuery not to set contentType
		success: function (data) {
			log("success");

			window.location.href = redirectPath + "/thank-you";
		},
		error: function (data) {
			log("error");
			log(data);
		},
		complete: function (data) {
			// console.log(data);
		},
	});
}

$(".registerKitIcon").click(function () {
	registerKitIcon();
});

function registerKitIcon () {
	console.log("registerKitIcon");
	Swal.fire({
		type: "success",
		title: localeObject[localization]["registerKit_info"],
		text: localeObject[localization]["registerKit_text"],
		animation: false,
		customClass: {
			popup: "animated fadeIn",
		},
	}).then(function () {
		// window.location.href = redirectPath + '/login';
		window.location.href = redirectPath + "/login?source=register-test-kit";
	});
}

//LOGIN API
function loginValidate () {
	$.validator.addMethod(
		"validemail",
		function (value, element) {
			// allow any non-whitespace characters as the host part
			return (
				this.optional(element) ||
				/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
					value
				)
			);
		},
		"Please enter a valid email."
	);

	$("#loginForm").validate({
		debug: true,
		focusInvalid: true,
		rules: {
			login: {
				required: true,
			},
			// email: {
			// 	required: true,
			// 	email: true,
			// 	validemail: true
			// },
			member_id: {
				required: true,
			},
			password: {
				required: true,
			}
		},
		errorPlacement: function (error, element) {
			error.insertAfter(element);
		},
		invalidHandler: function (e, validator) { },
		submitHandler: function (form) {
			loading();
			var selected = $("#login-options").find(":selected").val();

			var url = apipath + "user/login";
			var data;

    		var email     = $('#member-id').val();
    		var member_id = $('#member-id').val();
            var password  = $('#password').val();

            data = {"email": member_id, "member_id": member_id, "password": password};

			data.country = country;
			data.organization_id = organization_id;

			$.ajax({
				url: url,
				type: "POST",
				headers: { "X-localization": localization },
				data: JSON.stringify(data),
				contentType: 'application/json', // tell jQuery not to set contentType
                success : function(data) {
                    log('success');
                    log(data);

					if (data.message == "errorMsg.oldElken.newUser") {
						setCookie("user_member_id", member_id, 1);
						setCookie("user_password", password, 1);
						setCookie("user_ielken_token", "iElken", 1);
						deleteCookie("user_classic_token");

						removeLoading();

						window.location.href = redirectPath + "/complete-profile";
					} else if (data.message == "errorMsg.classicElken.newUser") {
						setCookie("user_member_id", member_id, 1);
						setCookie("user_password", password, 1);
						setCookie("user_classic_token", "Classic", 1);
						deleteCookie("user_ielken_token");

                        removeLoading();

						window.location.href = redirectPath + '/complete-profile';
                    } else if(data.message == 'errorMsg.bothElken.newUser') {
                        removeLoading();

                        if (localization == "en") {
                            errorTitle          = "Please select the plan you are from";
                            bodyText            = "Oops! It seems there is a duplicate of your account in both plans, please select the correct plan to proceed.";
                            buttonConfirmText   = "Elken Global";
                            buttonCancelText    = "Elken";
                        } else if (localization == "ms") {
                            errorTitle          = "Sila pilih pelan anda";
                            bodyText            = "Oops! Terdapat duplikasi akaun anda di kedua-dua pelan, sila pilih pelan yang betul untuk teruskan.";
                            buttonConfirmText   = "Elken Global";
                            buttonCancelText    = "Elken";
                        } else if (localization == "zh") {
                            errorTitle          = "请选择您的计划";
                            bodyText            = "Oops！您的账号似乎已重复使用，请选择正确的配套以继续。";
                            buttonConfirmText   = "爱康环球​";
                            buttonCancelText    = "爱康";
                        }

	                    Swal.fire({
							type: 'success',
							title: errorTitle,
							text: bodyText,
							showCancelButton: true,
							confirmButtonColor: '#1A1B4E',
							confirmButtonText: buttonConfirmText,
							cancelButtonColor: '#3085d6',
							cancelButtonText: buttonCancelText,
							reverseButtons: false,
							animation: false,
							customClass: {
								popup: 'animated fadeIn'
							}
						}).then(function(results) {
							if (results.value) {
								log('iElken');
								setCookie('user_member_id', member_id, 1);
					            setCookie('user_password', password, 1);
					            setCookie('user_classic_token', 'Classic', 1);
					            deleteCookie('user_ielken_token');

								window.location.href = redirectPath + '/complete-profile';
							} else if (results.dismiss === Swal.DismissReason.cancel) {
								log('Classic');
								setCookie('user_member_id', member_id, 1);
					            setCookie('user_password', password, 1);
					            setCookie('user_ielken_token', 'iElken', 1);
					            deleteCookie('user_classic_token');

								window.location.href = redirectPath + '/complete-profile';
							}
						});
                    } else {
                        setCookie('ty_access_token', data['token'], 1);
                        setCookie('login_country', smallLetterCountry, 1);

						removeLoading();

						var redirectUrl = "";
						var urlParams = new URLSearchParams(window.location.search);

						if (
							urlParams.get("source") &&
							urlParams.get("source") == "register-test-kit"
						) {
							if (smallLetterCountry == "my") {
								redirectUrl = redirectPath + "/register-test-kit";
							} else {
                                // redirectUrl = redirectPath + "/";
                                redirectUrl = redirectPath;
							}
						} else {
                            // redirectUrl = redirectPath + "/";
                            redirectUrl = redirectPath;
						}

						if (getCookie('product-redirect') == 1)
							window.location.href = redirectPath + '/our-products';
						else
							window.location.href = redirectUrl;

                        window.location.href = redirectUrl;
                    }
                },
                error : function(data) {
                    var response = JSON.parse(data.responseText);
                    removeLoading();

					Swal.fire({
						type: "error",
						title: localeObject[localization]["errorText"],
						text: response.message,
						animation: false,
						customClass: {
							popup: "animated fadeIn",
						},
					});
				},
				complete: function (data) {
					// console.log(data);
				},
			});
		}
	});

	if (localization == "en") {
		jQuery.extend(jQuery.validator.messages, {
			required: "This field is required.",
			remote: "Please fix this field.",
			email: "Please enter a valid email address.",
			validemail: jQuery.validator.format(
				"Please enter a valid email address."
			),
			url: "Please enter a valid URL.",
			date: "Please enter a valid date.",
			dateISO: "Please enter a valid date (ISO).",
			number: "Please enter a valid number.",
			digits: "Please enter only digits.",
			creditcard: "Please enter a valid credit card number.",
			equalTo: "Please enter the same value again.",
			validpassword: jQuery.validator.format(
				"Please enter at least 8 characters which consists of lowercase letters, uppercase letters and numerals."
			),
			accept: "Please enter a value with a valid extension.",
			maxlength: jQuery.validator.format(
				"Please enter no more than {0} characters."
			),
			minlength: jQuery.validator.format(
				"Please enter at least {0} characters."
			),
			rangelength: jQuery.validator.format(
				"Please enter a value between {0} and {1} characters long."
			),
			range: jQuery.validator.format(
				"Please enter a value between {0} and {1}."
			),
			max: jQuery.validator.format(
				"Please enter a value less than or equal to {0}."
			),
			min: jQuery.validator.format(
				"Please enter a value greater than or equal to {0}."
			),
			CheckDOB: "Please enter valid date format.",
			checkDeliveryDateWeekend: "Please select weekdays only.",
			checkDeliveryDate: "Please select 1 day after today.",
		});
	} else if (localization == "ms") {
		jQuery.extend(jQuery.validator.messages, {
			required: "Ruangan ini wajib diisi.",
			remote: "Sila betulkan ruangan ini.",
			email: "Sila masukkan alamat e-mel yang sah.",
			validemail: jQuery.validator.format(
				"Sila masukkan alamat e-mel yang sah."
			),
			url: "Sila masukkan URL yang sah.",
			date: "Sila masukkan tarikh yang sah.",
			dateISO: "Sila masukkan tarikh yang sah (ISO).",
			number: "Sila masukkan nombor yang sah.",
			digits: "Sila masukkan nombor sahaja.",
			creditcard: "SIla masukkan nombor kad kredit yang sah.",
			equalTo: "Sila masukkan nilai yang sama sekali lagi.",
			validpassword: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya 8 aksara yang terdiri daripada huruf kecil, huruf besar dan angka."
			),
			accept: "Sila masukkan nilai dengan sambungan sah.",
			maxlength: jQuery.validator.format(
				"Sila masukkan tidak melebihi {0} aksara."
			),
			minlength: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya {0} aksara."
			),
			rangelength: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara panjang."
			),
			range: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara."
			),
			max: jQuery.validator.format(
				"Sila masukkan nilai sekurang-kurangnya atau sama dengan {0}."
			),
			min: jQuery.validator.format(
				"Sila masukkan nilai melebihi atau sama dengan {0}."
			),
			CheckDOB: "Sila masukkan format tarikh yang sah.",
			checkDeliveryDateWeekend: "Sila pilih hari bekerja sahaja.",
			checkDeliveryDate: "Sila pilih tarikh selepas hari ini.",
		});
	} else if (localization == "zh") {
		jQuery.extend(jQuery.validator.messages, {
			required: "此为必填项.",
			remote: "请更正此项目.",
			email: "请输入有效的电邮地址.",
			validemail: jQuery.validator.format("请输入有效的电邮地址."),
			url: "请输入有效的网址.",
			date: "请输入有效的日期.",
			dateISO: "请输入有效的日期(ISO).",
			number: "请输入有效的数字.",
			digits: "请只输入号码.",
			creditcard: "请输入有效的信用卡号码.",
			equalTo: "请再次输入一样的字符串.",
			validpassword: jQuery.validator.format(
				"请输入至少8个字符，包括小写字母，大写字母和数字."
			),
			accept: "请输入拥有有效后缀名的字符串.",
			maxlength: jQuery.validator.format("请输入不多于 {0}个的字母."),
			minlength: jQuery.validator.format("请输入至少 {0}个的字数."),
			rangelength: jQuery.validator.format(
				"请输入一个长度介于 {0} 和 {1} 之间的字符串."
			),
			range: jQuery.validator.format("请输入一个介于 {0} 和 {1} 之间的字符串."),
			max: jQuery.validator.format("请输入一个 长度最少是 {0} 的字符串."),
			min: jQuery.validator.format("请输入一个最小为{0} 的字符串."),
			CheckDOB: "请输入有效的日期格式。",
			checkDeliveryDateWeekend: "请仅选择工作日。",
			checkDeliveryDate: "请选择今天之后的日期",
		});
	}
}

//INIT FB
function initFB () {
	log("INIT");
	window.fbAsyncInit = function () {
		FB.init({
			appId: fbID,
			cookie: true,
			xfbml: true,
			oauth: true,
			version: "v3.2",
		});
	}; //fbAsyncInit ends

	// Load the SDK asynchronously
	(function (d, s, id) {
		var js,
			fjs = d.getElementsByTagName(s)[0];
		if (d.getElementById(id)) return;
		js = d.createElement(s);
		js.id = id;
		js.src = "//connect.facebook.net/en_US/sdk.js";
		fjs.parentNode.insertBefore(js, fjs);
	})(document, "script", "facebook-jssdk");
}

//FB LOGIN Start
function fb_login () {
	FB.login(
		function (response) {
			if (response.authResponse) {
				log("Welcome!  Fetching your information.... ");
				// log(response); // dump complete info

				var access_token = response.authResponse.accessToken; //get access token
				var user_id = response.authResponse.userID; //get FB UID

				FB.api("/me", { locale: "en_US", fields: "id,name,email" }, function (
					responseAPI
				) {
					setCookie("user_email", responseAPI.email, 1);
				});

				facebookLoginAPI(access_token);
			} else {
				//user hit cancel button
				log("User cancelled login or did not fully authorize.");
			}
		},
		{
			scope: "email",
		}
	);
}

function facebookLoginAPI (access_token) {
	var url = apipath + "facebook/login";
	var data = {
		access_token: access_token,
		country: country,
		organization_id: organization_id,
	};
	setCookie("user_fb_token", access_token, 1);

	loading();

	$.ajax({
		url: url,
		type: "POST",
		headers: { "X-localization": localization },
		data: JSON.stringify(data),
		contentType: "application/json", // tell jQuery not to set contentType
		success: function (data) {
			// console.log('success');
			removeLoading();
			facebookAPIResponseHandler(data);
			// setCookie('ty_access_token', data['token'], 1);

			// window.location.href = redirectPath + '/thank-you';
		},
		error: function (data) {
			log(data);

			removeLoading();

			var response = JSON.parse(data.responseText);

			if (data.status == 401)
				Swal.fire({
					type: "info",
					title: "Info",
					text: response.message,
					animation: false,
					customClass: {
						popup: "animated fadeIn",
					},
				});

			deleteCookie("user_fb_token");
			deleteCookie("user_email");
		},
		complete: function (data) {
			// console.log(data);
		},
	});
}

function facebookAPIResponseHandler (data) {
	if (data["message"]) {
		window.location.href = redirectPath + "/complete-profile";
	} else {
        window.location.href = redirectPath;
        // window.location.href = redirectPath + "/";

		setCookie("ty_access_token", data["token"], 1);
		setCookie("login_country", smallLetterCountry, 1);

		deleteCookie("user_fb_token");
		deleteCookie("user_email");
	}
}
//FB LOGIN END

//GOOGLE INIT
function onLoadGoogleCallback () {
	var auth2, element;
	gapi.load("auth2", function () {
		auth2 = gapi.auth2.init({
			client_id: googleID,
			// cookiepolicy: 'single_host_origin',
			scope: "profile",
		});

		auth2.attachClickHandler(
			element,
			{},
			function (googleUser) {
				setCookie("user_email", googleUser.getBasicProfile().getEmail(), 1);
				log(getCookie("user_email"));
				// The ID token you need to pass to your backend:
				var id_token = googleUser.getAuthResponse().access_token;
				log("ID Token: " + id_token);

				googleLoginAPI(id_token);
			},
			function (error) {
				log(error);
				log("Sign-in error", error);
			}
		);
	});

	element = document.getElementById("googleSignIn");
}

//GOOGLE LOGIN START
function googleLoginAPI (access_token) {
	var url = apipath + "google/login";
	var data = {
		access_token: access_token,
		country: country,
		organization_id: organization_id,
	};

	removeLoading();

	setCookie("user_google_token", access_token, 1);

	$.ajax({
		url: url,
		type: "POST",
		headers: { "X-localization": localization },
		data: JSON.stringify(data),
		contentType: "application/json", // tell jQuery not to set contentType
		success: function (data) {
			console.log("success");

			removeLoading();

			googleAPIResponseHandler(data);
			// setCookie('ty_access_token', data['token'], 1);

			// window.location.href = redirectPath + '/thank-you';
		},
		error: function (data) {
			var response = JSON.parse(data.responseText);

			if (data.status == 401)
				Swal.fire({
					type: "info",
					title: "Info",
					text: response.message,
					animation: false,
					customClass: {
						popup: "animated fadeIn",
					},
				});

			deleteCookie("user_google_token");
			deleteCookie("user_email");
		},
		complete: function (data) {
			console.log(data);
		},
	});

	// return response;
}

function googleAPIResponseHandler (data) {
	if (data["message"]) {
		log(getCookie("user_email"));
		window.location.href = redirectPath + "/complete-profile";
	} else {
        window.location.href = redirectPath;
        // window.location.href = redirectPath + "/";

		setCookie("ty_access_token", data["token"], 1);
		setCookie("login_country", smallLetterCountry, 1);

		deleteCookie("user_google_token");
		deleteCookie("user_email");
	}
}
//GOOGLE LOGIN END

//PROFILE
//Edit profile add and delete additional profiles function//
$(".add-profile-btn").click(function () {
	if (localization == "en") {
		if (country == "MY") {
			var nationalityString = localeObject[localization]["Malaysian"];
			var non_nationalityString = localeObject[localization]["Non-Malaysian"];
		} else if (country == "SG") {
			var nationalityString = "Singaporean";
			var non_nationalityString = "Non-Singaporean";
		} else if (country == "BN") {
			var nationalityString = "Bruneian";
			var non_nationalityString = "Non-Bruneian";
		}
		var profiles =
			'<div class="sub-profiles" id="profile1"><p class="profiles">Profile 1</p><input type="hidden" class="sub-profile-bkID" id="sub-profile-bkID" value="new"><label>Name as per ID</label><input type="text" class="sub-profile-name" id="sub-profile-name1" name="name" placeholder="John Doe"><label>Gender</label><div class="select-gender selection-button sub-gender" id="add-gender-wrap"><input class="add-male" type="radio" id="addMale" name="addGender" value="Male"><label class="add-male-label" for="addMale">Male</label><input class="add-female" type="radio" id="addFemale" name="addGender" value="Female"><label class="add-female-label" for="addFemale">Female</label></div><label>Nationality</label><div class="select-nationality selection-button sub-nationality" id="additional-nationality-wrap"><input class="add-malaysian" type="radio" id="Malaysian" name="subNationality" value="Malaysian"><label class="nationality-label" for="Malaysian">' +
			nationalityString +
			'</label><input class="add-non-malaysian" type="radio" id="Non-Malaysian" name="subNationality" value="Non-Malaysian"><label class="non-nationality-label" for="Non-Malaysian">' +
			non_nationalityString +
			'</label></div><label>Race</label><select id="additional-race-list" class="additional-race-list" type="text" name="subRace" required><option value="" disabled selected hidden>Select</option><option value="Malay">Malay</option><option value="Chinese">Chinese</option><option value="Indian">Indian</option><option value="Bajau">Bajau</option><option value="Kadazan">Kadazan</option><option value="Murut">Murut</option><option value="Melanau">Melanau</option><option value="Other Sabah Bumiputeras">Other Sabah Bumiputeras</option><option value="Other Sarawak Bumiputeras">Other Sarawak Bumiputeras</option><option value="Iban">Iban</option><option value="Bidayuh">Bidayuh</option><option value="Dusun">Dusun</option><option value="Kedayan">Kedayan</option><option value="Aborigines (Peninsular)">Aborigines (Peninsular)</option><option value="Bangladeshi">Bangladeshi</option><option value="Pakistani">Pakistani</option><option value="Sri Lankan">Sri Lankan</option><option value="Indonesian">Indonesian</option><option value="European">European</option><option value="others">Others</option></select><label class="other-races-label">Other races</label><input class="additional-other-races" type="text" name="subOtherRaces" placeholder="(Please specify)" id="additional-other-races"><label>Date of birth</label><input type="text" class="sub-profile-dob dob selectDate" id="sub-dob1" value="" name="dob" data-date-format="dd/mm/yy" placeholder="yyyy/mm/dd" autocomplete="off"><div class="delete-btn-container"><button type="button" class="delete-profile">Delete</button></div></div>';
	} else if (localization == "ms") {
		var profiles =
			'<div class="sub-profiles" id="profile1"><p class="profiles">Profil 1</p><input type="hidden" class="sub-profile-bkID" id="sub-profile-bkID" value="new"><label>Nama seperti dalam K/P​</label><input type="text" class="sub-profile-name" id="sub-profile-name1" name="name" placeholder="John Doe"><label>Jantina​</label><div class="select-gender selection-button sub-gender" id="add-gender-wrap"><input class="add-male" type="radio" id="addMale" name="addGender" value="Male"><label class="add-male-label" for="addMale">Lelaki</label><input class="add-female" type="radio" id="addFemale" name="addGender" value="Female"><label class="add-female-label" for="addFemale">Wanita​</label></div><label>Kewarganegaraan​</label><div class="select-nationality selection-button sub-nationality" id="additional-nationality-wrap"><input class="add-malaysian" type="radio" id="Malaysian" name="subNationality" value="Malaysian"><label class="nationality-label" for="Malaysian">Warganegara</label><input class="add-non-malaysian" type="radio" id="Non-Malaysian" name="subNationality" value="Non-Malaysian"><label class="non-nationality-label" for="Non-Malaysian">Bukan Warganegara</label></div><label>Bangsa</label><select id="additional-race-list" class="additional-race-list" type="text" name="subRace" required><option value="" disabled selected hidden>Pilih</option><option value="Malay">Melayu</option><option value="Chinese">Cina</option><option value="Indian">India</option><option value="Bajau">Bajau</option><option value="Kadazan">Kadazan</option><option value="Murut">Murut</option><option value="Melanau">Melanau</option><option value="Other Sabah Bumiputeras">Lain-lain Bumiputera Sabah</option><option value="Other Sarawak Bumiputeras">Lain-lain Bumiputera Sarawak</option><option value="Iban">Iban</option><option value="Bidayuh">Bidayuh</option><option value="Dusun">Dusun</option><option value="Kedayan">Kedayan</option><option value="Aborigines (Peninsular)">Orang Asli (Semenanjung)</option><option value="Bangladeshi">Bangladesh</option><option value="Pakistani">Pakistan</option><option value="Sri Lankan">Sri Lanka</option><option value="Indonesian">Indonesia</option><option value="European">Eropah</option><option value="others">Lain-lain</option></select><label class="other-races-label">Bangsa lain</label><input class="additional-other-races" type="text" name="subOtherRaces" placeholder="(Sila nyatakan)" id="additional-other-races"><label>Tarikh Lahir​</label><input type="text" class="sub-profile-dob dob selectDate" id="sub-dob1" value="" name="dob" data-date-format="dd/mm/yy" placeholder="yyyy/mm/dd" autocomplete="off"><div class="delete-btn-container"><button type="button" class="delete-profile">Padam</button></div></div>';
	} else if (localization == "zh") {
		if (country == "MY") {
			var nationalityString = localeObject[localization]["Malaysian"];
			var non_nationalityString = localeObject[localization]["Non-Malaysian"];
		} else if (country == "SG") {
			var nationalityString = "新加坡人";
			var non_nationalityString = "非新加坡人";
		} else if (country == "BN") {
			var nationalityString = "文莱人​";
			var non_nationalityString = "非文莱人";
		}
		var profiles =
			'<div class="sub-profiles" id="profile1"><p class="profiles">简历 1</p><input type="hidden" class="sub-profile-bkID" id="sub-profile-bkID" value="new"><label>身份证所示姓名</label><input type="text" class="sub-profile-name" id="sub-profile-name1" name="name" placeholder="John Doe"><label>性别​</label><div class="select-gender selection-button sub-gender" id="add-gender-wrap"><input class="add-male" type="radio" id="addMale" name="addGender" value="Male"><label class="add-male-label" for="addMale">男</label><input class="add-female" type="radio" id="addFemale" name="addGender" value="Female"><label class="add-female-label" for="addFemale">女</label></div><label>国籍​</label><div class="select-nationality selection-button sub-nationality" id="additional-nationality-wrap"><input class="add-malaysian" type="radio" id="Malaysian" name="subNationality" value="Malaysian"><label class="nationality-label" for="Malaysian">' +
			nationalityString +
			'</label><input class="add-non-malaysian" type="radio" id="Non-Malaysian" name="subNationality" value="Non-Malaysian"><label class="non-nationality-label" for="Non-Malaysian">' +
			non_nationalityString +
			'</label></div><label>种族</label><select id="additional-race-list" class="additional-race-list" type="text" name="subRace" required><option value="" disabled selected hidden>选择</option><option value="Malay">马来人</option><option value="Chinese">华人</option><option value="Indian">印度人</option><option value="Bajau">巴瑶人</option><option value="Kadazan">卡达山人</option><option value="Murut">姆鲁人</option><option value="Melanau">马兰诺人</option><option value="Other Sabah Bumiputeras">其他沙巴原住民</option><option value="Other Sarawak Bumiputeras">其他砂拉越原住民</option><option value="Iban">伊班人</option><option value="Bidayuh">比达友人</option><option value="Dusun">杜顺人</option><option value="Kedayan">克达岩人</option><option value="Aborigines (Peninsular)">西马原住民</option><option value="Bangladeshi">孟加拉人</option><option value="Pakistani">巴基斯坦人</option><option value="Sri Lankan">斯里兰卡人</option><option value="Indonesian">印尼人</option><option value="European">欧洲人</option><option value="others">其他</option></select><label class="other-races-label">其他种族</label><input class="additional-other-races" type="text" name="subOtherRaces" placeholder="（请列明）" id="additional-other-races"><label>出生日期</label><input type="text" class="sub-profile-dob dob selectDate" id="sub-dob1" value="" name="dob" data-date-format="dd/mm/yy" placeholder="yyyy/mm/dd" autocomplete="off"><div class="delete-btn-container"><button type="button" class="delete-profile">删除</button></div></div>';
	}

	$(".additional-profiles").append(profiles);

	reCalculate();
	$(".delete-profile").unbind("click", bindDeleteButton);
	$(".delete-profile").bind("click", bindDeleteButton);

	$(".selectDate").fdatepicker({
		format: "yyyy/mm/dd",
		startDate: "-18y",
		endDate: "today",
	});
});

function bindDeleteButton () {
	var currentIndex = $(this).closest("div.sub-profiles").index();
	$(".confirm-delete").data("index", currentIndex).fadeIn();
}

function reCalculate () {
	var profileNumber = 0;
	var profileId = 0;
	var profileName = 0;
	var genderId = 0;
	var maleId = 0;
	var femaleId = 0;
	var forFemaleId = 0;
	var forMaleId = 0;
	var profileDob = 0;
	var genderMale = 0;
	var genderFemale = 0;
	var subBKID = 0;
	var additionalRaceID = 0;
	var otherRacesID = 0;
	var otherRacesLabelID = 0;
	var malaysianID = 0;
	var nonMalaysianID = 0;
	var nationalityWrapID = 0;
	var forMalaysiaID = 0;
	var forNonMalaysiaID = 0;

	$(".profiles").each(function () {
		profileNumber++;

		if (localization == "en") var newProfile = "Profile " + profileNumber;
		if (localization == "ms") var newProfile = "Profil " + profileNumber;
		if (localization == "zh") var newProfile = "简历 " + profileNumber;

		$(this).html(newProfile);
	});

	$(".sub-profiles").each(function () {
		profileId++;
		var newID = "profile" + profileId;
		$(this).attr("id", newID);
	});

	$(".sub-profile-name").each(function () {
		profileName++;
		var newID = "sub-profile-name" + profileName;
		var newName = "subName" + profileName;
		$(this).attr("id", newID);
		$(this).attr("name", newName);
	});

	$(".sub-gender").each(function () {
		genderId++;
		var newID = "add-gender-wrap" + genderId;
		$(this).attr("id", newID);
	});

	$(".sub-nationality").each(function () {
		nationalityWrapID++;
		var newID = "additional-nationality-wrap" + nationalityWrapID;
		$(this).attr("id", newID);
	});

	$(".add-male").each(function () {
		maleId++;
		var newID = "addMale" + maleId;
		var newName = "addGender" + maleId;
		$(this).attr("id", newID);
		$(this).attr("name", newName);
	});

	$(".add-male-label").each(function () {
		forMaleId++;
		var newID = "addMale" + forMaleId;
		this.setAttribute("for", newID);
	});

	$(".add-female").each(function () {
		femaleId++;
		var newID = "addFemale" + femaleId;
		var newName = "addGender" + femaleId;
		$(this).attr("id", newID);
		$(this).attr("name", newName);
	});

	$(".add-female-label").each(function () {
		forFemaleId++;
		var newID = "addFemale" + forFemaleId;
		this.setAttribute("for", newID);
	});

	$(".add-malaysian").each(function () {
		malaysianID++;
		var newID = "addMalaysian" + malaysianID;
		var newName = "subNationality" + malaysianID;
		$(this).attr("id", newID);
		$(this).attr("name", newName);
	});

	$(".add-non-malaysian").each(function () {
		nonMalaysianID++;
		var newID = "addNonMalaysian" + nonMalaysianID;
		var newName = "subNationality" + nonMalaysianID;
		$(this).attr("id", newID);
		$(this).attr("name", newName);
	});

	$(".nationality-label").each(function () {
		forMalaysiaID++;
		var newID = "addMalaysian" + forMalaysiaID;
		this.setAttribute("for", newID);
	});

	$(".non-nationality-label").each(function () {
		forNonMalaysiaID++;
		var newID = "addNonMalaysian" + forNonMalaysiaID;
		this.setAttribute("for", newID);
	});

	$(".sub-profile-dob").each(function () {
		profileDob++;
		var newID = "sub-dob" + profileDob;
		var newName = "subDob" + profileDob;
		$(this).attr("id", newID);
		$(this).attr("name", newName);
	});

	$(".sub-profile-bkID").each(function () {
		subBKID++;
		var newID = "sub-profile-bkID" + subBKID;
		$(this).attr("id", newID);
	});

	$(".other-races-label").each(function () {
		otherRacesLabelID++;
		var newID = "other-races-label" + otherRacesLabelID;
		$(this).attr("id", newID);
	});

	$(".additional-other-races").each(function () {
		otherRacesID++;
		var newID = "additional-other-races" + otherRacesID;
		var newName = "subOtherRaces" + otherRacesID;
		$(this).attr("id", newID);
		$(this).attr("name", newName);
	});

	$(".additional-race-list").each(function () {
		additionalRaceID++;
		var newID = "additional-race-list" + additionalRaceID;
		var newName = "subRace" + additionalRaceID;
		$(this).attr("id", newID);
		$(this).attr("name", newName);

		$("#" + newID).unbind();

		$("#" + newID).change(function () {
			var value = $(this).children(":selected").val();
			var id = newID.replace("additional-race-list", "");

			if (value == "others") {
				$("#other-races-label" + id).css("display", "block");
				$("#additional-other-races" + id).css("display", "block");
			} else {
				$("#other-races-label" + id).css("display", "none");
				$("#additional-other-races" + id).css("display", "none");
				$("#additional-other-races" + id + "-error").css("display", "none");
			}
		});
	});
}

function getProfileInformation (editProfile) {
	loading();
	var url = apipath + "profile";

	$.ajax({
		url: url,
		type: "GET",
		headers: {
			Authorization: "Bearer " + getCookie("ty_access_token"),
			"X-localization": localization,
		},
		contentType: "application/json", // tell jQuery not to set contentType
		success: function (data) {
			var profile = data[0];

			if (editProfile == 0) {
				log("profile-show");

				$("#print-name p").text(profile.full_name);
				$("#print-email p").text(profile.email);
				$("#print-mobile p").text(profile.mobile_no);

				var race = profile.race;

				if (localeObject[localization][race] != null)
					$("#print-race p").text(localeObject[localization][race]);
                else
                    $("#print-race p").text(race);

				if (profile.gender == 1) {
					$("#print-gender p").text(localeObject[localization]["Male"]);
				} else {
					$("#print-gender p").text(localeObject[localization]["Female"]);
				}

				var nationality_country = profile.country;
				if (localization == "en") {
					if (nationality_country == "MY") {
						var nationalityString = localeObject[localization]["Malaysian"];
						var non_nationalityString = localeObject[localization]["Non-Malaysian"];
					} else if (nationality_country == "SG") {
						var nationalityString = "Singaporean";
						var non_nationalityString = "Non-Singaporean";
					} else if (nationality_country == "BN") {
						var nationalityString = "Bruneian";
						var non_nationalityString = "Non-Bruneian";
					}
				} else if (localization == "ms") {
					var nationalityString = localeObject[localization]["Malaysian"];
					var non_nationalityString = localeObject[localization]["Non-Malaysian"];
				} else if (localization == "zh") {
					if (nationality_country == "MY") {
						var nationalityString = localeObject[localization]["Malaysian"];
						var non_nationalityString = localeObject[localization]["Non-Malaysian"];
					} else if (nationality_country == "SG") {
						var nationalityString = "新加坡人";
						var non_nationalityString = "非新加坡人";
					} else if (nationality_country == "BN") {
						var nationalityString = "文莱人​";
						var non_nationalityString = "非文莱人";
					}
				}

				if (profile.nationality == 1) {
					$("#print-nationality p").text(nationalityString);

					$("#print-id-no p").text(profile.NRIC);
				} else {
					$("#print-nationality p").text(non_nationalityString);

					$("#print-id-no p").text(profile.passport_no);
				}

				var dateTime = profile.DOB.split(" ");
				date = dateTime[0].split("-").join("/");

				$("#print-dob p").text(date);

				if ( profile.login_method == 4 || profile.login_method == 5 ) {
					$('.entity-wrapper').show();
					if (profile.login_method == 4) {
						$('#print-entity p').text(localeObject[localization]["entity_elkenGlobal"]);
					}else{
						$('#print-entity p').text(localeObject[localization]["entity_elken"]);
					}
				} else {
					$('.entity-wrapper').hide();
				}

				if (profile.guardian_flag == 1) {
					$(".print-guardian-wrap").show();
					$("#print-guardian-name p").text(profile.guardian_name);
					$("#print-guardian-nric p").text(profile.guardian_nric);
					$("#print-guardian-relationship p").text(
						profile.guardian_relationship
					);
				} else {
					$(".print-guardian-wrap").hide();
				}

				var html = "";

				if (profile.children.length != 0) {
					if (localization == "en") {
						html += "<h3>Additional Profiles</h3>";
						html += '<div class="additional-profile-info">';

						for (var i = 0; i < profile.children.length; i++) {
							var numberOfProfile = i + 1;

							html += '<div class="print-profile' + numberOfProfile + '">';

							html += "<p>Profile " + numberOfProfile + "</p>";
							html += '<ul class="print-profile-info">';
							html += '<li class="row">';
							html += '<div class="medium-6 columns">Name</div>';
							html +=
								'<div id="print-childname-' +
								numberOfProfile +
								'" class="medium-6 columns"><p>' +
								profile.children[i].full_name +
								"</p></div>";
							html += "</li>";
							html += '<li class="row">';

							var gender = "Male";

							if (profile.children[i].gender == 2) gender = "Female";

							html += '<div class="medium-6 columns">Gender</div>';
							html +=
								'<div id="print-childgender-' +
								numberOfProfile +
								'" class="medium-6 columns"><p>' +
								gender +
								"</p></div>";
							html += "</li>";

							html += '<li class="row">';
							html += '<div class="medium-6 columns">Nationality</div>';

							if (nationality_country == "MY") {
								var nationalityString = localeObject[localization]["Malaysian"];
								var non_nationalityString =
									localeObject[localization]["Non-Malaysian"];
							} else if (nationality_country == "SG") {
								var nationalityString = "Singaporean";
								var non_nationalityString = "Non-Singaporean";
							} else if (nationality_country == "BN") {
								var nationalityString = "Bruneian";
								var non_nationalityString = "Non-Bruneian";
							}

							if (profile.children[i].nationality == 1) {
								html +=
									'<div id="print-childNationality-' +
									numberOfProfile +
									'" class="medium-6 columns"><p>' +
									nationalityString +
									"</p></div>";
							} else {
								html +=
									'<div id="print-childNationality-' +
									numberOfProfile +
									'" class="medium-6 columns"><p>' +
									non_nationalityString +
									"</p></div>";
							}

							html += "</li>";

							html += '<li class="row">';
							html += '<div class="medium-6 columns">Race</div>';

							if (
								localeObject[localization][profile.children[i].race] != null
							) {
								html +=
									'<div id="print-childRace-' +
									numberOfProfile +
									'" class="medium-6 columns"><p>' +
									localeObject[localization][profile.children[i].race] +
									"</p></div>";
							} else {
								html +=
									'<div id="print-childRace-' +
									numberOfProfile +
									'" class="medium-6 columns"><p>' +
									profile.children[i].race +
									"</p></div>";
							}

							html += "</li>";

							html += '<li class="row">';

							var childrenDOB = profile.children[i].DOB.split(" ");
							childrenDOB = childrenDOB[0].split("-").join("/");

							html += '<div class="medium-6 columns">Date of birth</div>';
							html +=
								'<div id="print-childdob-' +
								numberOfProfile +
								'" class="medium-6 columns"><p>' +
								childrenDOB +
								"</p></div>";
							html += "</li>";

							html += "</ul>";
							html += "</div>";
						}
						html +=
							'<p style="font-weight:300;"><b>Additional Profiles</b><br>If you wish to purchase TrueYou genetic tests for your children below 18 years of age, please fill in their information here.</p>';
						html += "</div>";
					} else if (localization == "ms") {
						html += "<h3>Profil Tambahan​</h3>";
						html += '<div class="additional-profile-info">';

						for (var i = 0; i < profile.children.length; i++) {
							var numberOfProfile = i + 1;

							html += '<div class="print-profile' + numberOfProfile + '">';

							html += "<p>Profil " + numberOfProfile + "</p>";
							html += '<ul class="print-profile-info">';
							html += '<li class="row">';
							html += '<div class="medium-6 columns">Nama</div>';
							html +=
								'<div id="print-childname-' +
								numberOfProfile +
								'" class="medium-6 columns"><p>' +
								profile.children[i].full_name +
								"</p></div>";
							html += "</li>";
							html += '<li class="row">';

							var gender = "Lelaki";

							if (profile.children[i].gender == 2) gender = "Wanita";

							html += '<div class="medium-6 columns">Jantina</div>';
							html +=
								'<div id="print-childgender-' +
								numberOfProfile +
								'" class="medium-6 columns"><p>' +
								gender +
								"</p></div>";
							html += "</li>";

							html += '<li class="row">';
							html += '<div class="medium-6 columns">Kewarganegaraan</div>';

							if (profile.children[i].nationality == 1) {
								html +=
									'<div id="print-childNationality-' +
									numberOfProfile +
									'" class="medium-6 columns"><p>' +
									localeObject[localization]["Malaysian"] +
									"</p></div>";
							} else {
								html +=
									'<div id="print-childNationality-' +
									numberOfProfile +
									'" class="medium-6 columns"><p>' +
									localeObject[localization]["Non-Malaysian"] +
									"</p></div>";
							}

							html += "</li>";

							html += '<li class="row">';
							html += '<div class="medium-6 columns">Bangsa</div>';

							if (
								localeObject[localization][profile.children[i].race] != null
							) {
								html +=
									'<div id="print-childRace-' +
									numberOfProfile +
									'" class="medium-6 columns"><p>' +
									localeObject[localization][profile.children[i].race] +
									"</p></div>";
							} else {
								html +=
									'<div id="print-childRace-' +
									numberOfProfile +
									'" class="medium-6 columns"><p>' +
									profile.children[i].race +
									"</p></div>";
							}

							html += "</li>";

							html += '<li class="row">';

							var childrenDOB = profile.children[i].DOB.split(" ");
							childrenDOB = childrenDOB[0].split("-").join("/");

							html += '<div class="medium-6 columns">Tarikh Lahir​</div>';
							html +=
								'<div id="print-childdob-' +
								numberOfProfile +
								'" class="medium-6 columns"><p>' +
								childrenDOB +
								"</p></div>";
							html += "</li>";
							html += "</ul>";
							html += "</div>";
						}
						html +=
							'<p style="font-weight:300;"><b>Profil Tambahan</b><br>Jika anda membeli kit ujian genetik TrueYou untuk anak di bawah 18 tahun, lengkapkan maklumat mereka di sini.​</p>';
						html += "</div>";
					} else if (localization == "zh") {
						html += "<h3>已添加的用户​</h3>";
						html += '<div class="additional-profile-info">';

						for (var i = 0; i < profile.children.length; i++) {
							var numberOfProfile = i + 1;

							html += '<div class="print-profile' + numberOfProfile + '">';

							html += "<p>简历 " + numberOfProfile + "</p>";
							html += '<ul class="print-profile-info">';
							html += '<li class="row">';
							html += '<div class="medium-6 columns">姓名</div>';
							html +=
								'<div id="print-childname-' +
								numberOfProfile +
								'" class="medium-6 columns"><p>' +
								profile.children[i].full_name +
								"</p></div>";
							html += "</li>";
							html += '<li class="row">';

							var gender = "男";

							if (profile.children[i].gender == 2) gender = "女";

							html += '<div class="medium-6 columns">性别​</div>';
							html +=
								'<div id="print-childgender-' +
								numberOfProfile +
								'" class="medium-6 columns"><p>' +
								gender +
								"</p></div>";
							html += "</li>";

							html += '<li class="row">';
							html += '<div class="medium-6 columns">国籍</div>';

							if (nationality_country == "MY") {
								var nationalityString = localeObject[localization]["Malaysian"];
								var non_nationalityString =
									localeObject[localization]["Non-Malaysian"];
							} else if (nationality_country == "SG") {
								var nationalityString = "新加坡人";
								var non_nationalityString = "非新加坡人";
							} else if (nationality_country == "BN") {
								var nationalityString = "文莱人​";
								var non_nationalityString = "非文莱人";
							}

							if (profile.children[i].nationality == 1) {
								html +=
									'<div id="print-childNationality-' +
									numberOfProfile +
									'" class="medium-6 columns"><p>' +
									nationalityString +
									"</p></div>";
							} else {
								html +=
									'<div id="print-childNationality-' +
									numberOfProfile +
									'" class="medium-6 columns"><p>' +
									non_nationalityString +
									"</p></div>";
							}

							html += "</li>";

							html += '<li class="row">';
							html += '<div class="medium-6 columns">种族</div>';

							if (
								localeObject[localization][profile.children[i].race] != null
							) {
								html +=
									'<div id="print-childRace-' +
									numberOfProfile +
									'" class="medium-6 columns"><p>' +
									localeObject[localization][profile.children[i].race] +
									"</p></div>";
							} else {
								html +=
									'<div id="print-childRace-' +
									numberOfProfile +
									'" class="medium-6 columns"><p>' +
									profile.children[i].race +
									"</p></div>";
							}

							html += "</li>";

							html += '<li class="row">';

							var childrenDOB = profile.children[i].DOB.split(" ");
							childrenDOB = childrenDOB[0].split("-").join("/");

							html += '<div class="medium-6 columns">出生日期</div>';
							html +=
								'<div id="print-childdob-' +
								numberOfProfile +
								'" class="medium-6 columns"><p>' +
								childrenDOB +
								"</p></div>";
							html += "</li>";
							html += "</ul>";
							html += "</div>";
						}
						html +=
							'<p style="font-weight:300;"><b>已添加的用户​</b><br>若想为您18岁以下的孩子购买TrueYou基因检测配套，请于此填写他们的资料。</p>';
						html += "</div>";
					}
				}

				if (html != "") $(".children-info").html(html);

				if (profile.login_method != 1) {
					$("#change-password-link").css("display", "none");
					$(".add-password-desc").css("display", "block");
					$("#add-password-link").css("display", "inline-block");

					$("#facebookBind").css("display", "none");
					$("#facebookUnbind").css("display", "none");

					$("#googleSignIn").css("display", "none");
					$("#googleUnbind").css("display", "none");

					$("#iElkenBind").css("display", "none");
					$("#iElkenUnbindBtn").css("display", "none");

					$("#elkenClassicBind").css("display", "none");
					$("#elkenClassicUnbindBtn").css("display", "none");
				} else {
					$("#change-password-link").css("display", "inline-block");
					$(".add-password-desc").css("display", "none");
					$("#add-password-link").css("display", "none");

					if (profile.facebook_id) {
						$("#facebookBind").css("display", "none");
						$("#facebookUnbind").css("display", "flex");
					} else {
						$("#facebookBind").css("display", "flex");
						$("#facebookUnbind").css("display", "none");
					}

					if (profile.google_id) {
						$("#googleSignIn").css("display", "none");
						$("#googleUnbind").css("display", "flex");
					} else {
						$("#googleSignIn").css("display", "flex");
						$("#googleUnbind").css("display", "none");
					}

					if (profile.ielken_member_id) {
						$("#iElkenBind").css("display", "none");
						$("#iElkenUnbindBtn").css("display", "flex");
					} else {
						$("#iElkenBind").css("display", "flex");
						$("#iElkenUnbindBtn").css("display", "none");
					}

					if (profile.elken_classic_member_id) {
						$("#elkenClassicBind").css("display", "none");
						$("#elkenClassicUnbindBtn").css("display", "flex");
					} else {
						$("#elkenClassicBind").css("display", "flex");
						$("#elkenClassicUnbindBtn").css("display", "none");
					}
				}
			} else {
				$("#name").val(profile.full_name);
				$("#email").val(profile.email);

				if(country == 'MY') {
					if(profile.mobile_no.substring(0, 1) === '0') {
						iti.setNumber('+6' + profile.mobile_no);
						var dialCode = iti.getSelectedCountryData().dialCode;
						$("#mobile").val(profile.mobile_no.slice(dialCode.length - 1, profile.mobile_no.length));
					} else {
						iti.setNumber('+' + profile.mobile_no);
						var dialCode = iti.getSelectedCountryData().dialCode;
						$("#mobile").val(profile.mobile_no.slice(dialCode.length, profile.mobile_no.length));
					}
				} else {
					$("#mobile").val(profile.mobile_no);
				}

				// var select = document.getElementById("race-list");

				// var option = document.createElement("option");

				// var race = profile.race;
				// var nationality_country = profile.country;
				// option.value = race;

				// if (localeObject[localization][race] != null)
				// 	option.text = localeObject[localization][race];
                // else
                //     option.text = race;

				// select.add(option, 0);

				// $("#race-list").val(profile.race);

				originalMobile = profile.mobile_no;
				originalEmail = profile.email;

				if (profile.gender == 1) $("#Male").prop("checked", true);
				else $("#Female").prop("checked", true);

				if (profile.nationality == 1) {
					$("#Malaysian").prop("checked", true);

					$("#passport").val(profile.NRIC);
				} else {
					$("#Non-Malaysian").prop("checked", true);

					$("#passport").val(profile.passport_no);
				}

				var dob = profile.DOB.split(" ");
				dob = dob[0].split("-").join("/");
				$("#dob").val(dob);

				if (profile.guardian_flag == 1) {
					$(".edit-guardian-wrap").show();
					$("#guardian_name").val(profile.guardian_name);
					$("#guardian_nric").val(profile.guardian_nric);
					$("#guardian_relationship").val(profile.guardian_relationship);
				} else {
					$(".edit-guardian-wrap").hide();
				}

				if (profile.newsletter_email == 1) {
					$("#subscribe1").attr("checked", true);
				}

				var html = "";

				if (profile.children.length != 0) {
					if (localization == "en") {
						for (var i = 0; i < profile.children.length; i++) {
							var numberOfProfile = i + 1;

							html +=
								'<div class="sub-profiles" id="profile"' +
								numberOfProfile +
								">";
							html +=
								'<input type="hidden" class="sub-profile-bkID" id="sub-profile-bkID' +
								numberOfProfile +
								'" value="' +
								profile.children[i].id +
								'">';
							html += '<p class="profiles">Profile ' + numberOfProfile + "</p>";
							html += "<label>Name as per ID</label>";
							html +=
								'<input type="text" class="sub-profile-name" id="sub-profile-name' +
								numberOfProfile +
								'" name="subName" placeholder="John Doe" value="' +
								profile.children[i].full_name +
								'">';
							html += "<label>Gender</label>";
							html +=
								'<div class="select-gender selection-button sub-gender gender-disabled" id="add-gender-wrap"' +
								numberOfProfile +
								">";

							if (profile.children[i].gender == 1)
								html +=
									'<input class="add-male" type="radio" id="addMale' +
									numberOfProfile +
									'" name="addGender' +
									numberOfProfile +
									'" value="Male" checked disabled>';
							else
								html +=
									'<input class="add-male" type="radio" id="addMale' +
									numberOfProfile +
									'" name="addGender' +
									numberOfProfile +
									'" value="Male" disabled>';

							html +=
								'<label class="add-male-label" for="addMale' +
								numberOfProfile +
								'">Male</label>';

							if (profile.children[i].gender == 2)
								html +=
									'<input class="add-female" type="radio" id="addFemale' +
									numberOfProfile +
									'" name="addGender' +
									numberOfProfile +
									'" value="Female" checked disabled>';
							else
								html +=
									'<input class="add-female" type="radio" id="addFemale' +
									numberOfProfile +
									'" name="addGender' +
									numberOfProfile +
									'" value="Female" disabled>';

							html +=
								'<label class="add-female-label" for="addFemale' +
								numberOfProfile +
								'">Female</label>';
							html += "</div>";

							html += "<label>Nationality</label>";

							html +=
								'<div class="select-nationality selection-button sub-nationality nationality-disabled" id="additional-nationality-wrap' +
								numberOfProfile +
								'">';

							if (nationality_country == "MY") {
								var nationalityString = localeObject[localization]["Malaysian"];
								var non_nationalityString =
									localeObject[localization]["Non-Malaysian"];
							} else if (nationality_country == "SG") {
								var nationalityString = "Singaporean";
								var non_nationalityString = "Non-Singaporean";
							} else if (nationality_country == "BN") {
								var nationalityString = "Bruneian";
								var non_nationalityString = "Non-Bruneian";
							}

							if (profile.children[i].nationality == 1) {
								html +=
									'<input class="add-malaysian" type="radio" id="addMalaysian' +
									numberOfProfile +
									'" name="subNationality' +
									numberOfProfile +
									'" value="Malaysian" checked>';
								html +=
									'<label class="nationality-label for="addMalaysian' +
									numberOfProfile +
									'">' +
									nationalityString +
									"</label>";
								html +=
									'<input class="add-non-malaysian" type="radio" id="addNonMalaysian' +
									numberOfProfile +
									'" name="subNationality' +
									numberOfProfile +
									'" value="Non-Malaysian">';
								html +=
									'<label class="non-nationality-label for="addNonMalaysian' +
									numberOfProfile +
									'">' +
									non_nationalityString +
									"</label></div>";
							} else {
								html +=
									'<input class="add-malaysian" type="radio" id="addMalaysian' +
									numberOfProfile +
									'" name="subNationality' +
									numberOfProfile +
									'" value="Malaysian">';
								html +=
									'<label class="nationality-label for="addMalaysian' +
									numberOfProfile +
									'">' +
									nationalityString +
									"</label>";
								html +=
									'<input class="add-non-malaysian" type="radio" id="addNonMalaysian' +
									numberOfProfile +
									'" name="subNationality' +
									numberOfProfile +
									'" value="Non-Malaysian" checked>';
								html +=
									'<label class="non-nationality-label for="addNonMalaysian' +
									numberOfProfile +
									'">' +
									non_nationalityString +
									"</label></div>";
							}

							var childrenRace = profile.children[i].race;

							if (localeObject[localization][profile.children[i].race] != null)
								var childrenRaceText =
									localeObject[localization][profile.children[i].race];
							else var childrenRaceText = profile.children[i].race;

							html += "<label>Race</label>";
							html +=
								'<select id="additional-race-list' +
								numberOfProfile +
								'" class="additional-race-list" type="text" name="race" disabled="">';
							html +=
								'<option value="' +
								childrenRace +
								'" selected>' +
								childrenRaceText +
								"</option>";
							html += "</select>";

							html +=
								'<label class="other-races-label" id="other-races-label' +
								numberOfProfile +
								'" style="display: none;">Other races</label>';
							html +=
								'<input class="additional-other-races" type="text" name="subOtherRaces' +
								numberOfProfile +
								'" placeholder="(Please specify)" id="additional-other-races' +
								numberOfProfile +
								'" style="display: none;">';

							html += "<label>Date of birth</label>";

							var childrenDOB = profile.children[i].DOB.split(" ");
							childrenDOB = childrenDOB[0].split("-").join("/");

							html +=
								'<input type="text" class="sub-profile-dob dob selectDate" id="sub-dob' +
								numberOfProfile +
								'" value="' +
								childrenDOB +
								'" name="subDob" data-date-format="dd/mm/yy" placeholder="yyyy/mm/dd" autocomplete="off">';
							html += '<div class="delete-btn-container">';
							html +=
								'<button type="button" class="delete-profile">Delete</button>';
							html += "</div>";
							html += "</div>";
						}
					} else if (localization == "ms") {
						for (var i = 0; i < profile.children.length; i++) {
							var numberOfProfile = i + 1;

							html +=
								'<div class="sub-profiles" id="profile"' +
								numberOfProfile +
								">";
							html +=
								'<input type="hidden" class="sub-profile-bkID" id="sub-profile-bkID' +
								numberOfProfile +
								'" value="' +
								profile.children[i].id +
								'">';
							html += '<p class="profiles">Profil ' + numberOfProfile + "</p>";
							html += "<label>Nama seperti dalam K/P​</label>";
							html +=
								'<input type="text" class="sub-profile-name" id="sub-profile-name' +
								numberOfProfile +
								'" name="subName" placeholder="John Doe" value="' +
								profile.children[i].full_name +
								'">';
							html += "<label>Jantina​</label>";
							html +=
								'<div class="select-gender selection-button sub-gender' +
								numberOfProfile +
								' gender-disabled" id="add-gender-wrap">';

							if (profile.children[i].gender == 1)
								html +=
									'<input class="add-male" type="radio" id="addMale' +
									numberOfProfile +
									'" name="addGender' +
									numberOfProfile +
									'" value="Male" checked disabled>';
							else
								html +=
									'<input class="add-male" type="radio" id="addMale' +
									numberOfProfile +
									'" name="addGender' +
									numberOfProfile +
									'" value="Male" disabled>';

							html +=
								'<label class="add-male-label" for="addMale' +
								numberOfProfile +
								'">Lelaki</label>';

							if (profile.children[i].gender == 2)
								html +=
									'<input class="add-female" type="radio" id="addFemale' +
									numberOfProfile +
									'" name="addGender' +
									numberOfProfile +
									'" value="Female" checked disabled>';
							else
								html +=
									'<input class="add-female" type="radio" id="addFemale' +
									numberOfProfile +
									'" name="addGender' +
									numberOfProfile +
									'" value="Female" disabled>';

							html +=
								'<label class="add-female-label" for="addFemale' +
								numberOfProfile +
								'">Wanita​</label>';
							html += "</div>";

							html += "<label>Kewarganegaraan</label>";

							html +=
								'<div class="select-nationality selection-button sub-nationality nationality-disabled" id="additional-nationality-wrap' +
								numberOfProfile +
								'">';

							if (profile.children[i].nationality == 1) {
								html +=
									'<input class="add-malaysian" type="radio" id="addMalaysian' +
									numberOfProfile +
									'" name="subNationality' +
									numberOfProfile +
									'" value="Malaysian" checked>';
								html +=
									'<label class="nationality-label for="addMalaysian' +
									numberOfProfile +
									'">' +
									localeObject[localization]["Malaysian"] +
									"</label>";
								html +=
									'<input class="add-non-malaysian" type="radio" id="addNonMalaysian' +
									numberOfProfile +
									'" name="subNationality' +
									numberOfProfile +
									'" value="Non-Malaysian">';
								html +=
									'<label class="non-nationality-label for="addNonMalaysian' +
									numberOfProfile +
									'">' +
									localeObject[localization]["Non-Malaysian"] +
									"</label></div>";
							} else {
								html +=
									'<input class="add-malaysian" type="radio" id="addMalaysian' +
									numberOfProfile +
									'" name="subNationality' +
									numberOfProfile +
									'" value="Malaysian">';
								html +=
									'<label class="nationality-label for="addMalaysian' +
									numberOfProfile +
									'">' +
									localeObject[localization]["Malaysian"] +
									"</label>";
								html +=
									'<input class="add-non-malaysian" type="radio" id="addNonMalaysian' +
									numberOfProfile +
									'" name="subNationality' +
									numberOfProfile +
									'" value="Non-Malaysian" checked>';
								html +=
									'<label class="non-nationality-label for="addNonMalaysian' +
									numberOfProfile +
									'">' +
									localeObject[localization]["Non-Malaysian"] +
									"</label></div>";
							}

							var childrenRace = profile.children[i].race;

							if (localeObject[localization][profile.children[i].race] != null)
								var childrenRaceText =
									localeObject[localization][profile.children[i].race];
							else var childrenRaceText = profile.children[i].race;

							html += "<label>Bangsa</label>";
							html +=
								'<select id="additional-race-list' +
								numberOfProfile +
								' class="additional-race-list"  type="text" name="race" disabled="">';
							html +=
								'<option value="' +
								childrenRace +
								'" selected>' +
								childrenRaceText +
								"</option>";
							html += "</select>";

							html +=
								'<label class="other-races-label" id="other-races-label' +
								numberOfProfile +
								'" style="display: none;">Other races</label>';
							html +=
								'<input class="additional-other-races" type="text" name="subOtherRaces' +
								numberOfProfile +
								'" placeholder="(Please specify)" id="additional-other-races' +
								numberOfProfile +
								'" style="display: none;">';

							html += "<label>Tarikh Lahir​</label>";

							var childrenDOB = profile.children[i].DOB.split(" ");
							childrenDOB = childrenDOB[0].split("-").join("/");

							html +=
								'<input type="text" class="sub-profile-dob dob selectDate" id="sub-dob' +
								numberOfProfile +
								'" value="' +
								childrenDOB +
								'" name="subDob" data-date-format="dd/mm/yy" placeholder="yyyy/mm/dd" autocomplete="off">';
							html += '<div class="delete-btn-container">';
							html +=
								'<button type="button" class="delete-profile">Padam</button>';
							html += "</div>";
							html += "</div>";
						}
					} else if (localization == "zh") {
						for (var i = 0; i < profile.children.length; i++) {
							var numberOfProfile = i + 1;

							html +=
								'<div class="sub-profiles" id="profile"' +
								numberOfProfile +
								">";
							html +=
								'<input type="hidden" class="sub-profile-bkID" id="sub-profile-bkID' +
								numberOfProfile +
								'" value="' +
								profile.children[i].id +
								'">';
							html += '<p class="profiles">简历 ' + numberOfProfile + "</p>";
							html += "<label>身份证所示姓名</label>";
							html +=
								'<input type="text" class="sub-profile-name" id="sub-profile-name' +
								numberOfProfile +
								'" name="subName" placeholder="John Doe" value="' +
								profile.children[i].full_name +
								'">';
							html += "<label>性别​</label>";
							html +=
								'<div class="select-gender selection-button sub-gender' +
								numberOfProfile +
								' gender-disabled" id="add-gender-wrap">';

							if (profile.children[i].gender == 1)
								html +=
									'<input class="add-male" type="radio" id="addMale' +
									numberOfProfile +
									'" name="addGender' +
									numberOfProfile +
									'" value="Male" checked disabled>';
							else
								html +=
									'<input class="add-male" type="radio" id="addMale' +
									numberOfProfile +
									'" name="addGender' +
									numberOfProfile +
									'" value="Male" disabled>';

							html +=
								'<label class="add-male-label" for="addMale' +
								numberOfProfile +
								'">男</label>';

							if (profile.children[i].gender == 2)
								html +=
									'<input class="add-female" type="radio" id="addFemale' +
									numberOfProfile +
									'" name="addGender' +
									numberOfProfile +
									'" value="Female" checked disabled>';
							else
								html +=
									'<input class="add-female" type="radio" id="addFemale' +
									numberOfProfile +
									'" name="addGender' +
									numberOfProfile +
									'" value="Female" disabled>';

							html +=
								'<label class="add-female-label" for="addFemale' +
								numberOfProfile +
								'">女</label>';
							html += "</div>";

							html += "<label>国籍</label>";

							html +=
								'<div class="select-nationality selection-button sub-nationality nationality-disabled" id="additional-nationality-wrap' +
								numberOfProfile +
								'">';

							if (nationality_country == "MY") {
								var nationalityString = localeObject[localization]["Malaysian"];
								var non_nationalityString =
									localeObject[localization]["Non-Malaysian"];
							} else if (nationality_country == "SG") {
								var nationalityString = "新加坡人";
								var non_nationalityString = "非新加坡人";
							} else if (nationality_country == "BN") {
								var nationalityString = "文莱人​";
								var non_nationalityString = "非文莱人";
							}

							if (profile.children[i].nationality == 1) {
								html +=
									'<input class="add-malaysian" type="radio" id="addMalaysian' +
									numberOfProfile +
									'" name="subNationality' +
									numberOfProfile +
									'" value="Malaysian" checked>';
								html +=
									'<label class="nationality-label for="addMalaysian' +
									numberOfProfile +
									'">' +
									nationalityString +
									"</label>";
								html +=
									'<input class="add-non-malaysian" type="radio" id="addNonMalaysian' +
									numberOfProfile +
									'" name="subNationality' +
									numberOfProfile +
									'" value="Non-Malaysian">';
								html +=
									'<label class="non-nationality-label for="addNonMalaysian' +
									numberOfProfile +
									'">' +
									non_nationalityString +
									"</label></div>";
							} else {
								html +=
									'<input class="add-malaysian" type="radio" id="addMalaysian' +
									numberOfProfile +
									'" name="subNationality' +
									numberOfProfile +
									'" value="Malaysian">';
								html +=
									'<label class="nationality-label for="addMalaysian' +
									numberOfProfile +
									'">' +
									nationalityString +
									"</label>";
								html +=
									'<input class="add-non-malaysian" type="radio" id="addNonMalaysian' +
									numberOfProfile +
									'" name="subNationality' +
									numberOfProfile +
									'" value="Non-Malaysian" checked>';
								html +=
									'<label class="non-nationality-label for="addNonMalaysian' +
									numberOfProfile +
									'">' +
									non_nationalityString +
									"</label></div>";
							}

							var childrenRace = profile.children[i].race;

							if (localeObject[localization][profile.children[i].race] != null)
								var childrenRaceText =
									localeObject[localization][profile.children[i].race];
							else var childrenRaceText = profile.children[i].race;

							html += "<label>种族</label>";
							html +=
								'<select id="additional-race-list' +
								numberOfProfile +
								' class="additional-race-list" type="text" name="race" disabled="">';
							html +=
								'<option value="' +
								childrenRace +
								'" selected>' +
								childrenRaceText +
								"</option>";
							html += "</select>";

							html +=
								'<label class="other-races-label" id="other-races-label' +
								numberOfProfile +
								'" style="display: none;">Other races</label>';
							html +=
								'<input class="additional-other-races" type="text" name="subOtherRaces' +
								numberOfProfile +
								'" placeholder="(Please specify)" id="additional-other-races' +
								numberOfProfile +
								'" style="display: none;">';

							html += "<label>出生日期</label>";

							var childrenDOB = profile.children[i].DOB.split(" ");
							childrenDOB = childrenDOB[0].split("-").join("/");

							html +=
								'<input type="text" class="sub-profile-dob dob selectDate" id="sub-dob' +
								numberOfProfile +
								'" value="' +
								childrenDOB +
								'" name="subDob" data-date-format="dd/mm/yy" placeholder="yyyy/mm/dd" autocomplete="off">';
							html += '<div class="delete-btn-container">';
							html +=
								'<button type="button" class="delete-profile">删除</button>';
							html += "</div>";
							html += "</div>";
						}
					}

					$(".additional-profiles").html(html);

					$(".delete-profile").bind("click", bindDeleteButton);
				}
			}

			removeLoading();
		},
		error: function (data) {
			var response = JSON.parse(data.responseText);

			removeLoading();

			if (response.message == "token_expired") {
				promptTokenExpired();
				$(".navLoader").css("display", "none");
			} else {
				Swal.fire({
					type: "error",
					title: localeObject[localization]["errorText"],
					text: response.message,
					animation: false,
					customClass: {
						popup: "animated fadeIn",
					},
				});
			}
		},
		complete: function (data) {
			// console.log(data);
		},
	});
}

//EDIT PROFILE
function editProfile () {
	$.validator.addMethod(
		"validemail",
		function (value, element) {
			// allow any non-whitespace characters as the host part
			return (
				this.optional(element) ||
				/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
					value
				)
			);
		},
		"Please enter a valid email."
    );

    $.validator.addMethod(
        "mobileformat",
        function (value, element) {
			if(country == 'MY') {
				if( value.length >= 5 && value.length <= 20 && Object.keys(iti.getSelectedCountryData()).length != 0 ) {
					return true;
				} else {
					log('invalid format');
					return false;
				}
			} else {
				if (value.substring(0, 2) == '60') {    // MY
				    log('MY number');
				    return true;
				}else if (value.substring(0, 2) == '65') {  // SG
				    log('SG number');
				    return true;
				}else if (value.substring(0, 3) == '673') {   // BN
				    log('BN number');
				    return true;
				}else{
				    log('wrong number, no prefix');
				    return false;
				}
			}
        },
        "Please enter a valid mobile with country code."
    );

	$.validator.addMethod(
		"CheckDOB",
		function (value, element) {
			// checking whether the date entered is in correct format
			var isValid = value.match(/^\d\d\d\d?\/\d\d?\/\d\d$/);
			if (isValid) {
				var minDate = Date.parse("1919/01/01");
				var today = new Date();
				// today.setFullYear( today.getFullYear() - 18 );
				today.setFullYear(today.getFullYear() - 1);
				var DOB = new Date(value);
				if (DOB >= today || DOB <= minDate) {
					isValid = false;
				}
				return isValid;
			}
		},
		"Please enter valid date format."
	);

	$.validator.addMethod(
		"checkSubDOB",
		function (value, element) {
			// checking whether the date entered is in correct format
			var isValid = value.match(/^\d\d\d\d?\/\d\d?\/\d\d$/);
			if (isValid) {
				var minDate = new Date();
				minDate.setFullYear(minDate.getFullYear() - 18);
				var maxDate = new Date();
				var DOB = new Date(value);
				if (DOB < minDate || DOB > maxDate) {
					isValid = false;
				}

				return isValid;
			}
		},
		"Please enter valid date format."
	);

	var rules = new Object();

	rules["name"] = { required: true };
	rules["email"] = { required: true, email: true, validemail: true };
    // rules["mobile"] = { required: true, minlength: 10, maxlength: 11 };
    rules["mobile"] = {
        required: true,
        mobileformat: true,
    };
	if(country != 'MY') {
		rules["mobile"]['minlength'] = function (el) {
			    if ( $("#mobile").val().substring(0, 2) == '60' ) {
			        return 11;
			    }else if ( $("#mobile").val().substring(0, 2) == '65' ) {
			        return 10;
			    }else if ( $("#mobile").val().substring(0, 3) == '673' ) {
			        return 10;
			    }else{
			        return 11;
			    }
		};
		rules["mobile"]['maxlength'] = function (el) {
			    if ( $("#mobile").val().substring(0, 2) == '60' ) {
			        return 12;
			    }else if ( $("#mobile").val().substring(0, 2) == '65' ) {
			        return 10;
			    }else if ( $("#mobile").val().substring(0, 3) == '673' ) {
			        return 10;
			    }else{
			        return 12;
			    }
			};
	}

	rules["OTP"] = { required: true, minlength: 6, maxlength: 6 };
	rules["gender"] = { required: true };
	// rules["race "] = { required: true };
	rules["nationality"] = { required: true };

	// if ($('#Malaysian').is(':checked')) {
	// 	rules['passport'] = { required: true, minlength: 12, maxlength: 12 };
	// } else {
	// 	rules['passport'] = { required: true, minlength: 5, maxlength: 30 };
	// }

	rules["dob"] = {
		required: true,
		CheckDOB: true,
	};

	// Guardian Section
	rules["guardian_name"] = { required: true };
	rules["guardian_nric"] = { required: true, minlength: 5, maxlength: 20 };
	rules["guardian_relationship"] = { required: true };
	rules["guardian_agreement"] = { required: true };

	$("input[name^=subName]").each(function () {
		rules[this.name] = { required: true };
	});

	$("input[name^=subNationality]").each(function () {
		rules[this.name] = { required: true };
	});

	$("input[name^=addGender]").each(function () {
		rules[this.name] = { required: true };
	});

	$("input[name^=subRace]").each(function () {
		rules[this.name] = { required: true };
	});

	$("input[name^=subDob]").each(function () {
		rules[this.name] = {
			required: true,
			checkSubDOB: true,
		};
	});

	$("input[name^=subOtherRaces]").each(function () {
		var id = this.name.replace("subOtherRaces", "");
		if ($("#additional-race-list" + id).val() == "others") {
			rules[this.name] = { required: true };
		} else {
			rules[this.name] = { required: false };
		}
	});

	validate = $("#editProfile").validate();

	if (typeof validate != "undefined") {
		validate.destroy();
	}

	validator = $("#editProfile").validate({
		debug: true,
		focusInvalid: true,
		rules: rules,
		errorPlacement: function (error, element) {
			if (element.attr("name").indexOf("addGender") != -1) {
				var id = element.attr("name").replace("addGender", "");
				log(id);
				log("gender");
				error.insertAfter("#add-gender-wrap" + id);
			} else if (element.attr("name") == "mobile") {
				error.insertAfter(".mobile-container");
			} else if (element.attr("name").indexOf("subNationality") != -1) {
				var id = element.attr("name").replace("subNationality", "");
				error.insertAfter("#additional-nationality-wrap" + id);
			} else {
				error.insertAfter(element);
			}
		},
		invalidHandler: function (e, validator) {
			// for (var i in validator.errorMap) {
			//     console.log(i, ":", validator.errorMap[i]);
			// }
		},
		submitHandler: function (form) {
			loading();

			editProfile = true;

			if (originalMobile != $("#mobile").val()) {
				if (!mobileValidate) {
					editProfile = false;
				}
			}

			if (!editProfile) {
				removeLoading();

				if (localization == "en") {
					Swal.fire({
						type: "info",
						title: "Info",
						text: "Please verify your mobile no",
						animation: false,
						customClass: {
							popup: "animated fadeIn",
						},
					});
				} else if (localization == "ms") {
					Swal.fire({
						type: "info",
						title: "Info",
						text: "Sila sahkan no. telefon anda",
						animation: false,
						customClass: {
							popup: "animated fadeIn",
						},
					});
				} else if (localization == "zh") {
					Swal.fire({
						type: "info",
						title: "Info",
						text: "请验证您的手机号码",
						animation: false,
						customClass: {
							popup: "animated fadeIn",
						},
					});
				}
			} else {
				var full_name = $("#name").val();
				var email = $("#email").val();
				if (country == 'MY') {
					var mobile = iti.getSelectedCountryData().dialCode + $("#mobile").val();
				} else {
					var mobile = $("#mobile").val();
				}
				// var race = $("#race-list").val();
                var race = '';
				var gender = $("#Male").is(":checked") ? 1 : 2;
				var nationality = $("#Malaysian").is(":checked") ? 1 : 0;
				var dob = $(".dob").val();
				var newsletter = $("#subscribe1").is(":checked") ? 1 : 0;

				if (nationality == 1) {
					var NRIC = $("#passport").val();

					var data = {
						full_name: full_name,
						email: email,
						mobile_no: mobile,
						nationality: nationality,
						gender: gender,
						DOB: dob,
						NRIC: NRIC,
						race: race,
						newsletter_email: newsletter,
					};
				} else {
					var passport = $("#passport").val();

					var data = {
						full_name: full_name,
						email: email,
						mobile_no: mobile,
						nationality: nationality,
						gender: gender,
						DOB: dob,
						passport_no: passport,
						race: race,
						newsletter_email: newsletter,
					};
				}

				data.guardian_name = $("#guardian_name").val() === "" ? "" : $("#guardian_name").val();
				data.guardian_nric = $("#guardian_nric").val() === "" ? "" : $("#guardian_nric").val();
				data.guardian_relationship = $("#guardian_relationship").val() === "" ? "" : $("#guardian_relationship").val();

				var childrenArray = [];
				for (var i = 0; i < $(".sub-profiles").length; i++) {
					var profileNumber = i + 1;

					var full_name = $("#sub-profile-name" + profileNumber).val();
					var id = $("#sub-profile-bkID" + profileNumber).val();
					var dob = $("#sub-dob" + profileNumber).val();
					var gender = $("#addMale" + profileNumber).is(":checked") ? 1 : 2;
					var nationality = $("#addMalaysian" + profileNumber).is(":checked") ? 1 : 0;

					if (id == "new") {
						var race = $("#additional-race-list" + profileNumber).val();

						if (race == "others") {
							race = $("#additional-other-races" + profileNumber).val();
						}
					} else {
						var race = $("#additional-race-list" + profileNumber).val();
					}

					var childrenAttr = {
						full_name: full_name,
						id: id,
						DOB: dob,
						gender: gender,
						race: race,
						nationality: nationality,
					};

					childrenArray.push(childrenAttr);
				}
				data.children = childrenArray;

				var url = apipath + "profile";

				$.ajax({
					url: url,
					type: "POST",
					data: JSON.stringify(data),
					headers: {
						Authorization: "Bearer " + getCookie("ty_access_token"),
						"X-localization": localization,
					},
					contentType: "application/json",
					success: function (data) {
						log(data);
						window.location.href = redirectPath + "/my-profile";
						// if (originalEmail != email) {
						// 	deleteCookie('ty_access_token');

						// 	removeLoading();

						// 	window.location.href = redirectPath + '/change-email-verification';
						// } else {
						// 	removeLoading();

						// 	window.location.href = redirectPath + '/my-profile';
						// }
					},
					error: function (data) {
						var response = JSON.parse(data.responseText);

						removeLoading();

						if (response.message == "token_expired") {
							promptTokenExpired();
							$(".navLoader").css("display", "none");
						} else {
							Swal.fire({
								type: "error",
								title: localeObject[localization]["errorText"],
								text: response.message,
								animation: false,
								customClass: {
									popup: "animated fadeIn",
								},
							});
						}
					},
				});
			}
		},
	});

	if (localization == "en") {
		jQuery.extend(jQuery.validator.messages, {
			required: "This field is required.",
			remote: "Please fix this field.",
			email: "Please enter a valid email address.",
			validemail: jQuery.validator.format(
				"Please enter a valid email address."
			),
			url: "Please enter a valid URL.",
			date: "Please enter a valid date.",
			dateISO: "Please enter a valid date (ISO).",
			number: "Please enter a valid number.",
			digits: "Please enter only digits.",
			creditcard: "Please enter a valid credit card number.",
			equalTo: "Please enter the same value again.",
			validpassword: jQuery.validator.format(
				"Please enter at least 8 characters which consists of lowercase letters, uppercase letters and numerals."
			),
            accept: "Please enter a value with a valid extension.",
            mobileformat: jQuery.validator.format("Please enter a valid mobile."),
			maxlength: jQuery.validator.format(
				"Please enter no more than {0} characters."
			),
			minlength: jQuery.validator.format(
				"Please enter at least {0} characters."
			),
			rangelength: jQuery.validator.format(
				"Please enter a value between {0} and {1} characters long."
			),
			range: jQuery.validator.format(
				"Please enter a value between {0} and {1}."
			),
			max: jQuery.validator.format(
				"Please enter a value less than or equal to {0}."
			),
			min: jQuery.validator.format(
				"Please enter a value greater than or equal to {0}."
			),
			CheckDOB: "Please enter valid date format. T",
			checkDeliveryDateWeekend: "Please select weekdays only.",
			checkDeliveryDate: "Please select 1 day after today.",
		});
	} else if (localization == "ms") {
		jQuery.extend(jQuery.validator.messages, {
			required: "Ruangan ini wajib diisi.",
			remote: "Sila betulkan ruangan ini.",
			email: "Sila masukkan alamat e-mel yang sah.",
			validemail: jQuery.validator.format(
				"Sila masukkan alamat e-mel yang sah."
			),
			url: "Sila masukkan URL yang sah.",
			date: "Sila masukkan tarikh yang sah.",
			dateISO: "Sila masukkan tarikh yang sah (ISO).",
			number: "Sila masukkan nombor yang sah.",
			digits: "Sila masukkan nombor sahaja.",
			creditcard: "SIla masukkan nombor kad kredit yang sah.",
			equalTo: "Sila masukkan nilai yang sama sekali lagi.",
			validpassword: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya 8 aksara yang terdiri daripada huruf kecil, huruf besar dan angka."
			),
            accept: "Sila masukkan nilai dengan sambungan sah.",
            mobileformat: jQuery.validator.format("Sila masukkan Telefon bimbit yang sah."),
			maxlength: jQuery.validator.format(
				"Sila masukkan tidak melebihi {0} aksara."
			),
			minlength: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya {0} aksara."
			),
			rangelength: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara panjang."
			),
			range: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara."
			),
			max: jQuery.validator.format(
				"Sila masukkan nilai sekurang-kurangnya atau sama dengan {0}."
			),
			min: jQuery.validator.format(
				"Sila masukkan nilai melebihi atau sama dengan {0}."
			),
			CheckDOB: "Sila masukkan format tarikh yang sah.",
			checkDeliveryDateWeekend: "Sila pilih hari bekerja sahaja.",
			checkDeliveryDate: "Sila pilih tarikh selepas hari ini.",
		});
	} else if (localization == "zh") {
		jQuery.extend(jQuery.validator.messages, {
			required: "此为必填项.",
			remote: "请更正此项目.",
			email: "请输入有效的电邮地址.",
			validemail: jQuery.validator.format("请输入有效的电邮地址."),
			url: "请输入有效的网址.",
			date: "请输入有效的日期.",
			dateISO: "请输入有效的日期(ISO).",
			number: "请输入有效的数字.",
			digits: "请只输入号码.",
			creditcard: "请输入有效的信用卡号码.",
			equalTo: "请再次输入一样的字符串.",
			validpassword: jQuery.validator.format(
				"请输入至少8个字符，包括小写字母，大写字母和数字."
			),
            accept: "请输入拥有有效后缀名的字符串.",
            mobileformat: jQuery.validator.format("请输入有效的手机号码."),
			maxlength: jQuery.validator.format("请输入不多于 {0}个的字母."),
			minlength: jQuery.validator.format("请输入至少 {0}个的字数."),
			rangelength: jQuery.validator.format(
				"请输入一个长度介于 {0} 和 {1} 之间的字符串."
			),
			range: jQuery.validator.format("请输入一个介于 {0} 和 {1} 之间的字符串."),
			max: jQuery.validator.format("请输入一个 长度最少是 {0} 的字符串."),
			min: jQuery.validator.format("请输入一个最小为{0} 的字符串."),
			CheckDOB: "请输入有效的日期格式。",
			checkDeliveryDateWeekend: "请仅选择工作日。",
			checkDeliveryDate: "请选择今天之后的日期",
		});
	}
}

//CHANGE PASSWORD
function changePassword () {
	$.validator.addMethod(
		"validpassword",
		function (value, element) {
			// allow any non-whitespace characters as the host part
			return (
				this.optional(element) ||
				/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(value)
			);
		},
		"Please enter at least 8 characters which consists of lowercase letters, uppercase letters and numerals"
	);

	$("#changePasswordForm").validate({
		debug: true,
		focusInvalid: true,
		rules: {
			oldPassword: {
				required: true,
				minlength: 8,
			},
			password: {
				required: true,
				validpassword: true,
			},
			confirmPassword: {
				required: true,
				validpassword: true,
				equalTo: "#password",
			},
		},
		errorPlacement: function (error, element) {
			error.insertAfter(element);
		},
		invalidHandler: function (e, validator) { },
		submitHandler: function (form) {
			loading();

			var url = apipath + "change-password";

			var old_password = $("#oldPassword").val();
			var new_password = $("#password").val();
			var confirmation_password = $("#confirmPassword").val();

			var data = {
				old_password: old_password,
				new_password: new_password,
				confirmation_password: confirmation_password,
			};

			$.ajax({
				url: url,
				type: "POST",
				data: JSON.stringify(data),
				headers: {
					Authorization: "Bearer " + getCookie("ty_access_token"),
					"X-localization": localization,
				},
				contentType: "application/json", // tell jQuery not to set contentType
				success: function (data) {
					log("success");
					$(".change-password").css("display", "none");
					$(".change-password-success").css("display", "block");

					removeLoading();

					setTimeout(function () {
						window.location.href = redirectPath + "/my-profile";
					}, 5000);
				},
				error: function (data) {
					var response = JSON.parse(data.responseText);

					removeLoading();

					if (response.message == "token_expired") {
						promptTokenExpired();
						$(".navLoader").css("display", "none");
					} else {
						Swal.fire({
							type: "error",
							title: localeObject[localization]["errorText"],
							text: response.message,
							animation: false,
							customClass: {
								popup: "animated fadeIn",
							},
						});
					}
				},
				complete: function (data) {
					// console.log(data);
				},
			});
		},
	});

	if (localization == "en") {
		jQuery.extend(jQuery.validator.messages, {
			required: "This field is required.",
			remote: "Please fix this field.",
			email: "Please enter a valid email address.",
			validemail: jQuery.validator.format(
				"Please enter a valid email address."
			),
			url: "Please enter a valid URL.",
			date: "Please enter a valid date.",
			dateISO: "Please enter a valid date (ISO).",
			number: "Please enter a valid number.",
			digits: "Please enter only digits.",
			creditcard: "Please enter a valid credit card number.",
			equalTo: "Please enter the same value again.",
			validpassword: jQuery.validator.format(
				"Please enter at least 8 characters which consists of lowercase letters, uppercase letters and numerals."
			),
			accept: "Please enter a value with a valid extension.",
			maxlength: jQuery.validator.format(
				"Please enter no more than {0} characters."
			),
			minlength: jQuery.validator.format(
				"Please enter at least {0} characters."
			),
			rangelength: jQuery.validator.format(
				"Please enter a value between {0} and {1} characters long."
			),
			range: jQuery.validator.format(
				"Please enter a value between {0} and {1}."
			),
			max: jQuery.validator.format(
				"Please enter a value less than or equal to {0}."
			),
			min: jQuery.validator.format(
				"Please enter a value greater than or equal to {0}."
			),
			CheckDOB: "Please enter valid date format.",
			checkDeliveryDateWeekend: "Please select weekdays only.",
			checkDeliveryDate: "Please select 1 day after today.",
		});
	} else if (localization == "ms") {
		jQuery.extend(jQuery.validator.messages, {
			required: "Ruangan ini wajib diisi.",
			remote: "Sila betulkan ruangan ini.",
			email: "Sila masukkan alamat e-mel yang sah.",
			validemail: jQuery.validator.format(
				"Sila masukkan alamat e-mel yang sah."
			),
			url: "Sila masukkan URL yang sah.",
			date: "Sila masukkan tarikh yang sah.",
			dateISO: "Sila masukkan tarikh yang sah (ISO).",
			number: "Sila masukkan nombor yang sah.",
			digits: "Sila masukkan nombor sahaja.",
			creditcard: "SIla masukkan nombor kad kredit yang sah.",
			equalTo: "Sila masukkan nilai yang sama sekali lagi.",
			validpassword: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya 8 aksara yang terdiri daripada huruf kecil, huruf besar dan angka."
			),
			accept: "Sila masukkan nilai dengan sambungan sah.",
			maxlength: jQuery.validator.format(
				"Sila masukkan tidak melebihi {0} aksara."
			),
			minlength: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya {0} aksara."
			),
			rangelength: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara panjang."
			),
			range: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara."
			),
			max: jQuery.validator.format(
				"Sila masukkan nilai sekurang-kurangnya atau sama dengan {0}."
			),
			min: jQuery.validator.format(
				"Sila masukkan nilai melebihi atau sama dengan {0}."
			),
			CheckDOB: "Sila masukkan format tarikh yang sah.",
			checkDeliveryDateWeekend: "Sila pilih hari bekerja sahaja.",
			checkDeliveryDate: "Sila pilih tarikh selepas hari ini.",
		});
	} else if (localization == "zh") {
		jQuery.extend(jQuery.validator.messages, {
			required: "此为必填项.",
			remote: "请更正此项目.",
			email: "请输入有效的电邮地址.",
			validemail: jQuery.validator.format("请输入有效的电邮地址."),
			url: "请输入有效的网址.",
			date: "请输入有效的日期.",
			dateISO: "请输入有效的日期(ISO).",
			number: "请输入有效的数字.",
			digits: "请只输入号码.",
			creditcard: "请输入有效的信用卡号码.",
			equalTo: "请再次输入一样的字符串.",
			validpassword: jQuery.validator.format(
				"请输入至少8个字符，包括小写字母，大写字母和数字."
			),
			accept: "请输入拥有有效后缀名的字符串.",
			maxlength: jQuery.validator.format("请输入不多于 {0}个的字母."),
			minlength: jQuery.validator.format("请输入至少 {0}个的字数."),
			rangelength: jQuery.validator.format(
				"请输入一个长度介于 {0} 和 {1} 之间的字符串."
			),
			range: jQuery.validator.format("请输入一个介于 {0} 和 {1} 之间的字符串."),
			max: jQuery.validator.format("请输入一个 长度最少是 {0} 的字符串."),
			min: jQuery.validator.format("请输入一个最小为{0} 的字符串."),
			CheckDOB: "请输入有效的日期格式。",
			checkDeliveryDateWeekend: "请仅选择工作日。",
			checkDeliveryDate: "请选择今天之后的日期",
		});
	}
}

//ADD PASSWORD
function addPassword () {
	$.validator.addMethod(
		"validpassword",
		function (value, element) {
			// allow any non-whitespace characters as the host part
			return (
				this.optional(element) ||
				/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(value)
			);
		},
		"Please enter at least 8 characters which consists of lowercase letters, uppercase letters and numerals"
	);

	$("#addPasswordForm").validate({
		debug: true,
		focusInvalid: true,
		rules: {
			password: {
				required: true,
				validpassword: true,
			},
			confirmPassword: {
				required: true,
				validpassword: true,
				equalTo: "#password",
			},
		},
		errorPlacement: function (error, element) {
			error.insertAfter(element);
		},
		invalidHandler: function (e, validator) { },
		submitHandler: function (form) {
			loading();

			var url = apipath + "add-password";

			var new_password = $("#password").val();
			var confirmation_password = $("#confirmPassword").val();

			var data = {
				new_password: new_password,
				confirmation_password: confirmation_password,
			};

			$.ajax({
				url: url,
				type: "POST",
				data: JSON.stringify(data),
				headers: {
					Authorization: "Bearer " + getCookie("ty_access_token"),
					"X-localization": localization,
				},
				contentType: "application/json", // tell jQuery not to set contentType
				success: function (data) {
					log("success");
					$(".change-password").css("display", "none");
					$(".change-password-success").css("display", "block");

					removeLoading();

					setTimeout(function () {
						window.location.href = redirectPath + "/my-profile";
					}, 5000);
				},
				error: function (data) {
					var response = JSON.parse(data.responseText);

					removeLoading();

					if (response.message == "token_expired") {
						promptTokenExpired();
						$(".navLoader").css("display", "none");
					} else {
						Swal.fire({
							type: "error",
							title: localeObject[localization]["errorText"],
							text: response.message,
							animation: false,
							customClass: {
								popup: "animated fadeIn",
							},
						});
					}
				},
				complete: function (data) {
					// console.log(data);
				},
			});
		},
	});

	if (localization == "en") {
		jQuery.extend(jQuery.validator.messages, {
			required: "This field is required.",
			remote: "Please fix this field.",
			email: "Please enter a valid email address.",
			validemail: jQuery.validator.format(
				"Please enter a valid email address."
			),
			url: "Please enter a valid URL.",
			date: "Please enter a valid date.",
			dateISO: "Please enter a valid date (ISO).",
			number: "Please enter a valid number.",
			digits: "Please enter only digits.",
			creditcard: "Please enter a valid credit card number.",
			equalTo: "Please enter the same value again.",
			validpassword: jQuery.validator.format(
				"Please enter at least 8 characters which consists of lowercase letters, uppercase letters and numerals."
			),
			accept: "Please enter a value with a valid extension.",
			maxlength: jQuery.validator.format(
				"Please enter no more than {0} characters."
			),
			minlength: jQuery.validator.format(
				"Please enter at least {0} characters."
			),
			rangelength: jQuery.validator.format(
				"Please enter a value between {0} and {1} characters long."
			),
			range: jQuery.validator.format(
				"Please enter a value between {0} and {1}."
			),
			max: jQuery.validator.format(
				"Please enter a value less than or equal to {0}."
			),
			min: jQuery.validator.format(
				"Please enter a value greater than or equal to {0}."
			),
			CheckDOB: "Please enter valid date format.",
			checkDeliveryDateWeekend: "Please select weekdays only.",
			checkDeliveryDate: "Please select 1 day after today.",
		});
	} else if (localization == "ms") {
		jQuery.extend(jQuery.validator.messages, {
			required: "Ruangan ini wajib diisi.",
			remote: "Sila betulkan ruangan ini.",
			email: "Sila masukkan alamat e-mel yang sah.",
			validemail: jQuery.validator.format(
				"Sila masukkan alamat e-mel yang sah."
			),
			url: "Sila masukkan URL yang sah.",
			date: "Sila masukkan tarikh yang sah.",
			dateISO: "Sila masukkan tarikh yang sah (ISO).",
			number: "Sila masukkan nombor yang sah.",
			digits: "Sila masukkan nombor sahaja.",
			creditcard: "SIla masukkan nombor kad kredit yang sah.",
			equalTo: "Sila masukkan nilai yang sama sekali lagi.",
			validpassword: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya 8 aksara yang terdiri daripada huruf kecil, huruf besar dan angka."
			),
			accept: "Sila masukkan nilai dengan sambungan sah.",
			maxlength: jQuery.validator.format(
				"Sila masukkan tidak melebihi {0} aksara."
			),
			minlength: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya {0} aksara."
			),
			rangelength: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara panjang."
			),
			range: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara."
			),
			max: jQuery.validator.format(
				"Sila masukkan nilai sekurang-kurangnya atau sama dengan {0}."
			),
			min: jQuery.validator.format(
				"Sila masukkan nilai melebihi atau sama dengan {0}."
			),
			CheckDOB: "Sila masukkan format tarikh yang sah.",
			checkDeliveryDateWeekend: "Sila pilih hari bekerja sahaja.",
			checkDeliveryDate: "Sila pilih tarikh selepas hari ini.",
		});
	} else if (localization == "zh") {
		jQuery.extend(jQuery.validator.messages, {
			required: "此为必填项.",
			remote: "请更正此项目.",
			email: "请输入有效的电邮地址.",
			validemail: jQuery.validator.format("请输入有效的电邮地址."),
			url: "请输入有效的网址.",
			date: "请输入有效的日期.",
			dateISO: "请输入有效的日期(ISO).",
			number: "请输入有效的数字.",
			digits: "请只输入号码.",
			creditcard: "请输入有效的信用卡号码.",
			equalTo: "请再次输入一样的字符串.",
			validpassword: jQuery.validator.format(
				"请输入至少8个字符，包括小写字母，大写字母和数字."
			),
			accept: "请输入拥有有效后缀名的字符串.",
			maxlength: jQuery.validator.format("请输入不多于 {0}个的字母."),
			minlength: jQuery.validator.format("请输入至少 {0}个的字数."),
			rangelength: jQuery.validator.format(
				"请输入一个长度介于 {0} 和 {1} 之间的字符串."
			),
			range: jQuery.validator.format("请输入一个介于 {0} 和 {1} 之间的字符串."),
			max: jQuery.validator.format("请输入一个 长度最少是 {0} 的字符串."),
			min: jQuery.validator.format("请输入一个最小为{0} 的字符串."),
			CheckDOB: "请输入有效的日期格式。",
			checkDeliveryDateWeekend: "请仅选择工作日。",
			checkDeliveryDate: "请选择今天之后的日期",
		});
	}
}

//FACEBOOK BIND
function fb_bindProfile () {
	FB.login(
		function (response) {
			if (response.authResponse) {
				log("Welcome!  Binding your information.... ");
				//console.log(response); // dump complete info
				var access_token = response.authResponse.accessToken; //get access token
				var user_id = response.authResponse.userID; //get FB UID

				FB.api("/me", { locale: "en_US", fields: "id,name,email" }, function (
					responseAPI
				) {
					setCookie("user_email", responseAPI.email, 1);
				});

				bindFacebookAPI(access_token);
			} else {
				//user hit cancel button
				log("User cancelled login or did not fully authorize.");
			}
		},
		{
			scope: "email",
		}
	);
}

function bindFacebookAPI (access_token) {
	var url = apipath + "bind-socialmedia";
	var data = { access_token: access_token, method: 1, country: country };

	$.ajax({
		url: url,
		type: "POST",
		headers: {
			Authorization: "Bearer " + getCookie("ty_access_token"),
			"X-localization": localization,
		},
		data: JSON.stringify(data),
		contentType: "application/json", // tell jQuery not to set contentType
		success: function (data) {
			var errorTitle = "";
			var buttontext = "";

			if (localization == "en") {
				errorTitle = "Bind successfully";
				buttontext = "Go to profile";
			} else if (localization == "ms") {
				errorTitle = "Pautan Berjaya";
				buttontext = "Pergi ke profil";
			} else if (localization == "zh") {
				errorTitle = "成功绑定";
				buttontext = "回到个人资料​";
			}

			Swal.fire({
				title: errorTitle,
				text: data.message,
				type: "success",
				animation: false,
				customClass: {
					popup: "animated fadeIn",
				},
				showCancelButton: false,
				confirmButtonColor: "#3085d6",
				confirmButtonText: buttontext,
			}).then(function (results) {
				window.location.href = redirectPath + "/my-profile";
			});
		},
		error: function (data) {
			var response = JSON.parse(data.responseText);
			log(response.message);

			if (response.message == "token_expired") {
				promptTokenExpired();
				$(".navLoader").css("display", "none");
			} else {
				Swal.fire({
					type: "error",
					title: localeObject[localization]["errorText"],
					text: response.message,
					animation: false,
					customClass: {
						popup: "animated fadeIn",
					},
				});
			}
		},
		complete: function (data) {
			// console.log(data);
		},
	});

	return response;
}

//BIND GOOGLE
function onEditGoogleCallback () {
	var auth2, element;
	gapi.load("auth2", function () {
		auth2 = gapi.auth2.init({
			client_id: googleID,
			// cookiepolicy: 'single_host_origin',
			scope: "profile",
		});

		auth2.attachClickHandler(
			element,
			{},
			function (googleUser) {
				setCookie("user_email", googleUser.getBasicProfile().getEmail(), 1);
				log(getCookie("user_email"));
				// The ID token you need to pass to your backend:
				var id_token = googleUser.getAuthResponse().access_token;
				log("Edit ID Token: " + id_token);

				bindGoogleAPI(id_token);
			},
			function (error) {
				log("Sign-in error", error);
			}
		);
	});

	element = document.getElementById("googleSignIn");
}

function bindGoogleAPI (access_token) {
	var url = apipath + "bind-socialmedia";
	var data = { access_token: access_token, method: 2, country: country };

	$.ajax({
		url: url,
		type: "POST",
		headers: {
			Authorization: "Bearer " + getCookie("ty_access_token"),
			"X-localization": localization,
		},
		data: JSON.stringify(data),
		contentType: "application/json", // tell jQuery not to set contentType
		success: function (data) {
			var errorTitle = "";
			var buttontext = "";

			if (localization == "en") {
				errorTitle = "Bind successfully";
				buttontext = "Go to profile";
			} else if (localization == "ms") {
				errorTitle = "Pautan Berjaya";
				buttontext = "Pergi ke profil";
			} else if (localization == "zh") {
				errorTitle = "成功绑定";
				buttontext = "回到个人资料​";
			}

			Swal.fire({
				title: errorTitle,
				text: data.message,
				type: "success",
				animation: false,
				customClass: {
					popup: "animated fadeIn",
				},
				showCancelButton: false,
				confirmButtonColor: "#3085d6",
				confirmButtonText: buttontext,
			}).then(function (results) {
				window.location.href = redirectPath + "/my-profile";
			});
		},
		error: function (data) {
			var response = JSON.parse(data.responseText);
			// // alert(response.message);
			if (response.message == "token_expired") {
				promptTokenExpired();
				$(".navLoader").css("display", "none");
			} else {
				Swal.fire({
					type: "error",
					title: localeObject[localization]["errorText"],
					text: response.message,
					animation: false,
					customClass: {
						popup: "animated fadeIn",
					},
				});
			}
		},
		complete: function (data) {
			// console.log(data);
		},
	});
}

//UNBIND SOCIAL MEDIA
function unbindSocialMedia (method) {
	var url = apipath + "unbind-socialmedia";
	var data = { method: method };

	$.ajax({
		url: url,
		type: "POST",
		headers: {
			Authorization: "Bearer " + getCookie("ty_access_token"),
			"X-localization": localization,
		},
		data: JSON.stringify(data),
		contentType: "application/json", // tell jQuery not to set contentType
		success: function (data) {
			var errorTitle = "";
			var buttontext = "";

			if (localization == "en") {
				errorTitle = "Unbind successfully";
				buttontext = "Go to profile";
			} else if (localization == "ms") {
				errorTitle = "Berjaya memutus akaun";
				buttontext = "Pergi ke profil";
			} else if (localization == "zh") {
				errorTitle = "解除绑定成功";
				buttontext = "回到个人资料​";
			}

			Swal.fire({
				title: errorTitle,
				text: data.message,
				type: "success",
				animation: false,
				customClass: {
					popup: "animated fadeIn",
				},
				showCancelButton: false,
				confirmButtonColor: "#3085d6",
				confirmButtonText: buttontext,
			}).then(function (results) {
				window.location.href = redirectPath + "/my-profile";
			});
		},
		error: function (data) {
			var response = JSON.parse(data.responseText);
			// alert(response.message);

			if (response.message == "token_expired") {
				promptTokenExpired();
				$(".navLoader").css("display", "none");
			} else {
				Swal.fire({
					type: "error",
					title: localeObject[localization]["errorText"],
					text: response.message,
					animation: false,
					customClass: {
						popup: "animated fadeIn",
					},
				});
			}
		},
		complete: function (data) {
			// console.log(data);
		},
	});
}

//iElken BIND
function bindiElken() {
    $("#iElken-form").validate({
        debug: true,
        focusInvalid: true,
        rules: {
            member_id: {
                required: true,
            },
            password: {
                required: true,
            }
        },
        errorPlacement: function (error, element) {
            error.insertAfter(element);
        },
        invalidHandler: function (e, validator) {

        },
        submitHandler: function (form) {
        	loading();

            var member_id = $('#member_id').val();
            var password  = $('#password').val();

            var url = apipath + 'bind-socialmedia';
            var data = {'member_id':member_id, 'password':password, "method":3, 'country':country};

            $.ajax({
                url : url,
                type: 'POST',
				data: JSON.stringify(data),
				headers: { Authorization: 'Bearer ' + getCookie('ty_access_token'), 'X-localization': localization },
				contentType: 'application/json',
                success : function(data) {
                	removeLoading();

                    var errorTitle = '';
					var buttontext = '';

                    if (localization == "en") {
                        errorTitle = "Bind successfully";
                        buttontext = "Go to profile";
                    } else if (localization == "ms") {
                        errorTitle = "Pautan Berjaya";
                        buttontext = "Pergi ke profil";
                    } else if (localization == "zh") {
                        errorTitle = "成功绑定";
                        buttontext = "回到个人资料​";
                    }

					Swal.fire({
						title: errorTitle,
						text: data.message,
						type: "success",
						animation: false,
						customClass: {
							popup: "animated fadeIn",
						},
						showCancelButton: false,
						confirmButtonColor: "#3085d6",
						confirmButtonText: buttontext,
					}).then(function (results) {
						window.location.href = redirectPath + "/my-profile";
					});
				},
				error: function (data) {
					var response = JSON.parse(data.responseText);

					removeLoading();

					if (response.message == "token_expired") {
						promptTokenExpired();
						$(".navLoader").css("display", "none");
					} else {
						Swal.fire({
							type: "error",
							title: localeObject[localization]["errorText"],
							text: response.message,
							animation: false,
							customClass: {
								popup: "animated fadeIn",
							},
						});
					}
				},
				complete: function (data) {
					// console.log(data);
				},
			});
		},
	});
}

//ClassisElken BIND
function bindClassicElken() {
    $("#classic-elken-form").validate({
        debug: true,
        focusInvalid: true,
        rules: {
            member_id: {
                required: true,
            },
            password: {
                required: true,
            }
        },
        errorPlacement: function (error, element) {
            error.insertAfter(element);
        },
        invalidHandler: function (e, validator) {

        },
        submitHandler: function (form) {
        	loading();

            var member_id = $('#classic_member_id').val();
            var password  = $('#classic_password').val();

            var url = apipath + 'bind-socialmedia';
            var data = {'member_id':member_id, 'password':password, "method":4, 'country':country};

            $.ajax({
                url : url,
                type: 'POST',
				headers: { Authorization: 'Bearer ' + getCookie('ty_access_token'), 'X-localization': localization },
				data: JSON.stringify(data),
				contentType: 'application/json', // tell jQuery not to set contentType
                success : function(data) {
                	removeLoading();
                	log(data);
                    var errorTitle = '';
					var buttontext = '';

                    if (localization == "en") {
                        errorTitle = "Bind successfully";
                        buttontext = "Go to profile";
                    } else if (localization == "ms") {
                        errorTitle = "Pautan Berjaya";
                        buttontext = "Pergi ke profil";
                    } else if (localization == "zh") {
                        errorTitle = "成功绑定";
                        buttontext = "回到个人资料​";
                    }

					Swal.fire({
						title: errorTitle,
						text: data.message,
						type: "success",
						animation: false,
						customClass: {
							popup: "animated fadeIn",
						},
						showCancelButton: false,
						confirmButtonColor: "#3085d6",
						confirmButtonText: buttontext,
					}).then(function (results) {
						window.location.href = redirectPath + "/my-profile";
					});
				},
				error: function (data) {
					var response = JSON.parse(data.responseText);

					removeLoading();

					if (response.message == "token_expired") {
						promptTokenExpired();
						$(".navLoader").css("display", "none");
					} else {
						Swal.fire({
							type: "error",
							title: localeObject[localization]["errorText"],
							text: response.message,
							animation: false,
							customClass: {
								popup: "animated fadeIn",
							},
						});
					}
				},
				complete: function (data) {
					// console.log(data);
				},
			});
		},
	});
}

//NOTIFICATION
function loadNotification () {
	$(".loader").show();

	var url = apipath + "notification?page=" + notificationPage;

	$.ajax({
		url: url,
		type: "GET",
		headers: {
			Authorization: "Bearer " + getCookie("ty_access_token"),
			"X-localization": localization,
		},
		contentType: "application/json",
		success: function (data) {
			var html = $(".notification-list").html();

			for (var i = 0; i < data.data.length; i++) {
                var notification = data.data[i];

				if (notification.is_incomplete_testkit == 1)
					html += "<a href=" + baseUrl + smallLetterCountry + "/" + localization + "/status-tracker>";

				if (notification.is_read == 0) {
					html += '<div class="notices new-notification">';
				} else {
					html += '<div class="notices">';
				}

				html += '<div class="title">' + notification.notification_trans + "</div>";
				html += '<div class="info">' + notification.created_at + "</div>";
				html += "</div>";

                if (notification.is_incomplete_testkit == 1)
                    html += "</a>";
			}

			notificationPage = notificationPage + 1;

			$(".notification-list").html(html);
			$("html, body").animate(
				{ scrollTop: $("#load-more-btn").offset().top },
				800
			);
			$(".loader").hide();

			if (!data.next_page_url) {
				$("#load-more-btn").css({
					border: "none",
					"pointer-events": "none",
				});

				if (localization == "en") {
					$("#load-more-btn").text("You have " + $(".notices").length + " notifications.").prop("disabled", true);
				} else if (localization == "ms") {
					$("#load-more-btn").text("Anda ada " + $(".notices").length + "notifikasi.").prop("disabled", true);
				} else if (localization == "zh") {
					$("#load-more-btn").text("您有" + $(".notices").length + "通知。").prop("disabled", true);
				}
			}
		},
		error: function (data) {
			var response = JSON.parse(data.responseText);

			if (response.message == "token_expired") {
				promptTokenExpired();
				$(".navLoader").css("display", "none");
			}
		},
	});
}

//FORGOT PASSWORD
function forgotPassword () {
	$.validator.addMethod(
		"validemail",
		function (value, element) {
			// allow any non-whitespace characters as the host part
			return (
				this.optional(element) ||
				/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
					value
				)
			);
		},
		"Please enter a valid email."
	);

	$("#forgotPasswordForm").validate({
		debug: true,
		focusInvalid: true,
		rules: {
			email: {
				required: true,
				email: true,
				validemail: true,
			},
		},
		errorPlacement: function (error, element) {
			error.insertAfter(element);
		},
		invalidHandler: function (e, validator) { },
		submitHandler: function (form) {
			loading();

			var url = apipath + "forget-password";
			var data = {
				email: $("#email").val(),
				country: country,
				organization_id: organization_id,
			};

			$.ajax({
				url: url,
				type: "POST",
				headers: { "X-localization": localization },
				data: JSON.stringify(data),
				contentType: "application/json", // tell jQuery not to set contentType
				success: function (data) {
					log("success");

					removeLoading();

					$(".forgot-password-confirmation").css("display", "block");
					$(".forgot-password-copy").css("display", "none");
					$("#forgotPasswordForm").css("display", "none");
				},
				error: function (data) {
					var response = JSON.parse(data.responseText);

					removeLoading();

					Swal.fire({
						type: "error",
						title: localeObject[localization]["errorText"],
						text: response.message,
						animation: false,
						customClass: {
							popup: "animated fadeIn",
						},
					});
				},
				complete: function (data) {
					// console.log(data);
				},
			});
		},
	});

	if (localization == "en") {
		jQuery.extend(jQuery.validator.messages, {
			required: "This field is required.",
			remote: "Please fix this field.",
			email: "Please enter a valid email address.",
			validemail: jQuery.validator.format(
				"Please enter a valid email address."
			),
			url: "Please enter a valid URL.",
			date: "Please enter a valid date.",
			dateISO: "Please enter a valid date (ISO).",
			number: "Please enter a valid number.",
			digits: "Please enter only digits.",
			creditcard: "Please enter a valid credit card number.",
			equalTo: "Please enter the same value again.",
			validpassword: jQuery.validator.format(
				"Please enter at least 8 characters which consists of lowercase letters, uppercase letters and numerals."
			),
			accept: "Please enter a value with a valid extension.",
			maxlength: jQuery.validator.format(
				"Please enter no more than {0} characters."
			),
			minlength: jQuery.validator.format(
				"Please enter at least {0} characters."
			),
			rangelength: jQuery.validator.format(
				"Please enter a value between {0} and {1} characters long."
			),
			range: jQuery.validator.format(
				"Please enter a value between {0} and {1}."
			),
			max: jQuery.validator.format(
				"Please enter a value less than or equal to {0}."
			),
			min: jQuery.validator.format(
				"Please enter a value greater than or equal to {0}."
			),
			CheckDOB: "Please enter valid date format.",
			checkDeliveryDateWeekend: "Please select weekdays only.",
			checkDeliveryDate: "Please select 1 day after today.",
		});
	} else if (localization == "ms") {
		jQuery.extend(jQuery.validator.messages, {
			required: "Ruangan ini wajib diisi.",
			remote: "Sila betulkan ruangan ini.",
			email: "Sila masukkan alamat e-mel yang sah.",
			validemail: jQuery.validator.format(
				"Sila masukkan alamat e-mel yang sah."
			),
			url: "Sila masukkan URL yang sah.",
			date: "Sila masukkan tarikh yang sah.",
			dateISO: "Sila masukkan tarikh yang sah (ISO).",
			number: "Sila masukkan nombor yang sah.",
			digits: "Sila masukkan nombor sahaja.",
			creditcard: "SIla masukkan nombor kad kredit yang sah.",
			equalTo: "Sila masukkan nilai yang sama sekali lagi.",
			validpassword: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya 8 aksara yang terdiri daripada huruf kecil, huruf besar dan angka."
			),
			accept: "Sila masukkan nilai dengan sambungan sah.",
			maxlength: jQuery.validator.format(
				"Sila masukkan tidak melebihi {0} aksara."
			),
			minlength: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya {0} aksara."
			),
			rangelength: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara panjang."
			),
			range: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara."
			),
			max: jQuery.validator.format(
				"Sila masukkan nilai sekurang-kurangnya atau sama dengan {0}."
			),
			min: jQuery.validator.format(
				"Sila masukkan nilai melebihi atau sama dengan {0}."
			),
			CheckDOB: "Sila masukkan format tarikh yang sah.",
			checkDeliveryDateWeekend: "Sila pilih hari bekerja sahaja.",
			checkDeliveryDate: "Sila pilih tarikh selepas hari ini.",
		});
	} else if (localization == "zh") {
		jQuery.extend(jQuery.validator.messages, {
			required: "此为必填项.",
			remote: "请更正此项目.",
			email: "请输入有效的电邮地址.",
			validemail: jQuery.validator.format("请输入有效的电邮地址."),
			url: "请输入有效的网址.",
			date: "请输入有效的日期.",
			dateISO: "请输入有效的日期(ISO).",
			number: "请输入有效的数字.",
			digits: "请只输入号码.",
			creditcard: "请输入有效的信用卡号码.",
			equalTo: "请再次输入一样的字符串.",
			validpassword: jQuery.validator.format(
				"请输入至少8个字符，包括小写字母，大写字母和数字."
			),
			accept: "请输入拥有有效后缀名的字符串.",
			maxlength: jQuery.validator.format("请输入不多于 {0}个的字母."),
			minlength: jQuery.validator.format("请输入至少 {0}个的字数."),
			rangelength: jQuery.validator.format(
				"请输入一个长度介于 {0} 和 {1} 之间的字符串."
			),
			range: jQuery.validator.format("请输入一个介于 {0} 和 {1} 之间的字符串."),
			max: jQuery.validator.format("请输入一个 长度最少是 {0} 的字符串."),
			min: jQuery.validator.format("请输入一个最小为{0} 的字符串."),
			CheckDOB: "请输入有效的日期格式。",
			checkDeliveryDateWeekend: "请仅选择工作日。",
			checkDeliveryDate: "请选择今天之后的日期",
		});
	}
}

//RESET PASSWORD
function resetPassword () {
	$.validator.addMethod(
		"validpassword",
		function (value, element) {
			// allow any non-whitespace characters as the host part
			return (
				this.optional(element) ||
				/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(value)
			);
		},
		"Please enter at least 8 characters which consists of lowercase letters, uppercase letters and numerals"
	);

	$("#passwordResetForm").validate({
		debug: true,
		focusInvalid: true,
		rules: {
			password: {
				required: true,
				validpassword: true,
			},
			confirmPassword: {
				required: true,
				validpassword: true,
				equalTo: "#password",
			},
		},
		errorPlacement: function (error, element) {
			error.insertAfter(element);
		},
		invalidHandler: function (e, validator) { },
		submitHandler: function (form) {
			loading();

			var urlParams = new URLSearchParams(window.location.search);

			var url = apipath + "reset-password";
			var data = {
				token: urlParams.get("token"),
				password: $("#password").val(),
				confirmation_password: $("#confirmPassword").val(),
				country: country,
			};

			$.ajax({
				url: url,
				type: "POST",
				data: JSON.stringify(data),
				contentType: "application/json", // tell jQuery not to set contentType
				success: function (data) {
					log("success");

					$(".reset-password-confirmation").css("display", "block");
					$(".reset-password-copy").css("display", "none");
					$("#passwordResetForm").css("display", "none");
					$(".proceed-login-btn").css("display", "flex");

					removeLoading();
				},
				error: function (data) {
					var response = JSON.parse(data.responseText);

					removeLoading();

					Swal.fire({
						type: "error",
						title: localeObject[localization]["errorText"],
						text: response.message,
						animation: false,
						customClass: {
							popup: "animated fadeIn",
						},
					});
				},
				complete: function(data) {
					// console.log(data);
				},
			});
		},
	});

	if (localization == "en") {
		jQuery.extend(jQuery.validator.messages, {
			required: "This field is required.",
			remote: "Please fix this field.",
			email: "Please enter a valid email address.",
			validemail: jQuery.validator.format(
				"Please enter a valid email address."
			),
			url: "Please enter a valid URL.",
			date: "Please enter a valid date.",
			dateISO: "Please enter a valid date (ISO).",
			number: "Please enter a valid number.",
			digits: "Please enter only digits.",
			creditcard: "Please enter a valid credit card number.",
			equalTo: "Please enter the same value again.",
			validpassword: jQuery.validator.format(
				"Please enter at least 8 characters which consists of lowercase letters, uppercase letters and numerals."
			),
			accept: "Please enter a value with a valid extension.",
			maxlength: jQuery.validator.format(
				"Please enter no more than {0} characters."
			),
			minlength: jQuery.validator.format(
				"Please enter at least {0} characters."
			),
			rangelength: jQuery.validator.format(
				"Please enter a value between {0} and {1} characters long."
			),
			range: jQuery.validator.format(
				"Please enter a value between {0} and {1}."
			),
			max: jQuery.validator.format(
				"Please enter a value less than or equal to {0}."
			),
			min: jQuery.validator.format(
				"Please enter a value greater than or equal to {0}."
			),
			CheckDOB: "Please enter valid date format.",
			checkDeliveryDateWeekend: "Please select weekdays only.",
			checkDeliveryDate: "Please select 1 day after today.",
		});
	} else if (localization == "ms") {
		jQuery.extend(jQuery.validator.messages, {
			required: "Ruangan ini wajib diisi.",
			remote: "Sila betulkan ruangan ini.",
			email: "Sila masukkan alamat e-mel yang sah.",
			validemail: jQuery.validator.format(
				"Sila masukkan alamat e-mel yang sah."
			),
			url: "Sila masukkan URL yang sah.",
			date: "Sila masukkan tarikh yang sah.",
			dateISO: "Sila masukkan tarikh yang sah (ISO).",
			number: "Sila masukkan nombor yang sah.",
			digits: "Sila masukkan nombor sahaja.",
			creditcard: "SIla masukkan nombor kad kredit yang sah.",
			equalTo: "Sila masukkan nilai yang sama sekali lagi.",
			validpassword: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya 8 aksara yang terdiri daripada huruf kecil, huruf besar dan angka."
			),
			accept: "Sila masukkan nilai dengan sambungan sah.",
			maxlength: jQuery.validator.format(
				"Sila masukkan tidak melebihi {0} aksara."
			),
			minlength: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya {0} aksara."
			),
			rangelength: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara panjang."
			),
			range: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara."
			),
			max: jQuery.validator.format(
				"Sila masukkan nilai sekurang-kurangnya atau sama dengan {0}."
			),
			min: jQuery.validator.format(
				"Sila masukkan nilai melebihi atau sama dengan {0}."
			),
			CheckDOB: "Sila masukkan format tarikh yang sah.",
			checkDeliveryDateWeekend: "Sila pilih hari bekerja sahaja.",
			checkDeliveryDate: "Sila pilih tarikh selepas hari ini.",
		});
	} else if (localization == "zh") {
		jQuery.extend(jQuery.validator.messages, {
			required: "此为必填项.",
			remote: "请更正此项目.",
			email: "请输入有效的电邮地址.",
			validemail: jQuery.validator.format("请输入有效的电邮地址."),
			url: "请输入有效的网址.",
			date: "请输入有效的日期.",
			dateISO: "请输入有效的日期(ISO).",
			number: "请输入有效的数字.",
			digits: "请只输入号码.",
			creditcard: "请输入有效的信用卡号码.",
			equalTo: "请再次输入一样的字符串.",
			validpassword: jQuery.validator.format(
				"请输入至少8个字符，包括小写字母，大写字母和数字."
			),
			accept: "请输入拥有有效后缀名的字符串.",
			maxlength: jQuery.validator.format("请输入不多于 {0}个的字母."),
			minlength: jQuery.validator.format("请输入至少 {0}个的字数."),
			rangelength: jQuery.validator.format(
				"请输入一个长度介于 {0} 和 {1} 之间的字符串."
			),
			range: jQuery.validator.format("请输入一个介于 {0} 和 {1} 之间的字符串."),
			max: jQuery.validator.format("请输入一个 长度最少是 {0} 的字符串."),
			min: jQuery.validator.format("请输入一个最小为{0} 的字符串."),
			CheckDOB: "请输入有效的日期格式。",
			checkDeliveryDateWeekend: "请仅选择工作日。",
			checkDeliveryDate: "请选择今天之后的日期",
		});
	}
}

function getLatestTestkit () {
	loading();

	var url = apipath + "testkit";

	$.ajax({
		url: url,
		type: 'GET',
		headers: { Authorization: 'Bearer ' + getCookie('ty_access_token'), 'X-localization': localization },
		contentType: 'application/json', // tell jQuery not to set contentType
		success: function(data) {
			$('.testkit-success-consultant').hide();
            $('.testkit-success-home').show();

            if(data.length >= 1){
                var testkitInfo2 = data[0];
                if(testkitInfo2.is_completed){
                    setCookie('ty_addon', true, 1);
                }
            }

			if(data.length > 1){
                var testkitInfo = data[0];
				var product_type = testkitInfo.product_type;
				var containBasic = product_type.indexOf("basic");
				var containAddon = product_type.indexOf("addon");
				var containConsultation = product_type.indexOf("consultation");

				if(containBasic == -1){
					if(containAddon !== -1){
						$('#submitkit-tq').html(localeObject[localization]['submitkit_tq_addon']);
						$('#submitkit-tq-moduletype').html(localeObject[localization]['submitkit_tq_type_addon']);
						$('.testkit-success-consultant').hide();
						$('.testkit-success-home').show();
					}
					else if(containConsultation !== -1){
						$('#submitkit-tq').html(localeObject[localization]['submitkit_tq_consultant']);
						$('#submitkit-tq-moduletype').html(localeObject[localization]['submitkit_tq_type_consultant']);
						$('.testkit-success-consultant').show();
						$('.testkit-success-home').hide();
                    }
				}
            }

			removeLoading();
		},
		error: function (data) {
			var response = JSON.parse(data.responseText);

			removeLoading();

			if (response.message == "token_expired") {
				promptTokenExpired();
				$(".navLoader").css("display", "none");
			} else {
				Swal.fire({
					type: "error",
					title: localeObject[localization]["errorText"],
					text: response.message,
					animation: false,
					customClass: {
						popup: "animated fadeIn",
					},
				});
			}
		},
		complete: function (data) {
			// console.log(data);
		},
	});
}

function getAllTestkit () {
	loading();

	var url = apipath + "testkit";

	$.ajax({
		url: url,
		type: "GET",
		headers: {
			Authorization: "Bearer " + getCookie("ty_access_token"),
			"X-localization": localization,
		},
		contentType: "application/json", // tell jQuery not to set contentType
		success: function (data) {
			var completedTestKit = [];
			var incompletedTestKit = [];

			for (var i = 0; i < data.length; i++) {
                if (data[i].is_completed == 0)
                    incompletedTestKit.push(data[i]);
                else
                completedTestKit.push(data[i]);
			}

			//For button purpose
			if (completedTestKit.length == 0 && incompletedTestKit.length == 0) {
				$(".register-testkit-btn").css("display", "flex");
			} else {
				$(".register-testkit-btn").css("display", "none");
			}

			if (completedTestKit.length != 0) {
				var html = "";

				for (var i = 0; i < completedTestKit.length; i++) {
					var testkitInfo = completedTestKit[i];

					var step1 = "unchecked";
					var step2 = "unchecked";
					var step3 = "unchecked";
					var step4 = "unchecked";

					if (testkitInfo.testee_status == 1) {
						step1 = "checked";
					} else if (testkitInfo.testee_status == 2) {
						step1 = "completed";
						step2 = "checked";
					} else if (testkitInfo.testee_status == 3) {
						step1 = "completed";
						step2 = "completed";
						step3 = "checked";
					} else if (testkitInfo.testee_status == 4) {
						step1 = "completed";
						step2 = "completed";
						step3 = "completed";
						step4 = "completed";
					}

					var count = i + 1;

					html += '<li class="accordion-item" data-accordion-item>';
					html += '<a href="#" class="accordion-title">' + testkitInfo.user.full_name + "<br><span>" + testkitInfo.product_id + "</span></a>";
					html += '<div class="accordion-content" data-tab-content>';

					// Step icon start
					if (testkitInfo.product_type.indexOf("basic") !== -1) {
						html += '<div class="status-icon row">';
						html += '<div class="dashed-lines"></div>';
						html += '<div class="stage-1 small-3 columns">';
						html += '<div class="icon ' + step1 + '"></div>';
						html += "<p>" + localeObject[localization]["st_registered_succesfully"] + "</p>";
						html += "</div>";
						html += '<div class="stage-2 small-3 columns">';
						html += '<div class="icon ' + step2 + '"></div>';
						html += "<p>" + localeObject[localization]["st_received_lab"] + "</p>";
						html += "</div>";
						html += '<div class="stage-3 small-3 columns">';
						html += '<div class="icon ' + step3 + '"></div>';
						html += "<p>" + localeObject[localization]["st_analysis_in_progress"] + "</p>";
						html += "</div>";
						html += '<div class="stage-4 small-3 columns">';
						html += '<div class="icon ' + step4 + '"></div>';
						html += "<p>" + localeObject[localization]["st_completed"] + "</p>";
						html += "</div>";
						html += "</div>";
					}
					// Step icon end

					html += '<ul class="print-status-input">';
					html += '<li class="row">';
					html += '<div class="medium-6 columns">' + localeObject[localization]["st_name"] + "</div>";
					html += '<div id="print-name-' + count + '" class="medium-6 columns">';
					html += "<p>" + testkitInfo.user.full_name + "</p>";
					html += "</div>";
					html += "</li>";
					html += '<li class="row">';
					html += '<div class="medium-6 columns">' + localeObject[localization]["st_pacakge"] + "</div>";
					html += '<div id="print-package-' + count + '" class="medium-6 columns">';
					html += "<p>" + testkitInfo.product_id + "</p>";
					html += "</div>";
					html += "</li>";
					html += '<li class="row">';
					html += '<div class="medium-6 columns">' + localeObject[localization]["st_barcode"] + "</div>";
					html += '<div id="print-barcode-' + count + '" class="medium-6 columns">';

					var barcode = testkitInfo.barcode;

					html += "<p>" + barcode + "</p>";
					html += "</div>";
					html += "</li>";
					html += '<li class="row">';
					html += '<div class="medium-6 columns">' + localeObject[localization]["st_activation_code"] + "</div>";
					html += '<div id="print-security-' + count + '" class="medium-6 columns">';

					var security_code = testkitInfo.security_code;
					security_code = security_code.replace(/[a-zA-Z0-9]/g, "X");

					html += "<p>" + security_code + "</p>";
					html += "</div>";
					html += "</li>";

					// show if basic
					if (testkitInfo.product_type.indexOf("basic") !== -1) {
						html += '<li class="row">';
						html += '<div class="medium-6 columns">' + localeObject[localization]["st_language"] + "</div>";
						html += '<div id="print-language-' + count + '" class="medium-6 columns">';

						// if (testkitInfo.report_preferred_lang == 'English') {
						// 	if (localization == 'en') var report_preferred_lang = 'English';
						// 	else if (localization == 'ms') var report_preferred_lang = 'Bahasa Inggeris';
						// 	else if (localization == 'zh') var report_preferred_lang = '英语';
						// } else if (testkitInfo.report_preferred_lang == 'Chinese') {
						// 	if (localization == 'en') var report_preferred_lang = 'Chinese';
						// 	else if (localization == 'ms') var report_preferred_lang = 'Cina';
						// 	else if (localization == 'zh') var report_preferred_lang = '中文';
						// }
                        if (localization == "en")
                            var report_preferred_lang = "English";
						else if (localization == "ms")
							var report_preferred_lang = "Bahasa Inggeris";
                        else if (localization == "zh")
                            var report_preferred_lang = "英语";

						html += "<p>" + report_preferred_lang + "</p>";
						html += "</div>";
						html += "</li>";
						html += '<li class="row">';
						html += '<div class="medium-6 columns">' + localeObject[localization]["st_weight"] + "</div>";
						html += '<div id="print-weight-' + count + '" class="medium-6 columns">';
						html += "<p>" + testkitInfo.weight + "</p>";
						html += "</div>";
						html += "</li>";
						html += '<li class="row">';
						html += '<div class="medium-6 columns">' + localeObject[localization]["st_height"] + "</div>";
						html += '<div id="print-height-' + count + '" class="medium-6 columns">';
						html += "<p>" + testkitInfo.height + "</p>";
						html += "</div>";
						html += "</li>";
						// html += '<li class="row">';
						// html += '<div class="medium-6 columns">' + localeObject[localization]['st_alcohol_intake'] + '</div>';
						// html += '<div id="print-alcohol-' + count + '" class="medium-6 columns">';
						// html += '<p>' + testkitInfo.alcohol_intake_trans + '</p>';
						// html += '</div>';
						// html += '</li>';
						// html += '<li class="row">';
						// html += '<div class="medium-6 columns">' + localeObject[localization]['st_avg_sleep'] + '</div>';
						// html += '<div id="print-sleeping-' + count + '" class="medium-6 columns">';
						// html += '<p>' + testkitInfo.sleeping_hours_trans + '</p>';
						// html += '</div>';
						// html += '</li>';
						// html += '<li class="row">';
						// html += '<div class="medium-6 columns">' + localeObject[localization]['st_exercise'] + '</div>';
						// html += '<div id="print-exercise-' + count + '" class="medium-6 columns">';

						// if (testkitInfo.is_exercise == 0) html += '<p>' + localeObject[localization]['st_none'] + '</p>';
						// else html += '<p>' + testkitInfo.exercise_freq_trans + '</p>';

						// html += '</div>';
						// html += '</li>';
						html += '<li class="row">';
						html += '<div class="medium-6 columns">' + localeObject[localization]["st_method"] + "</div>";
						html += '<div id="print-method-' + count + '" class="medium-6 columns">';

						if (testkitInfo.delivery_method == 1) {
							html += "<p>" + localeObject[localization]["st_pickup"] + "</p>";
							html += "</div>";
							html += "</li>";
							html += '<li class="row">';
							html += '<div class="medium-6 columns">' + localeObject[localization]["st_address"] + "</div>";
							html += '<div id="print-address-' + count + '" class="medium-6 columns">';
							html += "<p>" + testkitInfo.pickup_address + "</p>";
							html += "</div>";
							html += "</li>";
							html += '<li class="row">';
							html += '<div class="medium-6 columns">' + localeObject[localization]["st_date"] + "</div>";
							html += '<div id="print-date-' + count + '" class="medium-6 columns">';

							var dateTime = testkitInfo.pickup_date.split(" ");

							html += "<p>" + dateTime[0] + "</p>";
							html += "</div>";
							html += "</li>";
							html += '<li class="row">';
							html += '<div class="medium-6 columns">' + localeObject[localization]["st_timeslot"] + "</div>";
							html += '<div id="print-timeslot-' + count + '" class="medium-6 columns">';
							html += "<p>" + testkitInfo.pickup_timeslot + "</p>";
							html += "</div>";
							html += "</li>";
						} else {
							html += "<p>" + localeObject[localization]["st_dropoff_event"] + "</p>";
							html += "</div>";
							html += "</li>";
						}

						if (testkitInfo.skin_problem || testkitInfo.skin_problem_others) {
							html += '<li class="row">';
							html += '<div class="medium-6 columns">' + localeObject[localization]["st_skinproblem"] + "</div>";
							html += '<div id="print-skin-1" class="medium-6 columns">';
							html += "<ul>";

							var skin_problem_array = testkitInfo.skin_problem_trans.split(",");

							for (var i = 0; i < skin_problem_array.length; i++) {
								html += "<li><p>" + skin_problem_array[i] + "</p></li>";
							}

							html += "</ul>";
							html += "</div>";
							html += "</li>";
						}

						if (testkitInfo.skin_type) {
							html += '<li class="row skin-q2 print-skin-q2">';
							html += '<div class="medium-6 columns">' + localeObject[localization]["st_skintype"] + "</div>";
							html += '<div id="print-skin-q2" class="medium-6 columns">';
							html += "<ul>";

							var skin_type_array = testkitInfo.skin_type_trans.split(",");

							for (var i = 0; i < skin_type_array.length; i++) {
								html += "<li><p>" + skin_type_array[i] + "</p></li>";
							}

							html += "</ul>";
							html += "</div>";
							html += "</li>";
						}
					}

					html += "</ul>";
					html += "</div>";
					html += "</li>";
				}

				$("#submmited_testkit").html(html);
				Foundation.reInit($("#submmited_testkit"));
			}

			if (incompletedTestKit.length != 0) {
				$(".incomplete-status").css("display", "block");

				var html = "";

				for (var i = 0; i < incompletedTestKit.length; i++) {
					var testkitInfo = incompletedTestKit[i];

					var testkit_id = secret + "_" + testkitInfo.barcode + "_" + testkitInfo.id;

					var encrypted_id = CryptoJS.AES.encrypt(testkit_id, secret);

					testkit_id = encodeURIComponent(encrypted_id);

					var url = redirectPath + "/submit-test-kit?testkit_id=" + testkit_id;

					html += '<a href="' + url + '">';
					html += '<div class="row">';
					html += '<p class="profile medium-9 columns">' + testkitInfo.user.full_name + "<br><span>" + testkitInfo.product_id + "</span></p>";

					if (localization == "en") {
						html += '<p class="incomplete-step medium-3 columns">Continue</p>';
					} else if (localization == "zh") {
						html += '<p class="incomplete-step medium-3 columns">继续</p>';
					} else if (localization == "ms") {
						html += '<p class="incomplete-step medium-3 columns">Teruskan</p>';
					}

					html += "</div>";
					html += "</a>";
				}

				$("#incompleted_testkit").html(html);
			} else {
				$(".incomplete-status").css("display", "none");
			}

			removeLoading();
		},
		error: function (data) {
			var response = JSON.parse(data.responseText);

			removeLoading();

			if (response.message == "token_expired") {
				promptTokenExpired();
				$(".navLoader").css("display", "none");
			} else {
				Swal.fire({
					type: "error",
					title: localeObject[localization]["errorText"],
					text: response.message,
					animation: false,
					customClass: {
						popup: "animated fadeIn",
					},
				});
			}
		},
		complete: function (data) {
			// console.log(data);
		},
	});
}

//For Register Testkit User List change
$("#name-list").change(function () {
	var id = $(this).children(":selected").val().split("|");
	if (id[1] == "incompleted") {
		$(".status-tracker-btn").css("display", "flex");
		$(".submit-register-btn").css("display", "none");
		$(".bar-code").css("display", "none");
		$(".security-code").css("display", "none");
		$(".security-code-container").css("display", "none");
	} else {
		$(".status-tracker-btn").css("display", "none");
		$(".submit-register-btn").css("display", "flex");

		if (id[0] == "exist") {
			$(".bar-code").css("display", "none");
			$(".security-code").css("display", "block");
			$(".security-code-container").css("display", "flex");
			$("#newkit-addon").html(localeObject[localization]["newkit_addon"]);
		} else {
			$(".bar-code").css("display", "flex");
			$(".security-code").css("display", "block");
			$(".security-code-container").css("display", "flex");
		}
	}
});

//Show hide barcode and activation code//
function showBarcode () {
	var x = document.getElementById("bar-code");
	if (x.type === "password") {
		x.type = "text";
	} else {
		x.type = "password";
	}

	$("#showBarCode").toggleClass("fa-eye-slash fa-eye");
}

function showActivationCode () {
	var activeCode1 = document.getElementById("security-code-1");
	if (activeCode1.type === "password") {
		activeCode1.type = "text";
	} else {
		activeCode1.type = "password";
	}

	var activeCode2 = document.getElementById("security-code-2");
	if (activeCode2.type === "password") {
		activeCode2.type = "text";
	} else {
		activeCode2.type = "password";
	}

	var activeCode3 = document.getElementById("security-code-3");
	if (activeCode3.type === "password") {
		activeCode3.type = "text";
	} else {
		activeCode3.type = "password";
	}

	$("#showActivationCode").toggleClass("fa-eye-slash fa-eye");
}

//User List API
function dropDownUserList () {
	loading();

	var url = apipath + "user-list";

	$.ajax({
		url: url,
		type: "GET",
		headers: {
			Authorization: "Bearer " + getCookie("ty_access_token"),
			"X-localization": localization,
		},
		contentType: "application/json", // tell jQuery not to set contentType
		success: function (data) {
			var select = document.getElementById("name-list");
			for (var i = 0; i < data.length; i++) {
				var option = document.createElement("option");
				option.id = data[i].id;
				option.text = data[i].name;

                if (data[i].test_kit_exist == false)
                    option.value = "none";
                else
                    option.value = "exist";

				if (data[i].test_kit_incomplete == false)
					option.value = option.value + "|completed";
                else
                    option.value = option.value + "|incompleted";

				select.add(option, 0);

				$("#name-list").val(option.value).trigger("change");
			}

			removeLoading();
		},
		error: function (data) {
			var response = JSON.parse(data.responseText);

			removeLoading();

			if (response.message == "token_expired") {
				promptTokenExpired();
				$(".navLoader").css("display", "none");
			} else {
				Swal.fire({
					type: "error",
					title: localeObject[localization]["errorText"],
					text: response.message,
					animation: false,
					customClass: {
						popup: "animated fadeIn",
					},
				});
			}
		},
		complete: function (data) {
			console.log(data);
		},
	});
}

//Tied Barcode API
function tiedBarcode () {
	$("#tiedBarcode").validate({
		debug: true,
		focusInvalid: true,
		rules: {
			name: {
				required: true,
			},
			barcode: {
				required: function (el) {
					return $("#name-list").find(":selected").val() != "none";
				},
			},
			security_code_1: {
				required: true,
				minlength: 4,
				maxlength: 4,
			},
			security_code_2: {
				required: true,
				minlength: 4,
				maxlength: 4,
			},
			security_code_3: {
				required: true,
				minlength: 4,
				maxlength: 4,
			},
		},
		errorPlacement: function (error, element) {
			if (element.attr("name") == "barcode") {
				error.insertAfter(".bar-code-container");
			} else if (element.attr("name") == "security_code_1") {
				error.insertAfter(".security-code-container");
			} else if (element.attr("name") == "security_code_2") {
				if ( $("#security-code-1-error").length == 0 || !$("#security-code-1-error").is(":visible") )
					error.insertAfter(".security-code-container");
			} else if (element.attr("name") == "security_code_3") {
				if ( ($("#security-code-1-error").length == 0 && $("#security-code-2-error").length == 0) || (!$("#security-code-1-error").is(":visible") && !$("#security-code-2-error").is(":visible")) )
					error.insertAfter(".security-code-container");
			} else {
				error.insertAfter(element);
			}
		},
		invalidHandler: function (e, validator) {
			// for (var i in validator.errorMap) {
			// 	console.log(i, ':', validator.errorMap[i]);
			// }
		},
		submitHandler: function (form) {
			loading();

			var selected_id = $("#name-list").find(":selected").attr("id");
			var barcode = $("#bar-code").val();
			var security_code =
				$("#security-code-1").val() +
				$("#security-code-2").val() +
				$("#security-code-3").val();

			var data = {
				selected_id: selected_id,
				barcode: barcode,
				security_code: security_code,
			};

			var url = apipath + "testkit/register";

			$.ajax({
				url: url,
				type: "POST",
				headers: {
					Authorization: "Bearer " + getCookie("ty_access_token"),
					"X-localization": localization,
				},
				data: JSON.stringify(data),
				contentType: "application/json", // tell jQuery not to set contentType
				success: function (data) {
					var testkit_id = secret + "_" + $("#bar-code").val() + "_" + data.id;
					var encrypted_id = CryptoJS.AES.encrypt(testkit_id, secret);

					url = encodeURIComponent(encrypted_id);

					removeLoading();

					if (data.status == 5)
						window.location.href = redirectPath + "/submit-test-kit-complete";
					else
						window.location.href = redirectPath + "/submit-test-kit?testkit_id=" + url;
				},
				error: function (data) {
					var response = JSON.parse(data.responseText);

					removeLoading();

					if (response.message == "token_expired") {
						promptTokenExpired();
						$(".navLoader").css("display", "none");
					} else if (response.message == "account_locked") {
						deleteCookie("user_classic_token");
						deleteCookie("user_ielken_token");
						deleteCookie("ge_access_token");

						if (localization == "en") {
							errorMsg = "Your account has been locked due to multiple failed attempts.";
						} else if (localization == "ms") {
							errorMsg = "Akaun anda telah dikunci kerana banyak percubaan yang gagal.";
						} else if (localization == "zh") {
							errorMsg = "有鉴于多次尝试失败，您的账号已被锁定。";
						}

						Swal.fire({
							type: "error",
							title: localeObject[localization]["errorText"],
							text: errorMsg,
							animation: false,
							customClass: {
								popup: "animated fadeIn",
							},
							onClose: function () {
								window.location.href = redirectPath + "/login";
							},
						});
					} else if (response.message == "securitycode_needBasic") {
						if (localization == "en") {
							errorMsg = "Please register a TrueYou Essential Package before registering an add-on package or consultant package.";
						} else if (localization == "ms") {
							errorMsg = "Sila daftar Pakej TrueYou Asas sebelum anda mendaftarkan pakej tambahan atau perundingan.";
						} else if (localization == "zh") {
							errorMsg = "需先注册一个TrueYou Lite配套，方能注册额外配套或咨询配套。";
						}

						Swal.fire({
							type: "error",
							title: localeObject[localization]["errorText"],
							text: errorMsg,
							animation: false,
							customClass: {
								popup: "animated fadeIn",
							},
						});
					} else if (response.message == "securitycode_tiedBasic") {
						if (localization == "en") {
							errorMsg = "This account already has a test kit registered to it. You may only register add-on packages, consultation, or add subscription duration for this account. To register a new test kit, please use a new account.";
						} else if (localization == "ms") {
							errorMsg = "Akaun ini sudah mempunyai kit ujian yang berdaftar. Anda hanya boleh mendaftar pakej tambahan, perundingan, atau tambah tempoh langganan untuk akaun ini. Untuk mendaftarkan kit ujian baharu, sila gunakan akaun baru.";
						} else if (localization == "zh") {
							errorMsg = "此账号已经注册了一个检测套件。您只能为此账号注册额外配套、咨询服务或增加订阅期限。欲注册一个新的检测套件，请使用另一个全新的账号。";
						}

						Swal.fire({
							type: "error",
							title: localeObject[localization]["errorText"],
							text: errorMsg,
							animation: false,
							customClass: {
								popup: "animated fadeIn",
							},
                        });
                    } else if (response.message == "securitycode_sameAddOn") {
						if (localization == "en") {
							errorMsg = "This account already have the same add-on package. You may only register different add-on packages for this account.";
						} else if (localization == "ms") {
							errorMsg = "Akaun ini sudah mempunyai pakej tambahan yang sama. Anda hanya boleh mendaftarkan pakej tambahan berlainan untuk akaun ini.";
						} else if (localization == "zh") {
							errorMsg = "此帐户已经有相同的附加产品。 您只能为此帐户注册其他的附加产品。";
						}

						Swal.fire({
							type: "error",
							title: localeObject[localization]["errorText"],
							text: errorMsg,
							animation: false,
							customClass: {
								popup: "animated fadeIn",
							},
						});
					} else if (response.message == "securitycode_ConsultationOnly") {
						if (localization == "en") {
							errorMsg = 'You may activate the consultation code in "Book a consultation" page.';
						} else if (localization == "ms") {
							errorMsg = 'You may activate the consultation code in "Book a consultation" page.';
						} else if (localization == "zh") {
							errorMsg = 'You may activate the consultation code in "Book a consultation" page.';
						}

						Swal.fire({
							type: "error",
							title: localeObject[localization]["errorText"],
							text: errorMsg,
							animation: false,
							customClass: {
								popup: "animated fadeIn",
							},
						});
					} else {
						if (localization == "en") {
							errorMsg = "Invalid activation code or barcode. Please get in touch with TrueYou customer service for further assistance.";
						} else if (localization == "ms") {
							errorMsg = "Kod pengaktifan atau kod bar tidak sah. Sila hubungi pegawai perkhidmatan pelanggan TrueYou untuk bantuan lanjut.";
						} else if (localization == "zh") {
							errorMsg = "激活码或条形码无效。 请与TrueYou客服联系以获得进一步协助。";
						}

						Swal.fire({
							type: "error",
							title: localeObject[localization]["errorText"],
							text: errorMsg,
							animation: false,
							customClass: {
								popup: "animated fadeIn",
							},
						});
					}
				},
				complete: function (data) {
					// console.log(data);
				},
			});
		},
	});

	if (localization == "en") {
		jQuery.extend(jQuery.validator.messages, {
			required: "This field is required.",
			remote: "Please fix this field.",
			email: "Please enter a valid email address.",
			validemail: jQuery.validator.format(
				"Please enter a valid email address."
			),
			url: "Please enter a valid URL.",
			date: "Please enter a valid date.",
			dateISO: "Please enter a valid date (ISO).",
			number: "Please enter a valid number.",
			digits: "Please enter only digits.",
			creditcard: "Please enter a valid credit card number.",
			equalTo: "Please enter the same value again.",
			validpassword: jQuery.validator.format(
				"Please enter at least 8 characters which consists of lowercase letters, uppercase letters and numerals."
			),
			accept: "Please enter a value with a valid extension.",
			maxlength: jQuery.validator.format(
				"Please enter no more than {0} characters."
			),
			minlength: jQuery.validator.format(
				"Please enter at least {0} characters."
			),
			rangelength: jQuery.validator.format(
				"Please enter a value between {0} and {1} characters long."
			),
			range: jQuery.validator.format(
				"Please enter a value between {0} and {1}."
			),
			max: jQuery.validator.format(
				"Please enter a value less than or equal to {0}."
			),
			min: jQuery.validator.format(
				"Please enter a value greater than or equal to {0}."
			),
			CheckDOB: "Please enter valid date format.",
			checkDeliveryDateWeekend: "Please select weekdays only.",
			checkDeliveryDate: "Please select 1 day after today.",
		});
	} else if (localization == "ms") {
		jQuery.extend(jQuery.validator.messages, {
			required: "Ruangan ini wajib diisi.",
			remote: "Sila betulkan ruangan ini.",
			email: "Sila masukkan alamat e-mel yang sah.",
			validemail: jQuery.validator.format(
				"Sila masukkan alamat e-mel yang sah."
			),
			url: "Sila masukkan URL yang sah.",
			date: "Sila masukkan tarikh yang sah.",
			dateISO: "Sila masukkan tarikh yang sah (ISO).",
			number: "Sila masukkan nombor yang sah.",
			digits: "Sila masukkan nombor sahaja.",
			creditcard: "SIla masukkan nombor kad kredit yang sah.",
			equalTo: "Sila masukkan nilai yang sama sekali lagi.",
			validpassword: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya 8 aksara yang terdiri daripada huruf kecil, huruf besar dan angka."
			),
			accept: "Sila masukkan nilai dengan sambungan sah.",
			maxlength: jQuery.validator.format(
				"Sila masukkan tidak melebihi {0} aksara."
			),
			minlength: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya {0} aksara."
			),
			rangelength: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara panjang."
			),
			range: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara."
			),
			max: jQuery.validator.format(
				"Sila masukkan nilai sekurang-kurangnya atau sama dengan {0}."
			),
			min: jQuery.validator.format(
				"Sila masukkan nilai melebihi atau sama dengan {0}."
			),
			CheckDOB: "Sila masukkan format tarikh yang sah.",
			checkDeliveryDateWeekend: "Sila pilih hari bekerja sahaja.",
			checkDeliveryDate: "Sila pilih tarikh selepas hari ini.",
		});
	} else if (localization == "zh") {
		jQuery.extend(jQuery.validator.messages, {
			required: "此为必填项.",
			remote: "请更正此项目.",
			email: "请输入有效的电邮地址.",
			validemail: jQuery.validator.format("请输入有效的电邮地址."),
			url: "请输入有效的网址.",
			date: "请输入有效的日期.",
			dateISO: "请输入有效的日期(ISO).",
			number: "请输入有效的数字.",
			digits: "请只输入号码.",
			creditcard: "请输入有效的信用卡号码.",
			equalTo: "请再次输入一样的字符串.",
			validpassword: jQuery.validator.format(
				"请输入至少8个字符，包括小写字母，大写字母和数字."
			),
			accept: "请输入拥有有效后缀名的字符串.",
			maxlength: jQuery.validator.format("请输入不多于 {0}个的字母."),
			minlength: jQuery.validator.format("请输入至少 {0}个的字数."),
			rangelength: jQuery.validator.format(
				"请输入一个长度介于 {0} 和 {1} 之间的字符串."
			),
			range: jQuery.validator.format("请输入一个介于 {0} 和 {1} 之间的字符串."),
			max: jQuery.validator.format("请输入一个 长度最少是 {0} 的字符串."),
			min: jQuery.validator.format("请输入一个最小为{0} 的字符串."),
			CheckDOB: "请输入有效的日期格式。",
			checkDeliveryDateWeekend: "请仅选择工作日。",
			checkDeliveryDate: "请选择今天之后的日期",
		});
	}
}

//Testkit questionaire options list api
function allOptionList () {
	var url = apipath + "options-list";

	$.ajax({
		url: url,
		type: "GET",
		headers: {
			Authorization: "Bearer " + getCookie("ty_access_token"),
			"X-localization": localization,
		},
		contentType: "application/json", // tell jQuery not to set contentType
		success: function (data) {
			console.log(data);

			var select = document.getElementById("pickup-state");
			for (var i = 0; i < data.stateArray.length; i++) {
				var option = document.createElement("option");

				option.value = data.stateArray[i].id;
				option.text = data.stateArray[i].state;

				select.add(option, 0);
			}

			//          var select = document.getElementById('dropOff-selection');
			// for (var i = 0; i < data.dropOffArray.length; i++) {
			// 	var option = document.createElement('option');

			// 	option.value = data.dropOffArray[i].drop_off_venue;
			// 	option.text = data.dropOffArray[i].drop_off_venue;

			// 	select.add(option);
			// }

			var select = document.getElementById("general_health_1");
			for (var key in data.general_health_1Array) {
				var option = document.createElement("option");

				option.value = key;
				option.text = data.general_health_1Array[key];

				select.add(option, 0);
			}

			var select = document.getElementById("general_health_2");
			for (var key in data.general_health_2Array) {
				var option = document.createElement("option");

				option.value = key;
				option.text = data.general_health_2Array[key];

				select.add(option, 0);
			}

			var select = document.getElementById("general_health_3");
			for (var key in data.general_health_3Array) {
				var option = document.createElement("option");

				option.value = key;
				option.text = data.general_health_3Array[key];

				select.add(option, 0);
			}

			var select = document.getElementById("general_health_4");
			for (var key in data.general_health_4Array) {
				var option = document.createElement("option");

				option.value = key;
				option.text = data.general_health_4Array[key];

				select.add(option, 0);
			}

			var select = document.getElementById("exercise_6");
			for (var key in data.exercise_6Array) {
				var option = document.createElement("option");

				option.value = key;
				option.text = data.exercise_6Array[key];

				select.add(option, 0);
			}

			// var select = document.getElementById('exercise_7');
			// for (var key in data.exercise_7Array) {
			// 	var option = document.createElement('option');

			// 	option.value = key;
			// 	option.text = data.exercise_7Array[key];

			// 	select.add(option, 0);
			// }

			// Question 7
			// var sortableEl = document.getElementById('sortable-list');
			// sortable = Sortable.create(sortableEl, {
			// 	selectedClass: 'selected', // The class applied to the selected items
			// 	fallbackTolerance: 3, // So that we can select items on mobile
			// 	animation: 150
			// });

			var select = document.getElementById("diet_8");
			for (var key in data.diet_8Array) {
				var option = document.createElement("option");

				option.value = key;
				option.text = data.diet_8Array[key];

				select.add(option, 0);
			}

			var select = document.getElementById("diet_9");
			for (var key in data.diet_9Array) {
				var option = document.createElement("option");

				option.value = key;
				option.text = data.diet_9Array[key];

				select.add(option, 0);
			}

			var select = document.getElementById("diet_10");
			for (var key in data.diet_10Array) {
				var option = document.createElement("option");

				option.value = key;
				option.text = data.diet_10Array[key];

				select.add(option, 0);
			}

			var select = document.getElementById("diet_11");
			for (var key in data.diet_11Array) {
				var option = document.createElement("option");

				option.value = key;
				option.text = data.diet_11Array[key];

				select.add(option, 0);
			}

			var select = document.getElementById("diet_12");
			for (var key in data.diet_12Array) {
				var option = document.createElement("option");

				option.value = key;
				option.text = data.diet_12Array[key];

				select.add(option, 0);
			}

			var select = document.getElementById("diet_13");
			for (var key in data.diet_13Array) {
				var option = document.createElement("option");

				option.value = key;
				option.text = data.diet_13Array[key];

				select.add(option, 0);
			}

			var select = document.getElementById("diet_14");
			for (var key in data.diet_14Array) {
				var option = document.createElement("option");

				option.value = key;
				option.text = data.diet_14Array[key];

				select.add(option, 0);
			}

			var select = document.getElementById("diet_15");
			for (var key in data.diet_15Array) {
				var option = document.createElement("option");

				option.value = key;
				option.text = data.diet_15Array[key];

				select.add(option, 0);
			}

			var select = document.getElementById("diet_16");
			for (var key in data.diet_16Array) {
				var option = document.createElement("option");

				option.value = key;
				option.text = data.diet_16Array[key];

				select.add(option, 0);
			}

			// var select = document.getElementById('diet_17');
			// for (var key in data.diet_17Array) {
			// 	var option = document.createElement('option');

			// 	option.value = key;
			// 	option.text = data.diet_17Array[key];

			// 	select.add(option, 0);
			// }

			var html = $(".diet-17").html();
			for (var key in data.diet_17Array) {
				var id = key.split(".");
				html += '<input class="styled-checkbox" type="checkbox" name="diet-17" class="diet-17" id="' + id[id.length - 1] + '" value="' + key + '"><label>' + data.diet_17Array[key] + "</label><br>";
			}

			$(".diet-17").html(html);

			var select = document.getElementById("lifestyles_18");
			for (var key in data.lifestyles_18Array) {
				var option = document.createElement("option");

				option.value = key;
				option.text = data.lifestyles_18Array[key];

				select.add(option, 0);
			}

			var select = document.getElementById("lifestyles_19");
			for (var key in data.lifestyles_19Array) {
				var option = document.createElement("option");

				option.value = key;
				option.text = data.lifestyles_19Array[key];

				select.add(option, 0);
			}

			var select = document.getElementById("lifestyles_20");
			for (var key in data.lifestyles_20Array) {
				var option = document.createElement("option");

				option.value = key;
				option.text = data.lifestyles_20Array[key];

				select.add(option, 0);
			}

			var select = document.getElementById("lifestyles_21");
			for (var key in data.lifestyles_21Array) {
				var option = document.createElement("option");

				option.value = key;
				option.text = data.lifestyles_21Array[key];

				select.add(option, 0);
			}

			var select = document.getElementById("medical_22");
			for (var key in data.medical_22Array) {
				var option = document.createElement("option");

				option.value = key;
				option.text = data.medical_22Array[key];

				select.add(option, 0);
			}

			var select = document.getElementById("medical_23");
			for (var key in data.medical_23Array) {
				var option = document.createElement("option");

				option.value = key;
				option.text = data.medical_23Array[key];

				select.add(option, 0);
			}

			var select = document.getElementById("medical_24");
			for (var key in data.medical_24Array) {
				var option = document.createElement("option");

				option.value = key;
				option.text = data.medical_24Array[key];

				select.add(option, 0);
			}

			// var select = document.getElementById('medical_25');
			// for (var key in data.medical_25Array) {
			// 	var option = document.createElement('option');

			// 	option.value = key;
			// 	option.text = data.medical_25Array[key];

			// 	select.add(option, 0);
			// }

			var html = $(".medical-question25").html();
			for (var key in data.medical_25Array) {
				var id = key.split(".");

				html += '<input class="styled-checkbox" type="checkbox" name="medical-25" class="medical-25" id="' + id[id.length - 1] + '" value="' + key + '"><label>' + data.medical_25Array[key] + "</label><br>";

				// if (id[id.length - 1] == 'others') {
				// 	console.log('in if');
				// 	html += '<input class="styled-checkbox" type="checkbox" onclick="uncheckMedicalAll();" name="medical-25" class="medical-25" id="' + id[id.length - 1] + '" value="' + key + '"><label>' + data.medical_25Array[key] + '</label><br>';
				// } else {
				// 	console.log('in else');
				// 	html += '<input class="styled-checkbox" type="checkbox" onclick="checkMedical();" name="medical-25" class="medical-25" id="' + id[id.length - 1] + '" value="' + key + '"><label>' + data.medical_25Array[key] + '</label><br>';
				// }
			}

            if (localization == "en") {
                $otherLang      = 'Others';
                $specifyLang    = 'Please specify';
            } else if (localization == "ms") {
                $otherLang      = 'Lain-lain';
                $specifyLang    = 'Sila nyatakan';
            } else if (localization == "zh") {
                $otherLang      = '其他';
                $specifyLang    = '请列明';
            }

            html += '<input class="styled-checkbox" type="checkbox" onclick="showMedicalOther();" name="medical-25-others" id="medical-25-others" value="Other"><label>'+$otherLang+'</label><br>';
            html += '<input type="text" name="medical-25-others-text" value="" id="other-medical-25" placeholder="'+$specifyLang+'" id="Other">';

			// html += '<input class="styled-checkbox" type="checkbox" onclick="showMedicalOther();" name="medical-25-others" id="medical-25-others" value="Other"><label>Others</label><br>';
            // html += '<input type="text" name="medical-25-others-text" value="" id="other-medical-25" placeholder="Please specify" id="Other">';

            // html += '<div class="medical-25-other">';
            // html += '</div>';

			$(".medical-question25").html(html);

			// var select = document.getElementById('alcohol_intake');

			// for (var key in data.alcoholInfoArray) {
			// 	var option = document.createElement('option');

			// 	option.value = key;
			// 	option.text = data.alcoholInfoArray[key];

			// 	select.add(option, 0);
			// }

			// var select = document.getElementById('sleeping_hours');

			// for (var key in data.sleepingHoursInfoArray) {
			// 	var option = document.createElement('option');

			// 	option.value = key;
			// 	option.text = data.sleepingHoursInfoArray[key];

			// 	select.add(option, 0);
			// }

			// var select = document.getElementById('exercise_duration');

			// for (var key in data.exerciseInfoArray) {
			// 	var option = document.createElement('option');

			// 	option.value = key;
			// 	option.text = data.exerciseInfoArray[key];

			// 	select.add(option, 0);
			// }

			// old
			var html = $(".additional-skin-question1").html();
			for (var key in data.skinProblemInfoArray) {
				var id = key.split(".");

				if (id[id.length - 1] == "none")
					html += '<input class="styled-checkbox skin-q1" type="checkbox" onclick="uncheckAll();" name="skin-q1" id="' + id[id.length - 1] + '" value="' + key + '"><span>' + data.skinProblemInfoArray[key] + "</span><br>";
				else
					html += '<input class="styled-checkbox skin-q1" type="checkbox" onclick="checkSkin();" name="skin-q1" id="' + id[id.length - 1] + '" value="' + key + '"><span>' + data.skinProblemInfoArray[key] + "</span><br>";
			}

			html += '<div class="skin-q1-other">';
			html +='<input class="styled-checkbox" type="checkbox" onclick="showOther();" name="skin-q1-others" id="skin-q1-others" value="Other"><span>Other, please specify:</span>';
			html +='<input type="text" name="skin-q1-others-text" value="" id="other-skin-problem" placeholder="Other" id="Other">';
			html += "</div>";

			$(".additional-skin-question1").html(html);

			var html = $(".additional-skin-question2").html();
			var count = 0;
			for (var key in data.skinTypeInfoArray) {
				var id = key.split(".");

				html += '<input class="styled-checkbox skin-q2" type="checkbox" name="skin-q2" id="' + id[id.length - 1] + '" value="' + key + '"><span>' + data.skinTypeInfoArray[key] + "</span><br>";
			}

			html += "</div>";

			$(".additional-skin-question2").html(html);

			// Select option reset
			$(".exercise_7_group").change(function () {
				var currentEl = $(this);
				var currentVal = $(this).val();
				var currentIndex = $(this).attr("data-exercise-group");
				$(".exercise_7_group").each(function (i) {
					if ($(this).val() == currentVal && i + 1 != currentIndex) {
						$(this).val("");
					}
				});
			});
		},
		error: function (data) {
			var response = JSON.parse(data.responseText);

			var errorTitle = "";
			var errorMsg = "";
			var buttontext = "";

			if (response.message == "token_expired") {
				$(".navLoader").css("display", "none");
				// alert('Token Expired Please Relogin');
				if (localization == "en") {
					errorTitle = "Session Expired";
					errorMsg = "Please Relogin";
					buttontext = "Login";
				} else if (localization == "ms") {
					errorTitle = "Sesi tamat";
					errorMsg = "Sila log masuk sekali lagi";
					buttontext = "Log masuk";
				} else if (localization == "zh") {
					errorTitle = "此环节已逾时";
					errorMsg = "请重新登入";
					buttontext = "登录";
				}
			} else {
				if (localization == "en") {
					errorTitle = "Token is invalid";
					errorMsg = "Please login";
					buttontext = "Login";
				} else if (localization == "ms") {
					errorTitle = "Token tidak sah​";
					errorMsg = "Sila log masuk";
					buttontext = "Log masuk";
				} else if (localization == "zh") {
					errorTitle = "Token无效";
					errorMsg = "请登录";
					buttontext = "登录";
				}
			}

			Swal.fire({
				title: errorTitle,
				text: errorMsg,
				type: "error",
				animation: false,
				customClass: {
					popup: "animated fadeIn",
				},
				showCancelButton: false,
				confirmButtonColor: "#FF0000",
				confirmButtonText: buttontext,
			}).then(function (results) {
				window.location.href = redirectPath + "/login";
			});
		},
		complete: function (data) {
			// console.log(data);
		},
	});
}

/*$('.state').change(function() {
	loading();

	var state_id = $("#pickup-state").find(":selected").val();

	var url = apipath + "state/holiday";

	$.ajax({
		url: url + "?state_id=" + state_id,
		type: "GET",
		headers: {
			Authorization: "Bearer " + getCookie("ty_access_token"),
			"X-localization": localization,
		},
		contentType: "application/json", // tell jQuery not to set contentType
		success: function (data) {
			$(".pickup-date").css("display", "block");
			$(".time-slot").css("display", "block");

			var unavailableDates = data;

			$("#pickup-date").datepicker("remove");

			$(function () {
				var myDate = new Date();
				var threeWorkingDays = new Date();
				var adjustments = [0, 0, 2, 2, 2, 2, 1]; // Offsets by day of the week. Sunday - Saturday : 0 - 6
				threeWorkingDays.setDate(
					threeWorkingDays.getDate() +
					4 +
					adjustments[threeWorkingDays.getDay()]
				);

				$("#pickup-date").datepicker({
					format: "yyyy/mm/dd",
					todayHighlight: false,
					// startDate: new Date(myDate.getTime() + 1 * 24 * 60 * 60 * 1000),
					startDate: threeWorkingDays,
					endDate: "",
					daysOfWeekDisabled: [0, 6],
					keyboardNavigation: false,
					onRender: function (date) {
						var dmy =
							date.getFullYear() +
							"/" +
							(date.getMonth() + 1) +
							"/" +
							date.getDate();
						if ($.inArray(dmy, unavailableDates) != -1) {
							return "disabled";
						}
					},
				});
			});

			removeLoading();
		},
		error: function (data) {
			var response = JSON.parse(data.responseText);

			removeLoading();

			if (response.message == "token_expired") {
				promptTokenExpired();
				$(".navLoader").css("display", "none");
			} else {
				Swal.fire({
					type: "error",
					title: localeObject[localization]["errorText"],
					text: response.message,
					animation: false,
					customClass: {
						popup: "animated fadeIn",
					},
				});
			}
		},
		complete: function (data) {
			// console.log(data);
		},
	});
});*/

//Get specific testkit api
function getSpecificTestkit () {
	loading();

	var urlParams = new URLSearchParams(window.location.search);

	var url = apipath + "testkit/specific";

	var data = { testkit_id: decodeURIComponent(urlParams.get("testkit_id")) };

	$.ajax({
		url: url,
		type: "POST",
		data: JSON.stringify(data),
		headers: {
			Authorization: "Bearer " + getCookie("ty_access_token"),
			"X-localization": localization,
		},
		contentType: "application/json", // tell jQuery not to set contentType
		success: function (data) {
			log(data);
			var previousUrl = document.referrer;

			previousUrl = previousUrl.split("/");

			var module = data.module;

			$(".additional-skin-question1").css("display", "none");
			$(".additional-skin-question2").css("display", "none");

			for (var i = module.length - 1; i >= 0; i--) {
				// if (module[i].module_no == 5) {
				if (module[i].id == 5) {
					$(".additional-skin-question1").css("display", "block");
					$(".additional-skin-question2").css("display", "block");
				}
			}

			if (!data.next_purchase) {
				$("#step-one-submit-btn").css("display", "flex");
				$("#step-one-submit-btn-2").css("display", "none");
			} else {
				$("#step-one-submit-btn").css("display", "none");
				$("#step-one-submit-btn-2").css("display", "flex");
				$(".questionnaireDiv").css("display", "none");
				$("#submitkit-addon").html(
					localeObject[localization]["submitkit_addon"]
				);
			}

			if (previousUrl[previousUrl.length - 1] == "status-tracker") {
				if (data.step >= 1) {
					$("#report_language").val(data.report_preferred_lang);
					$("#delivery_add").val(data.mailing_address);
					$("#weight").val(data.weight);
					$("#height").val(data.height);
					$("#alcohol_intake").val(data.alcohol_intake);
					$("#sleeping_hours").val(data.sleeping_hours);

					populateQuestionnaires(data.questionnaires);

					if (data.is_exercise == 1) {
						$("#exercise").val("Yes");
						$("#exercise_duration").val(data.exercise_freq);

						$("#exercise_duration").css("display", "block");
						$(".exercise-duration-label").css("display", "block");
					} else $("#exercise").val("No");

					if (data.skin_problem) {
						var skinProblemArray = data.skin_problem.split(",");

						for (var i = 0; i < skinProblemArray.length; i++) {
							var id = skinProblemArray[i].split(".");
							$("#" + id[id.length - 1]).prop("checked", true);
						}
					}

					if (data.skin_type) {
						var skinTypeArray = data.skin_type.split(",");
						for (var i = 0; i < skinTypeArray.length; i++) {
							var id = skinTypeArray[i].split(".");
							$("#" + id[id.length - 1]).prop("checked", true);
						}
					}

					if (data.skin_problem_others) {
						$("#skin-q1-others").prop("checked", true);
						$("#other-skin-problem").val(data.skin_problem_others);
					}
				}

				if (data.step >= 2) {
					populateQuestionnaires(data.questionnaires);

					if (data.delivery_method == 1) {
						var pickup_companyname = data.pickup_companyname === "" ? "" : data.pickup_companyname;
                        $("#pickUp").prop("checked", true);

                        if (country == 'MY') {
                            $("#pickup-address-type option[value='" +data.pickup_addresstype +"']").prop('selected', true);
                            if (data.pickup_addresstype == "Company") {
                                $("#pickup-company-name").val(pickup_companyname);
                            }
                            $('#pickup-location').val(data.pickup_address);
                            // $("#pickup-state option:contains('"+data.pickup_state+"')").attr('selected', 'selected');

                            pickupDate = data.pickup_date.split(" ");

                            var dateAr = pickupDate[0].split("-");
                            pickupDate = dateAr[0] + "/" + dateAr[1] + "/" + dateAr[2];

                            $("#pickup-date").val(pickupDate);
                            $("#pickup-timeslot option:contains('" + data.pickup_timeslot + "')").attr("selected", "selected");
                            $("#print-package p").html(data.security_module);

                            $(".pickup-location").css("display", "block");
                            $(".store-btn").css("display", "none");
                        }
					} else {
						$("#dropOff").prop("checked", true);
						$(".pickup-location").css("display", "none");
						$("#dropOff-selection").val(data.drop_off_venue);
						$(".store-btn").css("display", "block");
					}
				}
			} else if ( previousUrl[previousUrl.length - 1] != "status-tracker" && data.step == 3 ) {
				$("#report_language").val(data.report_preferred_lang);
				$("#delivery_add").val(data.mailing_address);
				$("#height").val(data.height);
				$("#weight").val(data.weight);
				$("#alcohol_intake").val(data.alcohol_intake);
				$("#sleeping_hours").val(data.sleeping_hours);

				populateQuestionnaires(data.questionnaires);

				if (data.is_exercise == 1) {
					$("#exercise").val("Yes");
					$("#exercise_duration").val(data.exercise_freq);

					$("#exercise_duration").css("display", "block");
					$(".exercise-duration-label").css("display", "block");
				} else $("#exercise").val("No");

				if (data.skin_problem) {
					var skinProblemArray = data.skin_problem.split(",");

					for (var i = 0; i < skinProblemArray.length; i++) {
						var id = skinProblemArray[i].split(".");
						$("#" + id[id.length - 1]).prop("checked", true);
					}
				}

				if (data.skin_type) {
					var skinTypeArray = data.skin_type.split(",");
					for (var i = 0; i < skinTypeArray.length; i++) {
						var id = skinTypeArray[i].split(".");
						$("#" + id[id.length - 1]).prop("checked", true);
					}
				}

				if (data.skin_problem_others) {
					$("#skin-q1-others").prop("checked", true);
					$("#other-skin-problem").val(data.skin_problem_others);
				}

				$("#step-one-submit-btn").css("display", "none");
				$("#step-one-submit-btn-2").css("display", "flex");
				// $(".submit-test-kit-step-1").css("display","none");
				// $(".submit-test-kit-step-2").css("display","none");
				// $(".submit-test-kit-step-3").css("display","block");

				// $('.step1').addClass('completed');
				// $('.step1').removeClass('checked');

				// $('.step2').addClass('completed');
				// $('.step2').removeClass('checked');

				// $('.step3').addClass('checked');
				// $('.step3').removeClass('uncheck');

				// $('#step-three-back-btn').css("display", "none");
			}

			removeLoading();
		},
		error: function (data) {
			var response = JSON.parse(data.responseText);

			removeLoading();

			if (response.message == "token_expired") {
				promptTokenExpired();
				$(".navLoader").css("display", "none");
			} else if (data.status == 404) {
				var buttontext = "";

				if (localization == "en") {
					buttontext = "Register Kit";
				} else if (localization == "ms") {
					buttontext = "Daftar Kit";
				} else if (localization == "zh") {
					buttontext = "注册采集器";
				}

				Swal.fire({
					title: localeObject[localization]["errorText"],
					text: response.message,
					type: "error",
					animation: false,
					customClass: {
						popup: "animated fadeIn",
					},
					showCancelButton: false,
					confirmButtonColor: "#FF0000",
					confirmButtonText: buttontext,
				}).then(function (results) {
					window.location.href = redirectPath + "/register-test-kit";
				});
			}
			// checkTokenExpired(data);
		},
		complete: function (data) {
			// console.log(data);
		},
	});
}

//Submit Testkit API
$("#step-two-back-btn").click(function () {
	$(".submit-test-kit-step-2").css("display", "none");
	$(".submit-test-kit-step-1").css("display", "block");

	$(".submit-test-kit-step-2-copy").css("display", "none");
	$(".submit-test-kit-step-1-copy").css("display", "block");

	$(".step1").addClass("checked");
	$(".step1").removeClass("completed");

	$(".step2").addClass("uncheck");
	$(".step2").removeClass("checked");
});

$("#step-three-back-btn").click(function () {
	$(".submit-test-kit-step-3").css("display", "none");
	$(".submit-test-kit-step-2").css("display", "block");

	$(".submit-test-kit-step-2-copy").css("display", "block");
	$(".submit-test-kit-step-1-copy").css("display", "none");

	$(".step2").addClass("checked");
	$(".step2").removeClass("completed");

	$(".step3").addClass("uncheck");
	$(".step3").removeClass("checked");
});

$("#step-three-back-btn-2").click(function () {
	$(".submit-test-kit-step-3").css("display", "none");
	$(".submit-test-kit-step-1").css("display", "block");

	$(".step1").addClass("checked");
	$(".step1").removeClass("completed");

	$(".step2").removeClass("checked");
	$(".step2").removeClass("completed");

	$(".step3").addClass("uncheck");
	$(".step3").removeClass("checked");
});

function populateQuestionnaires (questionnaires) {
	if (questionnaires.length) {
		$("#general_health_1").val(questionnaires[0].answer);
		$("#general_health_2").val(questionnaires[1].answer);
		$("#general_health_3").val(questionnaires[2].answer);
		$("#general_health_4").val(questionnaires[3].answer);
		$("#exercise_5").val(questionnaires[4].answer);
		$("#exercise_6").val(questionnaires[5].answer);

		if (questionnaires[4].answer.toLowerCase().indexOf("yes") !== -1)
			$("#exercise_6").parent("li").show();

		var question7Arr = JSON.parse(questionnaires[6].answer);
		$("#exercise_7_a").val($.inArray("free_time", question7Arr) + 1);
		$("#exercise_7_b").val($.inArray("work_commitments", question7Arr) + 1);
		$("#exercise_7_c").val($.inArray("diet", question7Arr) + 1);
		$("#exercise_7_d").val($.inArray("motivation", question7Arr) + 1);
		$("#exercise_7_e").val($.inArray("knowledge", question7Arr) + 1);
		// sortable.sort(question7Arr);

		$("#diet_8").val(questionnaires[7].answer);
		$("#diet_9").val(questionnaires[8].answer);
		$("#diet_10").val(questionnaires[9].answer);
		$("#diet_11").val(questionnaires[10].answer);
		$("#diet_12").val(questionnaires[11].answer);
		$("#diet_13").val(questionnaires[12].answer);
		$("#diet_14").val(questionnaires[13].answer);
		$("#diet_15").val(questionnaires[14].answer);
		$("#diet_16").val(questionnaires[15].answer);

		var question17Arr = JSON.parse(questionnaires[16].answer);
		$.each(question17Arr, function (key, value) {
			console.log(key + ": " + value);
			$("input[value='" + value + "']").prop("checked", true);
		});

		$("#lifestyles_18").val(questionnaires[17].answer);
		$("#lifestyles_19").val(questionnaires[18].answer);
		$("#lifestyles_20").val(questionnaires[19].answer);
		$("#lifestyles_21").val(questionnaires[20].answer);
		$("#medical_22").val(questionnaires[21].answer);
		$("#medical_23").val(questionnaires[22].answer);
		$("#medical_24").val(questionnaires[23].answer);

		var question25Arr = JSON.parse(questionnaires[24].answer);
		$.each(question25Arr, function (key, value) {
			console.log(key + ": " + value);
			$("input[value='" + value + "']").prop("checked", true);

			if (!$("input[value='" + value + "']").length) {
				// others
				$("input[name='medical-25-others']").prop("checked", true);
				$("input[name='medical-25-others-text']").show();
				$("input[name='medical-25-others-text']").val(
					question25Arr[question25Arr.length - 1]
				);
			}
		});
	}
}

function stepOneSubmitFunction ($firstPurchase) {
	$.validator.addMethod(
		"decimal",
		function (value, element) {
			return (
				this.optional(element) ||
				/^((\d+(\\.\d{0,2})?)|((\d*(\.\d{1,2}))))$/.test(value)
			);
		},
		"Please enter a correct number, format 0.00"
	);

	$.validator.addMethod(
		"noSpace",
		function (value, element) {
			return value != " ";
		},
		"Value is Space!"
	);
    console.log('remove QUESTIONNAIRES');

	$(".submit-test-kit-step-1").validate({
		debug: true,
		focusInvalid: true,
		rules: {
			report_language: {
				required: true,
			},
			// delivery_add: {
			// 	required: true,
			// 	noSpace: true,
			// },
			weight: {
				required: true,
				decimal: true,
				min: 1,
			},
			height: {
				required: true,
				decimal: true,
				min: 1,
			},
			alcohol_intake: {
				required: true,
			},
			sleeping_hours: {
				required: true,
			},
			exercise: {
				required: true,
			},
			exercise_duration: {
				required: function (el) {
					return $("#exercise").find(":selected").val() == "Yes";
				},
			},
			// QUESTIONNAIRES
			// general_health_1: { required: true },
			// general_health_2: { required: true },
			// general_health_3: { required: true },
			// general_health_4: { required: true },
			// exercise_5: { required: true },
			// exercise_6: {
			// 	required: function (element) {
			// 		return $("#exercise_5").val() != "";
			// 	},
			// },
			// exercise_7_a: { required: true },
			// exercise_7_b: { required: true },
			// exercise_7_c: { required: true },
			// exercise_7_d: { required: true },
			// exercise_7_e: { required: true },
			// diet_8: { required: true },
			// diet_9: { required: true },
			// diet_10: { required: true },
			// diet_11: { required: true },
			// diet_12: { required: true },
			// diet_13: { required: true },
			// diet_14: { required: true },
			// diet_15: { required: true },
			// diet_16: { required: true },
			// // 'diet-17': {required: true},
			// lifestyles_18: { required: true },
			// lifestyles_19: { required: true },
			// lifestyles_20: { required: true },
			// lifestyles_21: { required: true },
			// medical_22: { required: true },
			// medical_23: { required: true },
			// medical_24: { required: true },
			// "medical-25-others-text": {
			// 	required: function (element) {
			// 		var isRequired = false;
			// 		$("input[name='medical-25']:checked").each(function (i) {
			// 			var currentVal = $(this).val().toLowerCase();
			// 			console.log(currentVal);
			// 			if (currentVal == "other") isRequired = true;
			// 		});
			// 		return isRequired;
			// 	},
			// },
		},
		errorPlacement: function (error, element) {
			error.insertAfter(element);
		},
		invalidHandler: function (e, validator) {
			// for (var i in validator.errorMap) {
			// 	console.log(i, ':', validator.errorMap[i]);
			// }
		},
		submitHandler: function (form) {
			var report_preferred_lang = $("#report_language").find(":selected").val();
			var weight = $("#weight").val();
			var height = $("#height").val();
			// var mailing_address = $("#delivery_add").val();
			var alcohol_intake = $("#alcohol_intake").find(":selected").val();
			var sleeping_hours = $("#sleeping_hours").find(":selected").val();
			var is_exercise = $("#exercise").find(":selected").val() == "Yes" ? 1 : 0;
			var skin_problem = $(".skin-q1:checked")
				.map(function () {
					return this.value;
				})
				.get();
			var skin_problem_others = $("#other-skin-problem").val();
			var skin_type = $(".skin-q2:checked")
				.map(function () {
					return this.value;
				})
				.get();

			var data = {
				report_preferred_lang: report_preferred_lang,
				weight: weight,
				height: height,
				alcohol_intake: alcohol_intake,
				sleeping_hours: sleeping_hours,
				// mailing_address: mailing_address,
				is_exercise: is_exercise,
				step: 1,
			};

			// data.question_1 = $("#general_health_1").val();
			// data.question_2 = $("#general_health_2").val();
			// data.question_3 = $("#general_health_3").val();
			// data.question_4 = $("#general_health_4").val();
			// data.question_5 = $("#exercise_5").val();
			// data.question_6 = $("#exercise_6").val();

			// data.question_7 = [];
			// data.question_7[$("select[name='exercise_7_a']").val() - 1] = "free_time";
			// data.question_7[$("select[name='exercise_7_b']").val() - 1] = "work_commitments";
			// data.question_7[$("select[name='exercise_7_c']").val() - 1] = "diet";
			// data.question_7[$("select[name='exercise_7_d']").val() - 1] = "motivation";
			// data.question_7[$("select[name='exercise_7_e']").val() - 1] = "knowledge";
			// // data.question_7 = sortable.toArray();
			// data.question_7 = JSON.stringify(data.question_7);

			// data.question_8 = $("#diet_8").val();
			// data.question_9 = $("#diet_9").val();
			// data.question_10 = $("#diet_10").val();
			// data.question_11 = $("#diet_11").val();
			// data.question_12 = $("#diet_12").val();
			// data.question_13 = $("#diet_13").val();
			// data.question_14 = $("#diet_14").val();
			// data.question_15 = $("#diet_15").val();
			// data.question_16 = $("#diet_16").val();

			// data.question_17 = [];
			// $("input[name='diet-17']:checked").each(function () {
			// 	data.question_17.push($(this).val());
			// });
			// data.question_17 = JSON.stringify(data.question_17);

			// data.question_18 = $("#lifestyles_18").val();
			// data.question_19 = $("#lifestyles_19").val();
			// data.question_20 = $("#lifestyles_20").val();
			// data.question_21 = $("#lifestyles_21").val();
			// data.question_22 = $("#medical_22").val();
			// data.question_23 = $("#medical_23").val();
			// data.question_24 = $("#medical_24").val();

			// data.question_25 = [];
			// $("input[name='medical-25']:checked").each(function () {
			// 	data.question_25.push($(this).val());
			// });
			// data.question_25.push($("input[name='medical-25-others-text']").val());
			// data.question_25 = JSON.stringify(data.question_25);

			if (is_exercise == 1) {
				var exercise_freq = $("#exercise_duration").find(":selected").val();
				data.exercise_freq = exercise_freq;
			}

			if (skin_problem.length != 0) {
				skin_problem = skin_problem.join(",");
				data.skin_problem = skin_problem;
			}

			if (skin_type.length != 0) {
				skin_type = skin_type.join(",");
				data.skin_type = skin_type;
			}

			if ($("#skin-q1-others").is(":checked"))
				data.skin_problem_others = skin_problem_others;

			var urlParams = new URLSearchParams(window.location.search);
			data.testkit_id = decodeURIComponent(urlParams.get("testkit_id"));
			console.log(urlParams, window.location.search, data);
			var url = apipath + "testkit";

			loading();

			$.ajax({
				url: url,
				type: "POST",
				headers: {
					Authorization: "Bearer " + getCookie("ty_access_token"),
					"X-localization": localization,
				},
				data: JSON.stringify(data),
				contentType: "application/json", // tell jQuery not to set contentType
				success: function (data) {
					// console.log(data);

					$(".submit-test-kit-step-1-copy").css("display", "none");
					$(".submit-test-kit-step-2-copy").css("display", "block");

					$("#report_language select").val(report_preferred_lang);
					$("#weight").val(weight);
					$("#height").val(height);
					// $("#delivery_add").val(mailing_address);
					$("#alcohol_intake select").val(alcohol_intake);
					$("#sleeping_hours select").val(sleeping_hours);
					$("#is_exercise select").val(is_exercise);

					if (is_exercise == 1) {
						$("#exercise_duration select").val(exercise_freq);
					}

					if ($firstPurchase) {
						$(".submit-test-kit-step-1").css("display", "none");
						$(".submit-test-kit-step-2").css("display", "block");

						$(".step1").addClass("completed");
						$(".step1").removeClass("checked");

						$(".step2").addClass("checked");
						$(".step2").removeClass("uncheck");

						$("#step-three-back-btn").css("display", "flex");
						$("#step-three-back-btn-2").css("display", "none");
					} else {
						$("#print-name p").text(data.user.full_name);

						var barcode = data.barcode;
						// barcode = barcode.replace(/[a-zA-Z0-9]/g, 'X');
						$("#print-barcode p").text(barcode);

						var security_code = data.security_code;
						security_code = security_code.replace(/[a-zA-Z0-9]/g, "X");
						$("#print-security p").text(security_code);

						$("#print-language p").text(data.report_preferred_lang);
						$("#print-weight p").text(data.weight);
						$("#print-height p").text(data.height);
						$("#print-alcohol p").text(data.alcohol_intake_trans);
						$("#print-sleeping p").text(data.sleeping_hours_trans);

						$("#print-package p").html(data.security_module);

						if (data.is_exercise == 0) $("#print-exercise p").text("None");
						else {
							$("#print-exercise p").text(data.exercise_freq_trans);
						}

						if (!data.skin_problem && !data.skin_problem_others) {
							$(".print-skin-q1").css("display", "none");
							$(".print-skin-q2").css("display", "none");
						} else {
							$(".print-skin-q1").css("display", "flex");
							$(".print-skin-q2").css("display", "flex");

							var html = "";

							var skin_problem_array = data.skin_problem_trans.split(",");

							html += "<ul>";
							for (var i = 0; i < skin_problem_array.length; i++) {
								html += "<li><p>" + skin_problem_array[i] + "</p></li>";
							}

							html += "</ul>";

							$("#print-skin-q1").html(html);

							var html = "";

							var skin_type_array = data.skin_type_trans.split(",");

							html += "<ul>";
							for (var i = 0; i < skin_type_array.length; i++) {
								html += "<li><p>" + skin_type_array[i] + "</p></li>";
							}
							html += "</ul>";

							$("#print-skin-q2").html(html);
						}

						$(".submit-test-kit-step-1").css("display", "none");
						$(".submit-test-kit-step-3").css("display", "block");

						$(".step1").addClass("completed");
						$(".step1").removeClass("checked");

						$(".step2").addClass("completed");
						$(".step2").removeClass("checked");

						$(".step3").addClass("checked");
						$(".step3").removeClass("uncheck");

						$(".print-pickup-method").css("display", "none");
						$(".print-pickup-address").css("display", "none");
						$(".print-pickup-date").css("display", "none");
						$(".print-pickup-timeslot").css("display", "none");

						$("#step-three-back-btn").css("display", "none");
						$("#step-three-back-btn-2").css("display", "flex");
					}
				},
				error: function (data) {
					var response = JSON.parse(data.responseText);
					// checkTokenExpired(response);
					if (response.message == "token_expired") {
						promptTokenExpired();
						$(".navLoader").css("display", "none");
					}
				},
				complete: function (data) {
					// console.log(data);
					removeLoading();
				},
			});
		},
	});

	if (localization == "en") {
		jQuery.extend(jQuery.validator.messages, {
			required: "This field is required.",
			remote: "Please fix this field.",
			email: "Please enter a valid email address.",
			validemail: jQuery.validator.format(
				"Please enter a valid email address."
			),
			url: "Please enter a valid URL.",
			date: "Please enter a valid date.",
			dateISO: "Please enter a valid date (ISO).",
			number: "Please enter a valid number.",
			digits: "Please enter only digits.",
			creditcard: "Please enter a valid credit card number.",
			equalTo: "Please enter the same value again.",
			validpassword: jQuery.validator.format(
				"Please enter at least 8 characters which consists of lowercase letters, uppercase letters and numerals."
			),
			accept: "Please enter a value with a valid extension.",
			maxlength: jQuery.validator.format(
				"Please enter no more than {0} characters."
			),
			minlength: jQuery.validator.format(
				"Please enter at least {0} characters."
			),
			rangelength: jQuery.validator.format(
				"Please enter a value between {0} and {1} characters long."
			),
			range: jQuery.validator.format(
				"Please enter a value between {0} and {1}."
			),
			max: jQuery.validator.format(
				"Please enter a value less than or equal to {0}."
			),
			min: jQuery.validator.format(
				"Please enter a value greater than or equal to {0}."
			),
			CheckDOB: "Please enter valid date format.",
			checkDeliveryDateWeekend: "Please select weekdays only.",
			checkDeliveryDate: "Please select 1 day after today.",
		});
	} else if (localization == "ms") {
		jQuery.extend(jQuery.validator.messages, {
			required: "Ruangan ini wajib diisi.",
			remote: "Sila betulkan ruangan ini.",
			email: "Sila masukkan alamat e-mel yang sah.",
			validemail: jQuery.validator.format(
				"Sila masukkan alamat e-mel yang sah."
			),
			url: "Sila masukkan URL yang sah.",
			date: "Sila masukkan tarikh yang sah.",
			dateISO: "Sila masukkan tarikh yang sah (ISO).",
			number: "Sila masukkan nombor yang sah.",
			digits: "Sila masukkan nombor sahaja.",
			creditcard: "SIla masukkan nombor kad kredit yang sah.",
			equalTo: "Sila masukkan nilai yang sama sekali lagi.",
			validpassword: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya 8 aksara yang terdiri daripada huruf kecil, huruf besar dan angka."
			),
			accept: "Sila masukkan nilai dengan sambungan sah.",
			maxlength: jQuery.validator.format(
				"Sila masukkan tidak melebihi {0} aksara."
			),
			minlength: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya {0} aksara."
			),
			rangelength: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara panjang."
			),
			range: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara."
			),
			max: jQuery.validator.format(
				"Sila masukkan nilai sekurang-kurangnya atau sama dengan {0}."
			),
			min: jQuery.validator.format(
				"Sila masukkan nilai melebihi atau sama dengan {0}."
			),
			CheckDOB: "Sila masukkan format tarikh yang sah.",
			checkDeliveryDateWeekend: "Sila pilih hari bekerja sahaja.",
			checkDeliveryDate: "Sila pilih tarikh selepas hari ini.",
		});
	} else if (localization == "zh") {
		jQuery.extend(jQuery.validator.messages, {
			required: "此为必填项.",
			remote: "请更正此项目.",
			email: "请输入有效的电邮地址.",
			validemail: jQuery.validator.format("请输入有效的电邮地址."),
			url: "请输入有效的网址.",
			date: "请输入有效的日期.",
			dateISO: "请输入有效的日期(ISO).",
			number: "请输入有效的数字.",
			digits: "请只输入号码.",
			creditcard: "请输入有效的信用卡号码.",
			equalTo: "请再次输入一样的字符串.",
			validpassword: jQuery.validator.format(
				"请输入至少8个字符，包括小写字母，大写字母和数字."
			),
			accept: "请输入拥有有效后缀名的字符串.",
			maxlength: jQuery.validator.format("请输入不多于 {0}个的字母."),
			minlength: jQuery.validator.format("请输入至少 {0}个的字数."),
			rangelength: jQuery.validator.format(
				"请输入一个长度介于 {0} 和 {1} 之间的字符串."
			),
			range: jQuery.validator.format("请输入一个介于 {0} 和 {1} 之间的字符串."),
			max: jQuery.validator.format("请输入一个 长度最少是 {0} 的字符串."),
			min: jQuery.validator.format("请输入一个最小为{0} 的字符串."),
			CheckDOB: "请输入有效的日期格式。",
			checkDeliveryDateWeekend: "请仅选择工作日。",
			checkDeliveryDate: "请选择今天之后的日期",
		});
	}
}

function stepTwoSubmitFunction() {
    $.validator.addMethod("checkDeliveryDateWeekend", function (value, element) {
        // checking whether the date entered is in correct format
        var isValid = value.match(/^\d\d\d\d?\/\d\d?\/\d\d$/);
        if(isValid){
            var today = new Date();
            var minDate = new Date(today.getTime() + 1 * 24 * 60 * 60 * 1000);
            var date = new Date(value).getDay();
            if( date == 0 || date == 6) {
                return false
            } else {
                return true
            }
        }
    }, "Please select weekdays only.");

    $.validator.addMethod("checkDeliveryDate", function (value, element) {
        // checking whether the date entered is in correct format
        var isValid = value.match(/^\d\d\d\d?\/\d\d?\/\d\d$/);
        if(isValid){
            var value = new Date(value);
            var myDate = new Date();
            // myDate.setDate(myDate.getDate() + 7);

            // var adjustments = [0, 0, 2, 2, 2, 2, 1]; // Offsets by day of the week. Sunday - Saturday : 0 - 6
            // myDate.setDate(myDate.getDate() + 4 + adjustments[myDate.getDay()]);

            var adjustments = [1, 1, 1, 1, 2, 3, 2]; // Offsets by day of the week. Sunday - Saturday : 0 - 6
            myDate.setDate(myDate.getDate() + 1 + adjustments[myDate.getDay()]);
            myDate.setHours(0, 0, 0, 0)

            // if(value < minDate ) {
            if (value.getTime() < myDate.getTime() ) {
                return false
            } else {
                return true
            }
        }
    }, "Please select 1 day after today.");

	validator = $('.submit-test-kit-step-2').validate({
		debug: true,
		focusInvalid: true,
		rules: {
			delivery: {
				required: true,
			},
			deliveryType: {
				required: function (el) {
					return $("#pickUp").is(":checked");
				},
			},
			companyName: {
				required: function (el) {
					return $("#pickup-address-type").val() === "Company";
				},
			},
			location: {
				required: function (el) {
					return $("#pickUp").is(":checked");
				},
			},
			// deliveryState: {
			// 	required: function(el) {
			// 		return $('#pickUp').is(':checked');
			// 	}
			// },
			deliveryDate: {
				required: function (el) {
					return $("#pickUp").is(":checked");
				},
				checkDeliveryDate: true,
				checkDeliveryDateWeekend: true,
			},
			deliveryTimeslot: {
				required: function (el) {
					return $("#pickUp").is(":checked");
				},
			},
			dropOffSelection: {
				required: function (el) {
					return $("#dropOff").is(":checked");
				},
			},
		},
		errorPlacement: function (error, element) {
			if (element.attr("name") == "delivery") {
				error.insertAfter("#delivery-wrap");
			} else {
				error.insertAfter(element);
			}
		},
		invalidHandler: function (e, validator) {
			// for (var i in validator.errorMap) {
			// 	console.log(i, ':', validator.errorMap[i]);
			// }
		},
		submitHandler: function (form) {
			var deliveryMethod = $("#pickUp").is(":checked") ? 1 : 2;

			var data = { method: deliveryMethod, step: 2 };

			if (deliveryMethod == 1) {
				var pickupAddType = $("#pickup-address-type").val();
				var pickupCompanyName = $("#pickup-company-name").val();
				var location = $("#pickup-location").val();
				var pickupDate = $("#pickup-date").val();
				var pickupTimeslot = $("#pickup-timeslot").val();

				data.pickup_addresstype = pickupAddType;
				data.pickup_companyname = pickupCompanyName;
				data.pickup_address = location;
				data.pickup_date = pickupDate;
				data.pickup_timeslot = pickupTimeslot;
				// data.pickup_state = $('#pickup-state').val();
			}
			else {
				data.drop_off_venue = $('#dropOff-selection').val();
			}

			var urlParams = new URLSearchParams(window.location.search);
			data.testkit_id = decodeURIComponent(urlParams.get("testkit_id"));

			var url = apipath + "testkit";

			loading();

			$.ajax({
				url: url,
				type: "POST",
				headers: {
					Authorization: "Bearer " + getCookie("ty_access_token"),
					"X-localization": localization,
				},
				data: JSON.stringify(data),
				contentType: "application/json", // tell jQuery not to set contentType
				success: function (data) {
					console.log(data);

					if (data.delivery_method == 1) {
						$("#pickUp").prop("checked", true);

						$("#pickup-location").val(location);
						$("#pickup-date").val(pickupDate);
					} else $("#dropOff").prop("checked", true);

					$("#print-name p").text(data.user.full_name);

					// var moduleName = '';
					// for (var i = 0; i < data.security_module.length; i++) {
					// 	var securityModule = data.security_module[i];

					// 	if (i + 1 == data.security_module.length) {
					// 		moduleName += securityModule;
					// 	} else {
					// 		moduleName += securityModule + ', ';
					// 	}
					// }

					var moduleName = data.security_module;
					$("#print-package p").text(moduleName);

					var barcode = data.barcode;
					// barcode = barcode.replace(/[a-zA-Z0-9]/g, 'X');
					$("#print-barcode p").text(barcode);

					var security_code = data.security_code;
					security_code = security_code.replace(/[a-zA-Z0-9]/g, "X");
					$("#print-security p").text(security_code);

                    if (localization == "en")
                        var report_preferred_lang = "English";
					else if (localization == "ms")
						var report_preferred_lang = "Bahasa Inggeris";
                    else if (localization == "zh")
                        var report_preferred_lang = "英语";

					$("#print-language p").text(report_preferred_lang);
					$("#print-weight p").text(data.weight);
					$("#print-height p").text(data.height);
					$("#print-alcohol p").text(data.alcohol_intake_trans);
					$("#print-sleeping p").text(data.sleeping_hours_trans);

					if (data.is_exercise == 0)
						$("#print-exercise p").text(localeObject[localization]["st_none"]);
					else {
						$("#print-exercise p").text(data.exercise_freq_trans);
					}

					if (data.delivery_method == 1) {
                        $("#print-method p").text(localeObject[localization]["st_pickup"]);

                        if (country == "MY") {
                          $(".pickup-address").css("display", "flex");

                          $("#print-address p").text(data.pickup_address);

                          var dateTime = data.pickup_date.split(" ");

                          var date = dateTime[0];

                          $("#print-date p").text(date);
                          $("#print-timeslot p").text(data.pickup_timeslot);
                          $(".print-pickup-date").css("display", "flex");
                          $(".print-pickup-timeslot").css("display", "flex");
                        } else {
                          $(".pickup-address").css("display", "none");
                          $(".print-pickup-date").css("display", "none");
                          $(".print-pickup-timeslot").css("display", "none");
                        }
						$(".print-dropoff-venue").css("display", "none");
					} else {
						$("#print-method p").text(
							localeObject[localization]["submit_dropOffEvent"]
						);

						if (data.drop_off_venue != null) {
							$(".print-dropoff-venue").css("display", "flex");
							$("#print-dropoff-venue p").text(data.drop_off_venue);
                        } else {
                            $(".print-dropoff-venue").css("display", "none");
                        }

						$(".print-pickup-date").css("display", "none");
						$(".print-pickup-timeslot").css("display", "none");

						$(".pickup-address").hide();
					}

					if (!data.skin_problem && !data.skin_problem_others) {
						$(".print-skin-q1").css("display", "none");
						$(".print-skin-q2").css("display", "none");
					} else {
						$(".print-skin-q1").css("display", "flex");
						$(".print-skin-q2").css("display", "flex");

						var html = "";

						var skin_problem_array = data.skin_problem_trans.split(",");

						html += "<ul>";
						for (var i = 0; i < skin_problem_array.length; i++) {
							html += "<li><p>" + skin_problem_array[i] + "</p></li>";
						}

						html += "</ul>";

						$("#print-skin-q1").html(html);

						var html = "";

						var skin_type_array = data.skin_type_trans.split(",");

						html += "<ul>";
						for (var i = 0; i < skin_type_array.length; i++) {
							html += "<li><p>" + skin_type_array[i] + "</p></li>";
						}
						html += "</ul>";

						$("#print-skin-q2").html(html);
					}

					$(".submit-test-kit-step-2").css("display", "none");
					$(".submit-test-kit-step-3").css("display", "block");

					$(".step2").addClass("completed");
					$(".step2").removeClass("checked");

					$(".step3").addClass("checked");
					$(".step3").removeClass("uncheck");
				},
				error: function (data) {
					// alert('data');

					var response = JSON.parse(data.responseText);

					if (response.message == "token_expired") {
						promptTokenExpired();
						$(".navLoader").css("display", "none");
					} else {
						Swal.fire({
							type: "error",
							title: localeObject[localization]["errorText"],
							text: response.message,
							animation: false,
							customClass: {
								popup: "animated fadeIn",
							},
						});
					}
				},
				complete: function (data) {
					// console.log(data);
					removeLoading();
				},
			});
		},
	});

	if (localization == "en") {
		jQuery.extend(jQuery.validator.messages, {
			required: "This field is required.",
			remote: "Please fix this field.",
			email: "Please enter a valid email address.",
			validemail: jQuery.validator.format(
				"Please enter a valid email address."
			),
			url: "Please enter a valid URL.",
			date: "Please enter a valid date.",
			dateISO: "Please enter a valid date (ISO).",
			number: "Please enter a valid number.",
			digits: "Please enter only digits.",
			creditcard: "Please enter a valid credit card number.",
			equalTo: "Please enter the same value again.",
			validpassword: jQuery.validator.format(
				"Please enter at least 8 characters which consists of lowercase letters, uppercase letters and numerals."
			),
			accept: "Please enter a value with a valid extension.",
			maxlength: jQuery.validator.format(
				"Please enter no more than {0} characters."
			),
			minlength: jQuery.validator.format(
				"Please enter at least {0} characters."
			),
			rangelength: jQuery.validator.format(
				"Please enter a value between {0} and {1} characters long."
			),
			range: jQuery.validator.format(
				"Please enter a value between {0} and {1}."
			),
			max: jQuery.validator.format(
				"Please enter a value less than or equal to {0}."
			),
			min: jQuery.validator.format(
				"Please enter a value greater than or equal to {0}."
			),
			CheckDOB: "Please enter valid date format.",
			checkDeliveryDateWeekend: "Please select weekdays only.",
			checkDeliveryDate: "Please select 1 day after today.",
		});
	} else if (localization == "ms") {
		jQuery.extend(jQuery.validator.messages, {
			required: "Ruangan ini wajib diisi.",
			remote: "Sila betulkan ruangan ini.",
			email: "Sila masukkan alamat e-mel yang sah.",
			validemail: jQuery.validator.format(
				"Sila masukkan alamat e-mel yang sah."
			),
			url: "Sila masukkan URL yang sah.",
			date: "Sila masukkan tarikh yang sah.",
			dateISO: "Sila masukkan tarikh yang sah (ISO).",
			number: "Sila masukkan nombor yang sah.",
			digits: "Sila masukkan nombor sahaja.",
			creditcard: "SIla masukkan nombor kad kredit yang sah.",
			equalTo: "Sila masukkan nilai yang sama sekali lagi.",
			validpassword: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya 8 aksara yang terdiri daripada huruf kecil, huruf besar dan angka."
			),
			accept: "Sila masukkan nilai dengan sambungan sah.",
			maxlength: jQuery.validator.format(
				"Sila masukkan tidak melebihi {0} aksara."
			),
			minlength: jQuery.validator.format(
				"Sila masukkan sekurang-kurangnya {0} aksara."
			),
			rangelength: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara panjang."
			),
			range: jQuery.validator.format(
				"Sila masukkan nilai di antara {0} dan {1} aksara."
			),
			max: jQuery.validator.format(
				"Sila masukkan nilai sekurang-kurangnya atau sama dengan {0}."
			),
			min: jQuery.validator.format(
				"Sila masukkan nilai melebihi atau sama dengan {0}."
			),
			CheckDOB: "Sila masukkan format tarikh yang sah.",
			checkDeliveryDateWeekend: "Sila pilih hari bekerja sahaja.",
			checkDeliveryDate: "Sila pilih tarikh selepas hari ini.",
		});
	} else if (localization == "zh") {
		jQuery.extend(jQuery.validator.messages, {
			required: "此为必填项.",
			remote: "请更正此项目.",
			email: "请输入有效的电邮地址.",
			validemail: jQuery.validator.format("请输入有效的电邮地址."),
			url: "请输入有效的网址.",
			date: "请输入有效的日期.",
			dateISO: "请输入有效的日期(ISO).",
			number: "请输入有效的数字.",
			digits: "请只输入号码.",
			creditcard: "请输入有效的信用卡号码.",
			equalTo: "请再次输入一样的字符串.",
			validpassword: jQuery.validator.format(
				"请输入至少8个字符，包括小写字母，大写字母和数字."
			),
			accept: "请输入拥有有效后缀名的字符串.",
			maxlength: jQuery.validator.format("请输入不多于 {0}个的字母."),
			minlength: jQuery.validator.format("请输入至少 {0}个的字数."),
			rangelength: jQuery.validator.format(
				"请输入一个长度介于 {0} 和 {1} 之间的字符串."
			),
			range: jQuery.validator.format("请输入一个介于 {0} 和 {1} 之间的字符串."),
			max: jQuery.validator.format("请输入一个 长度最少是 {0} 的字符串."),
			min: jQuery.validator.format("请输入一个最小为{0} 的字符串."),
			CheckDOB: "请输入有效的日期格式。",
			checkDeliveryDateWeekend: "请仅选择工作日。",
			checkDeliveryDate: "请选择今天之后的日期",
		});
	}
}

function stepThreeSubmitFunction () {
	var urlParams = new URLSearchParams(window.location.search);

	var data = {
		testkit_id: decodeURIComponent(urlParams.get("testkit_id")),
		step: 3,
	};

	var url = apipath + "testkit";

	loading();

	$.ajax({
		url: url,
		type: "POST",
		headers: {
			Authorization: "Bearer " + getCookie("ty_access_token"),
			"X-localization": localization,
		},
		data: JSON.stringify(data),
		contentType: "application/json", // tell jQuery not to set contentType
		success: function (data) {
			window.location.href = redirectPath + "/submit-test-kit-complete";
		},
		error: function (data) {
			var response = JSON.parse(data.responseText);

			if (response.message == "token_expired") {
				promptTokenExpired();
				$(".navLoader").css("display", "none");
			} else {
				Swal.fire({
					type: "error",
					title: localeObject[localization]["errorText"],
					text: response.message,
					animation: false,
					customClass: {
						popup: "animated fadeIn",
					},
				});
			}
		},
		complete: function (data) {
			// console.log(data);
		},
	});
}

//Exercise Question
$("#exercise_5").change(function () {
	var id = $(this).children(":selected").val();

	if (id == "Yes") {
		$("#exercise_6").parent("li").show();
	} else {
		$("#exercise_6").parent("li").hide();
	}
});

//Exercise Question
$("#exercise").change(function () {
	var id = $(this).children(":selected").val();

	if (id == "Yes") {
		$("#exercise_duration").css("display", "block");
		$(".exercise-duration-label").css("display", "block");
	} else {
		$("#exercise_duration").css("display", "none");
		$(".exercise-duration-label").css("display", "none");
	}
});

//Race selection//
$("#race-list").change(function () {
	var id = $(this).children(":selected").val();

	if (id == "others") {
		$(".other-races").css("display", "block");
	} else {
		$(".other-races").css("display", "none");
	}
});

//Pick up drop off method
$("#pickUp, #dropOff").click(function () {
	deliveryMethod();
});

$("#step-one-submit-btn").click(function () {
	deliveryMethod();
	deliveryType();
});

$("#pickup-address-type").change(function () {
	deliveryType();
});

//security code autotab//
$(".security-code-autotab").autotab({
	format: "alphanumeric",
	uppercase: true,
});
//security code autotab end//

function deliveryType () {
	var address_type = $("#pickup-address-type").find(":selected").val();
	if (address_type == "Company") {
		$(".pickup-company-name").css("display", "block");
	} else {
		$(".pickup-company-name").css("display", "none");
	}
}

function deliveryMethod() {
    if (document.getElementById('pickUp').checked) {
    	$('.pickup-address-type').css('display', 'block');
		$('.pickup-location').css('display', 'block');
		$('.pickup-company-name').css('display','none');
        // $('.state').css('display', 'block');
        $('.state').css('display', 'none');
        $('.dropOff-location').css('display','none');
        $('.dropOff-location-disclaimer').css('display', 'none');
		$('.store-btn').css('display','none');
		selectPickupDate();
	} else if (document.getElementById('dropOff').checked) {
		$('.pickup-address-type').css('display', 'none');
		$('.pickup-company-name').css('display', 'none');
		$('.pickup-location').css('display', 'none');
		$('.state').css('display', 'none');
		$('.store-btn').css('display','block');
		$('.time-slot').css('display', 'none');
        $('.pickup-date').css('display', 'none');
        $('.dropOff-location').css('display','block');

        if (country == "MY") {
          $(".dropOff-location-disclaimer").css("display", "none");
        } else {
          $(".dropOff-location").css("display", "none");
          $(".dropOff-location-disclaimer").css("display", "block");
          $(".pickup-address-type").css("display", "none");
          $(".pickup-company-name").css("display", "none");
        }

		// Swal.fire({
		// 	type: 'info',
		// 	title: localeObject[localization]['submit_info'],
		// 	text: localeObject[localization]['submit_info_text'],
		// 	animation: false,
		// 	customClass: {
		// 		popup: 'animated fadeIn'
		// 	}
		// });
	}
}

function selectPickupDate() {
	$('.pickup-date').css('display', 'block');
	$('.time-slot').css('display', 'block');
	$('#pickup-date').datepicker('remove');

	// $(function() {
		var myDate = new Date();
        // myDate.setDate(myDate.getDate() + 8);
        // var adjustments = [0, 0, 2, 2, 2, 2, 1]; // Offsets by day of the week. Sunday - Saturday : 0 - 6
        // myDate.setDate(myDate.getDate() + 4 + adjustments[myDate.getDay()]);

        var adjustments = [1, 1, 1, 1, 2, 3, 2]; // Offsets by day of the week. Sunday - Saturday : 0 - 6
        myDate.setDate(myDate.getDate() + 1 + adjustments[myDate.getDay()]);
        var startDate = myDate;

		$('#pickup-date').datepicker({
			format: 'yyyy/mm/dd',
			todayHighlight: false,
            startDate: startDate,
            endDate: '+1m +1d',
			daysOfWeekDisabled: [0, 6],
			keyboardNavigation: false
		});
	// });
}

//Skin Question change
function uncheckAll () {
	if ($("#none").prop("checked")) {
		$(".skin-q1").not("#none").prop("checked", false);
	}
}

function checkSkin () {
	$("#none").prop("checked", false);
}

function showOther () {
	if ($("#skin-q1-others").prop("checked")) {
		$("#other-skin-problem").css("display", "block");
	} else {
		$("#other-skin-problem").css("display", "none");
	}
}

//Medical 25 Question change
function uncheckMedicalAll () {
	if ($("#others").prop("checked")) {
		$(".medical-25").not("#none").prop("checked", false);
	}
}

function checkMedical () {
	$("#others").prop("checked", false);
}

function showMedicalOther () {
	if ($("#medical-25-others").prop("checked")) {
		$("#other-medical-25").css("display", "block");
	} else {
		$("#other-medical-25").css("display", "none");
	}
}

// REPORT
var allParameter;
var summary;
var userList;

function report () {
	allParameter = [];

	loading();

	var url = apipath + "user/report";

	var language = localization;

	if (language == "ms") language = "en";

	$.ajax({
		url: url,
		type: "GET",
		headers: {
			"X-localization": localization,
			Authorization: "Bearer " + getCookie("ty_access_token"),
		},
		contentType: "application/json", // tell jQuery not to set contentType
		success: function (data) {

			$("#report_selected_language").val(data['preferred_language']);

			$('#report_selected_language').change(function(e){
				checkLanguageAvailability($( "#report_selected_language" ).val());
			});

			if (data["process_status"] == "processing") {
				$(".content.not-registered-content").addClass("hide");
				$(".content.processing-content").removeClass("hide");
			}

			if (data["process_status"] == "pending_generation") {
                if (data['preferred_language'] == "English"){
                    if (localization == "en"){
                        var span_preferred_lang = "English";
                    }else if (localization == "ms"){
                        var span_preferred_lang = "Bahasa Inggeris";
                    }else {
                        var span_preferred_lang = "英语";
                    }
                }else if (data['preferred_language'] == "Malay"){
                    if (localization == "en"){
                        var span_preferred_lang = "Malay";
                    }else if (localization == "ms"){
                        var span_preferred_lang = "Bahasa Melayu";
                    }else {
                        var span_preferred_lang = "国文";
                    }
                }else {
                    if (localization == "en"){
                        var span_preferred_lang = "Chinese";
                    }else if (localization == "ms"){
                        var span_preferred_lang = "Bahasa Cina";
                    }else {
                        var span_preferred_lang = "中文";
                    }
                }

				$('.content.not-registered-content').addClass('hide');
				$('.content.ready-content').removeClass('hide');
				// $('#report_selected_language').attr('disabled', true);
				$('#report_selected_language option[value="'+data['preferred_language']+'"]').attr('disabled', true);
				$('.pdf-pending-generation.hide').removeClass('hide');
				$('.pdf-pending-generation span').text(span_preferred_lang);
				$('.pdf-generated').addClass('hide');
				$('.pdf-generated').next('.no-report-btn-container').addClass('hide');
			}

			if(data['process_status'] == 'completed') {
				$('.content.not-registered-content').addClass('hide');
				$('.content.ready-content').removeClass('hide');

				if(data['pdf'])
					$('.content.ready-content .submit.view-report-btn').attr('href', data['pdf']);

				if(data['pdf_date'])
					$('.pdf-generated.hide').removeClass('hide').find('span').text(data['pdf_date']);

				if(data['recommended'])
					$('.content.ready-content .submit.view-recommended-btn').attr('href', data['recommended']);
				else
					$('.content.ready-content .submit.view-recommended-btn').addClass('hide');
			}

			removeLoading();
		},
		error: function (data) {
			removeLoading();

			var response = JSON.parse(data.responseText);

			if (response.message == "token_expired") {
				promptTokenExpired();
				$(".navLoader").css("display", "none");
			} else {
				Swal.fire({
					type: "error",
					title: localeObject[localization]["errorText"],
					text: response.message,
					animation: false,
					customClass: {
						popup: "animated fadeIn",
					},
				});
			}
		},
		complete: function (data) {
			// console.log(data);
		},
	});
}

function checkLanguageAvailability (language) {
	loading();
	var url = apipath + "user/report/language";
	var data = { language: language };
	$.ajax({
		url: url,
		type: "GET",
		data: data,
		headers: {
			"X-localization": localization,
			Authorization: "Bearer " + getCookie("ty_access_token"),
		},
		contentType: "application/json", // tell jQuery not to set contentType
		success: function (data) {
			log('checkLanguageAvailability', data);
			// $(".no-report-btn-container").eq(3).show();
			// $(".pdf-generated").removeClass('hide');
			// $(".pdf-pending-generation").addClass('hide');
			if(data['process_status'] == 'completed') {

				$('.pdf-pending-generation').addClass('hide');
				$('.pdf-generated').removeClass('hide');
				$('.pdf-generated').next('.no-report-btn-container').removeClass('hide');

				if(data['pdf'])
					$('.content.ready-content .submit.view-report-btn').removeClass('hide').attr('href', data['pdf']);
				else 
					$('.content.ready-content .submit.view-report-btn').addClass('hide');

				if(data['pdf_date'])
					$('.pdf-generated').removeClass('hide').find('span').text(data['pdf_date']);
				else
					$('.pdf-generated').addClass('hide');

				if(data['recommended'])
					$('.content.ready-content .submit.view-recommended-btn').removeClass('hide').attr('href', data['recommended']);
				else
					$('.content.ready-content .submit.view-recommended-btn').addClass('hide');
			}
			removeLoading();
		},
		error: function (data) {
			removeLoading();
			var response = JSON.parse(data.responseText);
			if (response.message == "token_expired") {
				promptTokenExpired();
				$(".navLoader").css("display", "none");
			} else if (response.process_status == "pending_generation") {

                if (response.preferred_language == "English"){
                    if (localization == "en"){
                        var span_preferred_lang = "English";
                    }else if (localization == "ms"){
                        var span_preferred_lang = "Bahasa Inggeris";
                    }else {
                        var span_preferred_lang = "英语";
                    }
                }else if (response.preferred_language == "Malay"){
                    if (localization == "en"){
                        var span_preferred_lang = "Malay";
                    }else if (localization == "ms"){
                        var span_preferred_lang = "Bahasa Melayu";
                    }else {
                        var span_preferred_lang = "国文";
                    }
                }else {
                    if (localization == "en"){
                        var span_preferred_lang = "Chinese";
                    }else if (localization == "ms"){
                        var span_preferred_lang = "Bahasa Cina";
                    }else {
                        var span_preferred_lang = "中文";
                    }
                }

				$('#report_selected_language option[value="'+response.preferred_language+'"]').attr('disabled', true);
				$('.pdf-pending-generation').removeClass('hide');
				$('.pdf-pending-generation span').text(span_preferred_lang);
				$('.pdf-generated').addClass('hide');
				$('.pdf-generated').next('.no-report-btn-container').addClass('hide');
			} else {
				Swal.fire({
					type: "error",
					title: localeObject[localization]["errorText"],
					text: response.message,
					animation: false,
					customClass: {
						popup: "animated fadeIn",
					},
				});
			}
		},
		complete: function (data) {
			// console.log(data);
		},
	});
}

function generateHTMLReport (barcode, name, preferred_lang, filename) {
	var url = reportpath + barcode + "/" + filename;

	$.ajax({
		url: url,
		type: "GET",
		headers: { "X-localization": localization },
		contentType: "application/json", // tell jQuery not to set contentType
		success: function (data) {
			data = jQuery.parseJSON(data);

			var userInfo = data[0].user;

			var queryString = "?id=" + userInfo.report_id;
			var reportNavHtml = "";

			reportNavHtml += '<ul data-accordion-menu data-multi-open="false">';
			reportNavHtml += '<li class="name-wrapper">';
			reportNavHtml += '<a class="name" href="#">' + name + "</a>";
			reportNavHtml += '<ul class="sub-name-wrapper">';

			for (var i = 0; i < userList.length; i++) {
				if (userList[i]["name"] != name)
					reportNavHtml +=
						'<li><a href="javascript:userListChange(' +
						i +
						')">' +
						userList[i]["name"] +
						"</a></li>";
			}

			// if($('.sub-name-wrapper').has('li')) {
			//     $(this).addClass('multi');
			// } else {
			//     $(this).addClass('single');
			// }

			reportNavHtml += "</ul>";
			reportNavHtml += "</li>";
			reportNavHtml += '<li class="sub-wrapper">';
			reportNavHtml += '<a class="sub-container" href="#"></a>';
			reportNavHtml += "<ul>";
			// reportNavHtml += '<li>';
			// reportNavHtml += '<a class="healthyme" href="javascript:summaryAttr();">' + data[0].module.module_name[0].module_name + '</a>';
			// reportNavHtml += '</li>';
			reportNavHtml += "<li>";
			if (localization == "zh") {
				reportNavHtml +=
					'<a class="shareable" href="' +
					redirectPath +
					"/shareable-report" +
					queryString +
					'">分享我的报告</a>';
			} else {
				reportNavHtml +=
					'<a class="shareable" href="' +
					redirectPath +
					"/shareable-report" +
					queryString +
					'">Share my report</a>';
			}
			reportNavHtml += "</li>";
			reportNavHtml += "<li>";

			// if (preferred_lang == 'English') {
			// 	var downloadAttr = "'" + barcode + "', 'en'";
			// } else if (preferred_lang == 'Chinese') {
			// 	var downloadAttr = "'" + barcode + "', 'zh'";
			// }

			var downloadAttr = "'" + barcode + "', '" + localization + "'";
			if (localization == "zh") {
				reportNavHtml +=
					'<a class="download" id="downloadPDF" href="javascript:downloadPDF(' +
					downloadAttr +
					');">下载我的报告</a>';
			} else {
				reportNavHtml +=
					'<a class="download" id="downloadPDF" href="javascript:downloadPDF(' +
					downloadAttr +
					');">Download my report</a>';
			}
			reportNavHtml += "</li>";
			reportNavHtml += "</ul>";
			reportNavHtml += "</li>";
			reportNavHtml += "</ul>";

			$("#reportNav").html(reportNavHtml);
			$("#reportNav").foundation();
			$(".healthyme").click(function () {
				$(".submenu.is-accordion-submenu").css("display", "none");
			});

			allParameter = [];

			for (var j = 0; j < data.length; j++) {
				var parameter = data[j]["parameter"];

				summary = data[j]["summary"];

				for (var i = 0; i < parameter.length; i++) {
					var key = Object.keys(parameter[i]);
					var values = Object.keys(parameter[i]).map(function (key) {
						return parameter[i][key];
					});
					// Object.values(parameter[i]);

					var value = values[0];

					for (var k = 0; k < value.length; k++) {
						allParameter.push(value[k]);
					}

					var prevNextHtml = "";
					var paramLang = localization === "zh" ? "zh" : "en";
					prevNextHtml +=
						'<a class="btn-prev-' +
						paramLang +
						' null" href="/" onclick="return false;"></a>';
					prevNextHtml +=
						'<a class="btn-next-' +
						paramLang +
						'"href="javascript:reportAttr(0);"></a>';

					$("#pageAHref").html(prevNextHtml);
				}

				var summaryKey = ["High", "Normal", "Low"];

				var html = "";
				html += '<div class="row">';
				html += '<table class="summary">';
				if (localization == "zh") {
					html += '<thead class="zh">';
					html += "<tr>";
					html += '<td colspan="2">HealthyMe</td>';
				} else {
					html += '<thead class="en-ms">';
					html += "<tr>";
					html += '<td colspan="2">HealthyMe</td>';
				}
				html += "<td></td>";
				html += "<td></td>";
				html += "<td></td>";
				html += "</tr>";
				html += "</thead>";
				html += "<tbody>";

				for (var i = 0; i < summaryKey.length; i++) {
					var parameterSummary = summary[summaryKey[i]];

					if (summary[summaryKey[i]] != null) {
						for (var h = 0; h < parameterSummary.length; h++) {
							var index = 0;

							allParameter.some(function (entry, i) {
								if (
									entry.parameter_translation[0].parameter ==
									parameterSummary[h].title
								) {
									index = i;
									return true;
								}
							});

							html +=
								'<tr class="' + parameterSummary[h].level.toLowerCase() + '">';
							html += "<td>";
							html +=
								'<source data-srcset="' +
								baseUrl +
								"assets/images/report/parameters/" +
								parameterSummary[h].icon +
								'.webp" type="image/webp" />';
							html +=
								'<source data-srcset="' +
								baseUrl +
								"assets/images/report/parameters/" +
								parameterSummary[h].icon +
								'.png" type="image/png" />';
							html +=
								'<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-src="' +
								baseUrl +
								"assets/images/report/parameters/" +
								parameterSummary[h].icon +
								'.png" class="lazyload" alt="" />';
							html += "</td>";
							html +=
								'<td><a href="javascript:reportAttr(' +
								index +
								');">' +
								parameterSummary[h].title +
								"</a></td>";
							html += "<td></td>";
							html += "<td></td>";
							html += "<td></td>";
							html += "<td></td>";
							html += "</tr>";
						}
					}
				}
			}

			html += "</tbody>";
			html += "</table>";
			html += "</div>";

			$("#parameter").html(html);
		},
		error: function (data) {
			var response = JSON.parse(data.responseText);

			if (response.message == "token_expired") {
				promptTokenExpired();
				$(".navLoader").css("display", "none");
			}
		},
		complete: function (data) { },
	});
}

function userListChange (index) {
	var barcode = userList[index]["barcode"];
	var name = userList[index]["name"];
	var preferred_lang = userList[index]["preferred_lang"];

	for (var i = 0; i < userList[index]["report_file"].length; i++) {
		$lang = userList[index]["report_file"][i].split("_");

		if ($lang[0] == localization)
			var filename = userList[index]["report_file"][i];
	}

	generateHTMLReport(barcode, name, preferred_lang, filename);
}

function downloadPDF (barcode, lang) {
	var url = pdfpath + "true-you/report";

	loading();

	var data = { barcode: barcode, lang: lang };

	$.ajax({
		url: url,
		type: "POST",
		data: JSON.stringify(data),
		crossDomain: true,
		cache: false,
		contentType: "application/json", // tell jQuery not to set contentType
		success: function (data) {
			$.ajax({
				url: data,
				method: "GET",
				xhrFields: {
					responseType: "blob",
				},
				processData: false,
				success: function (responseData) {
					removeLoading();

					if (window.navigator.userAgent.indexOf("Trident/") != -1) {
						window.navigator.msSaveBlob(responseData, data.split("/").pop());
					} else if (window.navigator.userAgent.indexOf("Edge/") != -1) {
						window.navigator.msSaveBlob(responseData, data.split("/").pop());
					} else {
						var url = window.URL.createObjectURL(responseData);
						var a = document.createElement("a");
						a.href = url;
						a.download = data.split("/").pop();
						document.body.appendChild(a);
						a.click();
						a.remove();
						window.URL.revokeObjectURL(url);
					}
				},
			});
		},
		error: function (data) {
			log(data.responseText);
			var response = JSON.parse(data.responseText);

			removeLoading();

			if (response.message == "token_expired") {
				promptTokenExpired();
				$(".navLoader").css("display", "none");
			} else {
				Swal.fire({
					type: "error",
					title: localeObject[localization]["errorText"],
					text: response.message,
					animation: false,
					customClass: {
						popup: "animated fadeIn",
					},
				});
			}
			// window.location.href = redirectPath + '/login';
		},
		complete: function (data) {
			// console.log(data);
		},
	});
}

function summaryAttr () {
	var summaryKey = ["High", "Normal", "Low"];

	var html = "";

	html += '<div class="row">';
	html += '<table class="summary">';
	html += "<thead>";
	html += "<tr>";
	if (localization == "zh") {
		html += '<thead class="zh">';
		html += "<tr>";
		html += '<td colspan="2">HealthyMe</td>';
	} else {
		html += '<thead class="en-ms">';
		html += "<tr>";
		html += '<td colspan="2">HealthyMe</td>';
	}
	html += "<td></td>";
	html += "<td></td>";
	html += "<td></td>";
	html += "</tr>";
	html += "</thead>";
	html += "<tbody>";

	for (var i = 0; i < summaryKey.length; i++) {
		var parameterSummary = summary[summaryKey[i]];

		if (summary[summaryKey[i]] != null) {
			for (var h = 0; h < parameterSummary.length; h++) {
				var index = 0;

				allParameter.some(function (entry, i) {
					if (
						entry.parameter_translation[0].parameter ==
						parameterSummary[h].title
					) {
						index = i;
						return true;
					}
				});

				html += '<tr class="' + parameterSummary[h].level.toLowerCase() + '">';
				html += "<td>";
				html +=
					'<source data-srcset="' +
					baseUrl +
					"assets/images/report/parameters/" +
					parameterSummary[h].icon +
					'.webp" type="image/webp" />';
				html +=
					'<source data-srcset="' +
					baseUrl +
					"assets/images/report/parameters/" +
					parameterSummary[h].icon +
					'.png" type="image/png" />';
				html +=
					'<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-src="' +
					baseUrl +
					"assets/images/report/parameters/" +
					parameterSummary[h].icon +
					'.png" class="lazyload" alt="" />';
				html += "</td>";
				html +=
					'<td><a href="javascript:reportAttr(' +
					index +
					');">' +
					parameterSummary[h].title +
					"</a></td>";
				html += "<td></td>";
				html += "<td></td>";
				html += "<td></td>";
				html += "<td></td>";
				html += "</tr>";
			}
		}
	}

	html += "</tbody>";
	html += "</table>";
	html += "</div>";

	$("#parameter").html(html);

	var prevNextHtml = "";
	var paramLang = localization === "zh" ? "zh" : "en";
	prevNextHtml +=
		'<a class="btn-prev-' +
		paramLang +
		' null" href="/" onclick="return false;"></a>';
	prevNextHtml +=
		'<a class="btn-next-' +
		paramLang +
		'"href="javascript:reportAttr(0);"></a>';

	$("#pageAHref").html(prevNextHtml);
}

function reportAttr (index) {
	var details = allParameter[index];

	var html = "";

	html += '<div class="row">';
	html += '<div class="header">';
	html += '<div class="title-wrapper">';
	html += '<picture class="icon">';

	var iconName = details.parameter.toLowerCase().split(" ").join("-");

	html +=
		'<source type="image/webp" srcset="' +
		baseUrl +
		"assets/images/report/parameters/" +
		iconName +
		'.webp"/>';
	html +=
		'<img src="' +
		baseUrl +
		"assets/images/report/parameters/" +
		iconName +
		'.png" alt="' +
		iconName +
		'"/>';
	html += "</picture>";
	html +=
		"<h3>" + details.parameter_translation[0].parameter.toUpperCase() + "</h3>";
	html += "</div>";
	html += '<div class="readcontent">';
	html += details.parameter_translation[0].parameter_desc;
	html += "</div>";
	html += "</div>";
	html += '<div class="content">';

	var h4_results = localization === "zh" ? "基因报告:" : "YOUR RESULTS:";
	html += "<h4>" + h4_results + "</h4>";

	html += '<ul class="gauge">';
	for (var i = 0; i < details.all_risk.length; i++) {
		if (details.risk_level == details.all_risk[i]) {
			html += '<li class="' + details.risk_level.toLowerCase() + ' active">';
		} else {
			html += "<li>";
		}

		html += "<ul>";
		html += "<li>" + details.all_risk[i].toUpperCase() + "</li>";
		html += "<li></li>";
		html += "</ul>";
		html += "</li>";
	}

	html += "</ul>";

	html += '<div class="genotype">';
	var h4_genotype =
		localization === "zh" ? "基因型报告:" : "YOUR GENOTYPE RESULTS:";
	html += "<h4>" + h4_genotype + "</h4>";
	html += "<table>";
	html += "<thead>";
	html += "<tr>";

	var td_gene = localization === "zh" ? "基因" : "Gene";
	html += "<td>" + td_gene + "</td>";
	var td_genotype = localization === "zh" ? "基因型" : "Genotype";
	html += "<td>" + td_genotype + "</td>";
	var td_description = localization === "zh" ? "基因型说明" : "Description";
	html += "<td>" + td_description + "</td>";

	html += "</tr>";
	html += "</thead>";
	html += "<tbody>";

	for (var i = 0; i < details.genotype.length; i++) {
		html += "<tr>";
		html += "<td>" + details.genotype[i].gene + "</td>";
		html += "<td>" + details.genotype[i].genotype[0].genotype + "</td>";
		html += "<td>" + details.genotype[i].genotype[0].desc + "</td>";
		html += "</tr>";
	}

	html += "</tbody>";
	html += "</table>";
	html += "</div>";

	html += '<div class="recommendations">';

	var h4_recommendations = localization === "zh" ? "建议:" : "RECOMMENDATIONS:";
	html += "<h4>" + h4_recommendations + "</h4>";

	html += details.parameter_risk_content[0].recommendation_desc;
	html += "</div>";
	html += "</div>";
	html += "</div>";
	// html += html;
	$("#parameter").html(html);

	var readMore = localization === "zh" ? "查看更多" : "Read More";
	var readLess = localization === "zh" ? "查看简介" : "Read Less";

	$(".readcontent").readmore({
		collapsedHeight: 90,
		moreLink: '<a class="rm-link" href="#"><br>' + readMore + "</a>",
		lessLink: '<a class="rm-link" href="#"><br>' + readLess + "</a>",
	});

	var prevNextHtml = "";

	$("#pageAHref").html(prevNextHtml);

	var next = localization === "zh" ? "下一页" : "Next";
	var prev = localization === "zh" ? "前一页" : "Previous";

	var paramLang = localization === "zh" ? "zh" : "en";

	if (index > 0) {
		var prev = index - 1;
		prevNextHtml +=
			'<a class="btn-prev-' +
			paramLang +
			'" href="javascript:reportAttr(' +
			prev +
			');"></a>';
	} else {
		prevNextHtml +=
			'<a class="btn-prev-' +
			paramLang +
			'" href="javascript:summaryAttr();"></a>';
	}

	if (index + 1 > allParameter.length - 1) {
		prevNextHtml +=
			'<a class="btn-next-' +
			paramLang +
			' null" href="/" onclick="return false;"></a>';
	} else {
		var next = index + 1;
		prevNextHtml +=
			'<a class="btn-next-' +
			paramLang +
			'" href="javascript:reportAttr(' +
			next +
			');"></a>';
	}

	$("#pageAHref").html(prevNextHtml);

	window.scrollTo(0, 0);
}

function shareableReport () {
	loading();

	var urlParams = new URLSearchParams(window.location.search);
	// log(urlParams.has('id'));
	if (!urlParams.has("id")) window.location.href = redirectPath + "/";

	var report_id = urlParams.get("id");

	var url = apipath + "shareable-report";

	var data = { report_id: report_id };

	$.ajax({
		url: url,
		type: "GET",
		headers: { "X-localization": localization },
		data: data,
		contentType: "application/json", // tell jQuery not to set contentType
		success: function (data) {
			var barcode = data.barcode;

			for (var i = 0; i < data.reportFile.length; i++) {
				$lang = data.reportFile[i].split("_");

				if (localization == $lang[0]) var filename = data.reportFile[i];
			}

			var url = reportpath + barcode + "/" + filename;

			$.ajax({
				url: url,
				type: "GET",
				headers: { "X-localization": localization },
				contentType: "application/json", // tell jQuery not to set contentType
				success: function (data) {
					data = jQuery.parseJSON(data);

					$("#fullname").html(data[0].user.fullname);

					var html = "";

					html += '<span class="pattern-bg left" data-mh="pattern"></span>';
					html += '<span class="pattern-bg right" data-mh="pattern"></span>';

					var shareParameter = [];

					for (var j = 0; j < data.length; j++) {
						var parameter = data[j]["parameter"];

						summary = data[j]["summary"];

						for (var i = 0; i < parameter.length; i++) {
							var values = Object.keys(parameter[i]).map(function (e) {
								return parameter[i][e];
							});

							var value = values[0];

							for (var k = 0; k < value.length; k++) {
								log(value[k].parameter_translation[0]);
								log(value[k].parameter_risk_content[0]);
								if (value[k].parameter_risk_content[0].share_desc != null)
									shareParameter.push(value[k]);
							}
						}
					}

					for (var i = 0; i < shareParameter.length; i++) {
						log(shareParameter[i].parameter_translation);

						if (
							shareParameter[i].risk_level == "高" ||
							shareParameter[i].risk_level == "Tinggi" ||
							shareParameter[i].risk_level == "High"
						) {
							var risk_level = "high";
						} else if (
							shareParameter[i].risk_level == "普通" ||
							shareParameter[i].risk_level == "Biasa" ||
							shareParameter[i].risk_level == "Normal"
						) {
							var risk_level = "normal";
						} else if (
							shareParameter[i].risk_level == "低" ||
							shareParameter[i].risk_level == "Rendah" ||
							shareParameter[i].risk_level == "Low"
						) {
							var risk_level = "low";
						}
						console.log(localization);
						html +=
							'<section class="shareable-modules-section ' +
							risk_level +
							" " +
							localization +
							'">';
						html += '<div class="module-container">';
						html += '<div class="contents">';
						html += '<div class="level">';
						html += "<span></span>";
						html += "</div>";
						html +=
							"<h3>" +
							shareParameter[
								i
							].parameter_translation[0].parameter.toUpperCase() +
							"</h3>";
						html +=
							"<p>" +
							shareParameter[i].parameter_risk_content[0].share_desc +
							"</p>";
						html += "</div>";
						html += '<div class="image">';

						var iconName = shareParameter[i].parameter
							.toLowerCase()
							.split(" ")
							.join("-");

						html +=
							'<img src="' +
							baseUrl +
							"assets/images/shareable-report/" +
							iconName +
							'.png" data-mh="param-image" alt="' +
							shareParameter[
								i
							].parameter_translation[0].parameter.toUpperCase() +
							'">';
						html += "</div>";
						html += "</div>";
						html += "</section>";
					}

					$("#shareableReport").html(html);
					$("[data-mh]").matchHeight();

					removeLoading();
				},
				error: function (data) {
					removeLoading();
				},
				complete: function (data) { },
			});
		},
		error: function (data) {
			log(data);
			var response = JSON.parse(data.responseText);

			removeLoading();

			if (response.message == "token_expired") {
				promptTokenExpired();
				$(".navLoader").css("display", "none");
			} else {
				Swal.fire({
					type: "error",
					title: localeObject[localization]["errorText"],
					text: response.message,
					animation: false,
					customClass: {
						popup: "animated fadeIn",
					},
				});
			}
			// window.location.href = redirectPath + '/login';
		},
		complete: function (data) {
			// console.log(data);
		},
	});

	$(window).on("load", function () {
		setTimeout(function () {
			// $.fn.matchHeight._update();
			$("[data-mh]").matchHeight();
		}, 500);
	});
}

function checkLogin () {
	if (!getCookie("ty_access_token")) {
		window.location.href = redirectPath + "/login";
	}
}

function checkLoginNav () {
	if (!getCookie("ty_access_token")) {
		// $('#navBeforeLogin').css('display', 'flex');
		$(".navBeforeLogin").css("display", "flex");
		// $('#navAfterLogin').css('display', 'none');
		$(".navAfterLogin").css("display", "none");
	} else {
		// $('#navBeforeLogin').css('display', 'none');
		$(".navBeforeLogin").css("display", "none");
        $(".navLoader").css("display", "flex");

        getLatestTestkit();

		var url = apipath + "check-expired";

		$.ajax({
			url: url,
			type: "GET",
			cache: false,
			headers: { Authorization: "Bearer " + getCookie("ty_access_token") },
			contentType: "application/json", // tell jQuery not to set contentType
			success: function (data) {
				log(data);
				$(".navLoader").css("display", "none");
				// $('#navAfterLogin').css('display', 'flex');
                $(".navAfterLogin").css("display", "flex");

                setTimeout(function(){ 
                    if(getCookie("ty_addon")){ // check hv completed 1st test kit
                        $(".register-kit-btn").text(localeObject[localization]["register_addon"]);
                        $(".login-register-kit-btn").text(localeObject[localization]["register_addon"]);
                    }
                }, 500);

				if (localization == "en") {
					$("#username").html("Hello, " + data.full_name);
				} else if (localization == "zh") {
					$("#username").html("你好, " + data.full_name);
				} else if (localization == "ms") {
					$("#username").html("Helo, " + data.full_name);
				}

                if ( window.location.href == baseUrl + "/login" || window.location.href == baseUrl + "/sign-up" )
                    window.location.href = redirectPath;
					// window.location.href = redirectPath + "/";

				if (data.new_message == 0) {
					$(".notification-dots").css("display", "none");
				} else {
					$(".notification-dots").css("display", "flex");
					$(".notification-dots").html(data.new_message);
				}

				if (data.shopping_cart == 0) {
					$(".shopping-dots").css("display", "none");
				} else {
					$(".shopping-dots").css("display", "flex");
					$(".shopping-dots").html(data.shopping_cart);
                }
			},
			error: function (data) {
				var errorTitle = "";
				var errorMsg = "";
				var buttontext = "";

				var response = JSON.parse(data.responseText);

				if (response.message == "token_expired") {
					$(".navLoader").css("display", "none");
					if (localization == "en") {
						errorTitle = "Session Expired";
						errorMsg = "Please Relogin";
						buttontext = "Login";
					} else if (localization == "ms") {
						errorTitle = "Sesi tamat";
						errorMsg = "Sila log masuk sekali lagi";
						buttontext = "Log masuk";
					} else if (localization == "zh") {
						errorTitle = "此环节已逾时";
						errorMsg = "请重新登入";
						buttontext = "登录";
					}
				} else {
					if (localization == "en") {
						errorTitle = "Token is invalid";
						errorMsg = "Please login";
						buttontext = "Login";
					} else if (localization == "ms") {
						errorTitle = "Token tidak sah​";
						errorMsg = "Sila log masuk";
						buttontext = "Log masuk";
					} else if (localization == "zh") {
						errorTitle = "Token无效";
						errorMsg = "请登录";
						buttontext = "登录";
					}
				}

                deleteCookie("ty_access_token");
                deleteCookie("ty_addon");
				// $('#navBeforeLogin').css('display', 'flex');
				$(".navBeforeLogin").css("display", "flex");
				// $('#navAfterLogin').css('display', 'none');
				$(".navAfterLogin").css("display", "none");

				Swal.fire({
					title: errorTitle,
					text: errorMsg,
					type: "error",
					animation: false,
					customClass: {
						popup: "animated fadeIn",
					},
					showCancelButton: false,
					confirmButtonColor: "#FF0000",
					confirmButtonText: buttontext,
					onClose: function () {
						window.location.href = redirectPath + "/login";
					},
					// })
					// .then(function(results) {
					// 	window.location.href = redirectPath + '/login';
				});
			},
			complete: function (data) {
				// console.log(data);
			},
		});
	}
}

if ($("#redirect-countdown").length > 0) {
	var timeLeft = 30;
	var elem = document.getElementById("redirect-countdown");
	var timerId = setInterval(countdown, 1000);

	function countdown () {
		if (timeLeft == -1) {
			clearTimeout(timerId);
			redirectLogin();
		} else {
			elem.innerHTML = timeLeft;
			timeLeft--;
		}
	}

	countdown();
}

function redirectLogin () {
	window.location.href = redirectPath + "/login";
}

//DATE PICKER SIGN UP
$(function () {
	$(".guardian-wrap").hide();
	$("#guardian_flag").hide();

	var unavailableDates = ["2000/10/10"];

	$(".selectDate").datepicker({
        format: "yyyy/mm/dd",
        startDate: "1919/01/01",
        // endDate: '-18y',
        endDate: "-1d",
        keyboardNavigation: false,
        startView: "years",
        onRender: function (date) {
            var dmy = date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate();
            if ($.inArray(dmy, unavailableDates) != -1) {
                return "disabled";
            }
        },
    })
    .on("paste", function (e) {
        $(this).blur();
    })
    .on("keydown", function (e) {
        if (e.which === 13) {
            $(this).blur();
        }
    })
    .on("keyup", function (e) {
        if (e.which === 86) {
            $(this).blur();
        }
    })
    .change(function (e) {
        guardianDiv($(".selectDate").val());
        console.log("changeDate==" + $(".selectDate").val());
    });
});

function guardianDiv (date) {
	var date = new Date(date);
	var currentDate = new Date().toJSON().slice(0, 10);
	var age = ~~((Date.now(currentDate) - date) / 31557600000);
	$("#guardian_flag").hide();
	if (age < 18) {
		console.log("onchange < 18");
		$(".guardian-wrap").show();
		$("#guardian_flag").attr("checked", true);
	} else {
		console.log("onchange > 18");
		$(".guardian-wrap").hide();
		$("#guardian_flag").attr("checked", false);
	}
}

function promptTokenExpired () {
	deleteCookie("ty_access_token");

	$(".navLoader").css("display", "none");

	if (localization == "en") {
		errorTitle = "Session Expired";
		errorMsg = "Please Relogin";
		buttontext = "Login";
	} else if (localization == "ms") {
		errorTitle = "Sesi tamat";
		errorMsg = "Sila log masuk sekali lagi";
		buttontext = "Log masuk";
	} else if (localization == "zh") {
		errorTitle = "此环节已逾时";
		errorMsg = "请重新登入";
		buttontext = "登录";
	}

	Swal.fire({
		title: errorTitle,
		text: errorMsg,
		type: "error",
		animation: false,
		customClass: {
			popup: "animated fadeIn",
		},
		showCancelButton: false,
		confirmButtonColor: "#FF0000",
		confirmButtonText: buttontext,
	}).then(function (results) {
		window.location.href = redirectPath + "/login";
	});
}

//Global function
function getCookie (cname) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(";");
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

function setCookie (cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + exdays * 1 * 60 * 60 * 1000);
	var expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function deleteCookie (name) {
	setCookie(name, "", -1);
}

function log (ex) {
	if (log_debug) console.log(ex);
}

$("#login-options").change(function () {
	var id = $(this).children(":selected").val();
	$("#member-id-error").css("display", "none");
	$("#email-error").css("display", "none");
	$("#password-error").css("display", "none");
	$(".login-password").css("display", "block");

	if (id == "iElken" || id == "ElkenClassic") {
		$(".login-member-id").css("display", "block");
		$(".login-email").css("display", "none");
	} else {
		$(".login-member-id").css("display", "none");
		$(".login-email").css("display", "block");
	}
});

function checkTokenExpired (response) {
	if (response.message == "token_expired") {
		// alert('Token Expired Please Relogin');

        if (localization == "en") {
            errorTitle = "Session Expired";
            errorMsg = "Please Relogin";
        } else if (localization == "ms") {
            errorTitle = "Sesi tamat";
            errorMsg = "Sila log masuk sekali lagi";
        } else if (localization == "zh") {
            errorTitle = "此环节已逾时";
            errorMsg = "请重新登入";
        }

		Swal.fire({
			type: "error",
			title: errorTitle,
			text: errorMsg,
			animation: false,
			customClass: {
				popup: "animated fadeIn",
			},
		});

		window.location.href = redirectPath + "/login";
	}
}
